webpackJsonp([94053359063892],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(338)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var wrapped = __webpack_require__(344)
	
	module.exports = factory
	
	function factory(id, rule) {
	  var parts = id.split(':')
	  var source = parts[0]
	  var ruleId = parts[1]
	  var fn = wrapped(rule)
	
	  /* istanbul ignore if - possibly useful if externalised later. */
	  if (!ruleId) {
	    ruleId = source
	    source = null
	  }
	
	  attacher.displayName = id
	
	  return attacher
	
	  function attacher(raw) {
	    var config = coerce(ruleId, raw)
	    var severity = config[0]
	    var options = config[1]
	    var fatal = severity === 2
	
	    return severity ? transformer : undefined
	
	    function transformer(tree, file, next) {
	      var index = file.messages.length
	
	      fn(tree, file, options, done)
	
	      function done(err) {
	        var messages = file.messages
	        var message
	
	        /* Add the error, if not already properly added. */
	        /* istanbul ignore if - only happens for incorrect plugins */
	        if (err && messages.indexOf(err) === -1) {
	          try {
	            file.fail(err)
	          } catch (err) {}
	        }
	
	        while (index < messages.length) {
	          message = messages[index]
	          message.ruleId = ruleId
	          message.source = source
	          message.fatal = fatal
	
	          index++
	        }
	
	        next()
	      }
	    }
	  }
	}
	
	/* Coerce a value to a severity--options tuple. */
	function coerce(name, value) {
	  var def = 1
	  var result
	  var level
	
	  /* istanbul ignore if - Handled by unified in v6.0.0 */
	  if (typeof value === 'boolean') {
	    result = [value]
	  } else if (value == null) {
	    result = [def]
	  } else if (
	    typeof value === 'object' &&
	    (typeof value[0] === 'number' ||
	      typeof value[0] === 'boolean' ||
	      typeof value[0] === 'string')
	  ) {
	    result = value.concat()
	  } else {
	    result = [1, value]
	  }
	
	  level = result[0]
	
	  if (typeof level === 'boolean') {
	    level = level ? 1 : 0
	  } else if (typeof level === 'string') {
	    if (level === 'off') {
	      level = 0
	    } else if (level === 'on' || level === 'warn') {
	      level = 1
	    } else if (level === 'error') {
	      level = 2
	    } else {
	      level = 1
	      result = [level, result]
	    }
	  }
	
	  if (level < 0 || level > 2) {
	    throw new Error(
	      'Invalid severity `' +
	        level +
	        '` for `' +
	        name +
	        '`, ' +
	        'expected 0, 1, or 2'
	    )
	  }
	
	  result[0] = level
	
	  return result
	}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = generated
	
	/* Detect if a node was available in the original document. */
	function generated(node) {
	  var position = optional(optional(node).position)
	  var start = optional(position.start)
	  var end = optional(position.end)
	
	  return !start.line || !start.column || !end.line || !end.column
	}
	
	/* Return `value` if it’s an object, an empty object
	 * otherwise. */
	function optional(value) {
	  return value && typeof value === 'object' ? value : {}
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = all
	
	var trim = __webpack_require__(13)
	var one = __webpack_require__(87)
	
	/* Transform the children of `parent`. */
	function all(h, parent) {
	  var nodes = parent.children || []
	  var length = nodes.length
	  var values = []
	  var index = -1
	  var result
	  var head
	
	  while (++index < length) {
	    result = one(h, nodes[index], parent)
	
	    if (result) {
	      if (index && nodes[index - 1].type === 'break') {
	        if (result.value) {
	          result.value = trim.left(result.value)
	        }
	
	        head = result.children && result.children[0]
	
	        if (head && head.value) {
	          head.value = trim.left(head.value)
	        }
	      }
	
	      values = values.concat(result)
	    }
	  }
	
	  return values
	}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a whitespace character. */
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(81);
	
	
	module.exports = function u (type, props, value) {
	  if (value == null && (typeof props != 'object' || Array.isArray(props))) {
	    value = props;
	    props = {};
	  }
	
	  return assign({}, props, { type: String(type) },
	                value != null && (Array.isArray(value)
	                                  ? { children: value }
	                                  : { value: String(value) }));
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	var position = exports
	
	position.start = factory('start')
	position.end = factory('end')
	
	/* Factory to get a `type` point in the positional info of a node. */
	function factory(type) {
	  point.displayName = type
	
	  return point
	
	  /* Get a point in `node.position` at a bound `type`. */
	  function point(node) {
	    var point = (node && node.position && node.position[type]) || {}
	
	    return {
	      line: point.line || null,
	      column: point.column || null,
	      offset: isNaN(point.offset) ? null : point.offset
	    }
	  }
	}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = wrap
	
	var u = __webpack_require__(11)
	
	/* Wrap `nodes` with newlines between each entry.
	 * Optionally adds newlines at the start and end. */
	function wrap(nodes, loose) {
	  var result = []
	  var index = -1
	  var length = nodes.length
	
	  if (loose) {
	    result.push(u('text', '\n'))
	  }
	
	  while (++index < length) {
	    if (index) {
	      result.push(u('text', '\n'))
	    }
	
	    result.push(nodes[index])
	  }
	
	  if (loose && nodes.length !== 0) {
	    result.push(u('text', '\n'))
	  }
	
	  return result
	}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is decimal. */
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	
	'use strict';
	
	
	var encodeCache = {};
	
	
	// Create a lookup array where anything but characters in `chars` string
	// and alphanumeric chars is percent-encoded.
	//
	function getEncodeCache(exclude) {
	  var i, ch, cache = encodeCache[exclude];
	  if (cache) { return cache; }
	
	  cache = encodeCache[exclude] = [];
	
	  for (i = 0; i < 128; i++) {
	    ch = String.fromCharCode(i);
	
	    if (/^[0-9a-z]$/i.test(ch)) {
	      // always allow unencoded alphanumeric characters
	      cache.push(ch);
	    } else {
	      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
	    }
	  }
	
	  for (i = 0; i < exclude.length; i++) {
	    cache[exclude.charCodeAt(i)] = exclude[i];
	  }
	
	  return cache;
	}
	
	
	// Encode unsafe characters with percent-encoding, skipping already
	// encoded sequences.
	//
	//  - string       - string to encode
	//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
	//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
	//
	function encode(string, exclude, keepEscaped) {
	  var i, l, code, nextCode, cache,
	      result = '';
	
	  if (typeof exclude !== 'string') {
	    // encode(string, keepEscaped)
	    keepEscaped  = exclude;
	    exclude = encode.defaultChars;
	  }
	
	  if (typeof keepEscaped === 'undefined') {
	    keepEscaped = true;
	  }
	
	  cache = getEncodeCache(exclude);
	
	  for (i = 0, l = string.length; i < l; i++) {
	    code = string.charCodeAt(i);
	
	    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
	      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
	        result += string.slice(i, i + 3);
	        i += 2;
	        continue;
	      }
	    }
	
	    if (code < 128) {
	      result += cache[code];
	      continue;
	    }
	
	    if (code >= 0xD800 && code <= 0xDFFF) {
	      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
	        nextCode = string.charCodeAt(i + 1);
	        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
	          result += encodeURIComponent(string[i] + string[i + 1]);
	          i++;
	          continue;
	        }
	      }
	      result += '%EF%BF%BD';
	      continue;
	    }
	
	    result += encodeURIComponent(string[i]);
	  }
	
	  return result;
	}
	
	encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
	encode.componentChars = "-_.!~*'()";
	
	
	module.exports = encode;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var characterEntities = __webpack_require__(185)
	var legacy = __webpack_require__(78)
	var invalid = __webpack_require__(186)
	var decimal = __webpack_require__(18)
	var hexadecimal = __webpack_require__(77)
	var alphanumerical = __webpack_require__(76)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	/* Default settings. */
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	/* Reference types. */
	var NAMED = 'named'
	var HEXADECIMAL = 'hexadecimal'
	var DECIMAL = 'decimal'
	
	/* Map of bases. */
	var BASE = {}
	
	BASE[HEXADECIMAL] = 16
	BASE[DECIMAL] = 10
	
	/* Map of types to tests. Each type of character reference
	 * accepts different characters. This test is used to
	 * detect whether a reference has ended (as the semicolon
	 * is not strictly needed). */
	var TESTS = {}
	
	TESTS[NAMED] = alphanumerical
	TESTS[DECIMAL] = decimal
	TESTS[HEXADECIMAL] = hexadecimal
	
	/* Warning messages. */
	var NAMED_NOT_TERMINATED = 1
	var NUMERIC_NOT_TERMINATED = 2
	var NAMED_EMPTY = 3
	var NUMERIC_EMPTY = 4
	var NAMED_UNKNOWN = 5
	var NUMERIC_DISALLOWED = 6
	var NUMERIC_PROHIBITED = 7
	
	var MESSAGES = {}
	
	MESSAGES[NAMED_NOT_TERMINATED] =
	  'Named character references must be terminated by a semicolon'
	MESSAGES[NUMERIC_NOT_TERMINATED] =
	  'Numeric character references must be terminated by a semicolon'
	MESSAGES[NAMED_EMPTY] = 'Named character references cannot be empty'
	MESSAGES[NUMERIC_EMPTY] = 'Numeric character references cannot be empty'
	MESSAGES[NAMED_UNKNOWN] = 'Named character references must be known'
	MESSAGES[NUMERIC_DISALLOWED] =
	  'Numeric character references cannot be disallowed'
	MESSAGES[NUMERIC_PROHIBITED] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	/* Wrap to ensure clean parameters are given to `parse`. */
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	/* Parse entities. */
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  /* Cache the current point. */
	  prev = now()
	
	  /* Wrap `handleWarning`. */
	  warning = handleWarning ? parseError : noop
	
	  /* Ensure the algorithm walks over the first character
	   * and the end (inclusive). */
	  index--
	  length++
	
	  while (++index < length) {
	    /* If the previous character was a newline. */
	    if (character === '\n') {
	      column = indent[lines] || 1
	    }
	
	    character = at(index)
	
	    /* Handle anything other than an ampersand,
	     * including newlines and EOF. */
	    if (character !== '&') {
	      if (character === '\n') {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character) {
	        queue += character
	        column++
	      } else {
	        flush()
	      }
	    } else {
	      following = at(index + 1)
	
	      /* The behaviour depends on the identity of the next
	       * character. */
	      if (
	        following === '\t' /* Tab */ ||
	        following === '\n' /* Newline */ ||
	        following === '\f' /* Form feed */ ||
	        following === ' ' /* Space */ ||
	        following === '<' /* Less-than */ ||
	        following === '&' /* Ampersand */ ||
	        following === '' ||
	        (additional && following === additional)
	      ) {
	        /* Not a character reference. No characters
	         * are consumed, and nothing is returned.
	         * This is not an error, either. */
	        queue += character
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      /* Numerical entity. */
	      if (following !== '#') {
	        type = NAMED
	      } else {
	        end = ++begin
	
	        /* The behaviour further depends on the
	         * character after the U+0023 NUMBER SIGN. */
	        following = at(end)
	
	        if (following === 'x' || following === 'X') {
	          /* ASCII hex digits. */
	          type = HEXADECIMAL
	          end = ++begin
	        } else {
	          /* ASCII digits. */
	          type = DECIMAL
	        }
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = TESTS[type]
	      end--
	
	      while (++end < length) {
	        following = at(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += following
	
	        /* Check if we can match a legacy named
	         * reference.  If so, we cache that as the
	         * last viable named reference.  This
	         * ensures we do not need to walk backwards
	         * later. */
	        if (type === NAMED && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = at(end) === ';'
	
	      if (terminated) {
	        end++
	
	        if (type === NAMED && own.call(characterEntities, characters)) {
	          entityCharacters = characters
	          entity = characterEntities[characters]
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        /* Empty. */
	      } else if (!characters) {
	        /* An empty (possible) entity is valid, unless
	         * its numeric (thus an ampersand followed by
	         * an octothorp). */
	        if (type !== NAMED) {
	          warning(NUMERIC_EMPTY, diff)
	        }
	      } else if (type === NAMED) {
	        /* An ampersand followed by anything
	         * unknown, and not terminated, is invalid. */
	        if (terminated && !entity) {
	          warning(NAMED_UNKNOWN, 1)
	        } else {
	          /* If theres something after an entity
	           * name which is not known, cap the
	           * reference. */
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          /* If the reference is not terminated,
	           * warn. */
	          if (!terminated) {
	            reason = entityCharacters ? NAMED_NOT_TERMINATED : NAMED_EMPTY
	
	            if (!settings.attribute) {
	              warning(reason, diff)
	            } else {
	              following = at(end)
	
	              if (following === '=') {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          /* All non-terminated numeric entities are
	           * not rendered, and trigger a warning. */
	          warning(NUMERIC_NOT_TERMINATED, diff)
	        }
	
	        /* When terminated and number, parse as
	         * either hexadecimal or decimal. */
	        reference = parseInt(characters, BASE[type])
	
	        /* Trigger a warning when the parsed number
	         * is prohibited, and replace with
	         * replacement character. */
	        if (prohibited(reference)) {
	          warning(NUMERIC_PROHIBITED, diff)
	          reference = '\uFFFD'
	        } else if (reference in invalid) {
	          /* Trigger a warning when the parsed number
	           * is disallowed, and replace by an
	           * alternative. */
	          warning(NUMERIC_DISALLOWED, diff)
	          reference = invalid[reference]
	        } else {
	          /* Parse the number. */
	          output = ''
	
	          /* Trigger a warning when the parsed
	           * number should not be used. */
	          if (disallowed(reference)) {
	            warning(NUMERIC_DISALLOWED, diff)
	          }
	
	          /* Stringify the number. */
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      /* If we could not find a reference, queue the
	       * checked characters (as normal characters),
	       * and move the pointer to their end. This is
	       * possible because we can be certain neither
	       * newlines nor ampersands are included. */
	      if (!reference) {
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      } else {
	        /* Found it! First eat the queued
	         * characters as normal text, then eat
	         * an entity. */
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      }
	    }
	  }
	
	  /* Return the reduced nodes, and any possible warnings. */
	  return result.join('')
	
	  /* Get current position. */
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  /* “Throw” a parse-error: a warning. */
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, MESSAGES[code], position, code)
	  }
	
	  /* Get character at position. */
	  function at(position) {
	    return value.charAt(position)
	  }
	
	  /* Flush `queue` (normal text). Macro invoked before
	   * each entity and at the end of `value`.
	   * Does nothing when `queue` is empty. */
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	/* Check if `character` is outside the permissible unicode range. */
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	/* Check if `character` is disallowed. */
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true
	}


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whiteSpace = __webpack_require__(73);
	
	exports.before = siblings(-1);
	exports.after = siblings(1);
	
	/* Factory to check siblings in a direction. */
	function siblings(increment) {
	  return sibling;
	
	  /* Find applicable siblings in a direction.   */
	  function sibling(parent, index, includeWhiteSpace) {
	    var siblings = parent && parent.children;
	    var next;
	
	    index += increment;
	    next = siblings && siblings[index];
	
	    if (!includeWhiteSpace) {
	      while (next && whiteSpace(next)) {
	        index += increment;
	        next = siblings[index];
	      }
	    }
	
	    return next;
	  }
	}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = toString;
	
	/* Get the text content of a node.  If the node itself
	 * does not expose plain-text fields, `toString` will
	 * recursivly try its children. */
	function toString(node) {
	  return valueOf(node) ||
	    (node.children && node.children.map(toString).join('')) ||
	    '';
	}
	
	/* Get the value of `node`.  Checks, `value`,
	 * `alt`, and `title`, in that order. */
	function valueOf(node) {
	  if (!node) {
	    return '';
	  }
	  return node.value ? node.value : (node.alt ? node.alt : node.title) || '';
	}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var irregularPlurals = __webpack_require__(179);

	module.exports = function (word, plural, count) {
		if (typeof plural === 'number') {
			count = plural;
		}

		if (irregularPlurals.has(word.toLowerCase())) {
			plural = irregularPlurals.get(word.toLowerCase());

			var firstLetter = word.charAt(0);
			var isFirstLetterUpperCase = firstLetter === firstLetter.toUpperCase();
			if (isFirstLetterUpperCase) {
				plural = firstLetter.toUpperCase() + plural.slice(1);
			}

			var isWholeWordUpperCase = word === word.toUpperCase();
			if (isWholeWordUpperCase) {
				plural = plural.toUpperCase();
			}
		} else if (typeof plural !== 'string') {
			plural = (word.replace(/(?:s|x|z|ch|sh)$/i, '$&e').replace(/([^aeiou])y$/i, '$1ie') + 's').replace(/i?e?s$/i, function (m) {
				var isTailLowerCase = word.slice(-1) === word.slice(-1).toLowerCase();
				return isTailLowerCase ? m.toLowerCase() : m.toUpperCase();
			});
		}

		return Math.abs(count) === 1 ? word : plural;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:util:get-indentation
	 * @fileoverview Get indentation.
	 */
	
	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:util:normalize
	 * @fileoverview Normalize an identifier.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var collapseWhiteSpace = __webpack_require__(59);
	
	/* Expose. */
	module.exports = normalize;
	
	/**
	 * Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing.
	 *
	 * @example
	 *   normalizeIdentifier('FOO\t bar'); // 'foo bar'
	 *
	 * @param {string} value - Content to normalize.
	 * @return {string} - Normalized content.
	 */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:enclose-title
	 * @fileoverview Quote a `title` the best way possible.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = enclose;
	
	/**
	 * There is currently no way to support nested delimiters
	 * across Markdown.pl, CommonMark, and GitHub (RedCarpet).
	 * The following code supports Markdown.pl and GitHub.
	 * CommonMark is not supported when mixing double- and
	 * single quotes inside a title.
	 *
	 * @see https://github.com/vmg/redcarpet/issues/473
	 * @see https://github.com/jgm/CommonMark/issues/308
	 *
	 * @example
	 *   encloseTitle('foo') // '"foo"'
	 *   encloseTitle('foo \'bar\' baz') // '"foo \'bar\' baz"'
	 *   encloseTitle('foo "bar" baz') // '\'foo "bar" baz\''
	 *   encloseTitle('foo "bar" \'baz\'') // '"foo "bar" \'baz\'"'
	 *
	 * @param {string} title - Content.
	 * @return {string} - Properly enclosed title.
	 */
	function enclose(title) {
	  var delimiter = title.indexOf('"') === -1 ? '"' : '\'';
	  return delimiter + title + delimiter;
	}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:enclose-uri
	 * @fileoverview Wrap `url` in angle brackets when needed.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var count = __webpack_require__(57);
	
	/* Expose. */
	module.exports = enclose;
	
	/* Constants. */
	var re = /\s/;
	
	/**
	 * Wrap `url` in angle brackets when needed, or when
	 * forced.
	 *
	 * In links, images, and definitions, the URL part needs
	 * to be enclosed when it:
	 *
	 * - has a length of `0`;
	 * - contains white-space;
	 * - has more or less opening than closing parentheses.
	 *
	 * @example
	 *   encloseURI('foo bar') // '<foo bar>'
	 *   encloseURI('foo(bar(baz)') // '<foo(bar(baz)>'
	 *   encloseURI('') // '<>'
	 *   encloseURI('example.com') // 'example.com'
	 *   encloseURI('example.com', true) // '<example.com>'
	 *
	 * @param {string} uri - URI to enclose.
	 * @param {boolean?} [always] - Force enclosing.
	 * @return {boolean} - Properly enclosed `uri`.
	 */
	function enclose(uri, always) {
	  if (always || uri.length === 0 || re.test(uri) || count(uri, '(') !== count(uri, ')')) {
	    return '<' + uri + '>';
	  }
	
	  return uri;
	}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var entities = __webpack_require__(184)
	var legacy = __webpack_require__(78)
	var hexadecimal = __webpack_require__(77)
	var alphanumerical = __webpack_require__(76)
	var dangerous = __webpack_require__(191)
	
	/* Expose. */
	module.exports = encode
	encode.escape = escape
	
	var own = {}.hasOwnProperty
	
	/* List of enforced escapes. */
	var escapes = ['"', "'", '<', '>', '&', '`']
	
	/* Map of characters to names. */
	var characters = construct()
	
	/* Default escapes. */
	var defaultEscapes = toExpression(escapes)
	
	/* Surrogate pairs. */
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g
	
	/* Non-ASCII characters. */
	// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
	var bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
	
	/* Encode special characters in `value`. */
	function encode(value, options) {
	  var settings = options || {}
	  var subset = settings.subset
	  var set = subset ? toExpression(subset) : defaultEscapes
	  var escapeOnly = settings.escapeOnly
	  var omit = settings.omitOptionalSemicolons
	
	  value = value.replace(set, function(char, pos, val) {
	    return one(char, val.charAt(pos + 1), settings)
	  })
	
	  if (subset || escapeOnly) {
	    return value
	  }
	
	  return value
	    .replace(surrogatePair, replaceSurrogatePair)
	    .replace(bmp, replaceBmp)
	
	  function replaceSurrogatePair(pair, pos, val) {
	    return toHexReference(
	      (pair.charCodeAt(0) - 0xd800) * 0x400 +
	        pair.charCodeAt(1) -
	        0xdc00 +
	        0x10000,
	      val.charAt(pos + 2),
	      omit
	    )
	  }
	
	  function replaceBmp(char, pos, val) {
	    return one(char, val.charAt(pos + 1), settings)
	  }
	}
	
	/* Shortcut to escape special characters in HTML. */
	function escape(value) {
	  return encode(value, {
	    escapeOnly: true,
	    useNamedReferences: true
	  })
	}
	
	/* Encode `char` according to `options`. */
	function one(char, next, options) {
	  var shortest = options.useShortestReferences
	  var omit = options.omitOptionalSemicolons
	  var named
	  var numeric
	
	  if ((shortest || options.useNamedReferences) && own.call(characters, char)) {
	    named = toNamed(characters[char], next, omit, options.attribute)
	  }
	
	  if (shortest || !named) {
	    numeric = toHexReference(char.charCodeAt(0), next, omit)
	  }
	
	  if (named && (!shortest || named.length < numeric.length)) {
	    return named
	  }
	
	  return numeric
	}
	
	/* Transform `code` into an entity. */
	function toNamed(name, next, omit, attribute) {
	  var value = '&' + name
	
	  if (
	    omit &&
	    own.call(legacy, name) &&
	    dangerous.indexOf(name) === -1 &&
	    (!attribute || (next && next !== '=' && !alphanumerical(next)))
	  ) {
	    return value
	  }
	
	  return value + ';'
	}
	
	/* Transform `code` into a hexadecimal character reference. */
	function toHexReference(code, next, omit) {
	  var value = '&#x' + code.toString(16).toUpperCase()
	  return omit && next && !hexadecimal(next) ? value : value + ';'
	}
	
	/* Create an expression for `characters`. */
	function toExpression(characters) {
	  return new RegExp('[' + characters.join('') + ']', 'g')
	}
	
	/* Construct the map. */
	function construct() {
	  var chars = {}
	  var name
	
	  for (name in entities) {
	    chars[entities[name]] = name
	  }
	
	  return chars
	}


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	/* Remove final newline characters from `value`. */
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    /* Empty */
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = factory
	
	/* Factory. */
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	/* Factory to get the line and column-based `position` for
	 * `offset` in the bound indices. */
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  /* Get the line and column-based `position` for
	   * `offset` in the bound indices. */
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	/* Factory to get the `offset` for a line and column-based
	 * `position` in the bound indices. */
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  /* Get the `offset` for a line and column-based
	   * `position` in the bound indices. */
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	/* Get indices of line-breaks in `value`. */
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = ccount
	
	function ccount(value, character) {
	  var count = 0
	  var index
	
	  value = String(value)
	
	  if (typeof character !== 'string' || character.length !== 1) {
	    throw new Error('Expected character')
	  }
	
	  index = value.indexOf(character)
	
	  while (index !== -1) {
	    count++
	    index = value.indexOf(character, index + 1)
	  }
	
	  return count
	}


/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = isElement
	
	/* Check if, whether `tagNames` is given, a node is an element
	 * or an element matching `tagNames`. */
	function isElement(node, tagNames) {
	  var name
	
	  if (
	    !(
	      tagNames === null ||
	      tagNames === undefined ||
	      typeof tagNames === 'string' ||
	      (typeof tagNames === 'object' && tagNames.length !== 0)
	    )
	  ) {
	    throw new Error(
	      'Expected `string` or `Array.<string>` for `tagNames`, not `' +
	        tagNames +
	        '`'
	    )
	  }
	
	  if (
	    !node ||
	    typeof node !== 'object' ||
	    node.type !== 'element' ||
	    typeof node.tagName !== 'string'
	  ) {
	    return false
	  }
	
	  if (tagNames === null || tagNames === undefined) {
	    return true
	  }
	
	  name = node.tagName
	
	  if (typeof tagNames === 'string') {
	    return name === tagNames
	  }
	
	  return tagNames.indexOf(name) !== -1
	}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var one = __webpack_require__(71);
	
	module.exports = all;
	
	/* Stringify all children of `parent`. */
	function all(ctx, parent) {
	  var children = parent && parent.children;
	  var length = children && children.length;
	  var index = -1;
	  var results = [];
	
	  while (++index < length) {
	    results[index] = one(ctx, children[index], index, parent);
	  }
	
	  return results.join('');
	}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(26);
	var element = __webpack_require__(66);
	var whiteSpaceLeft = __webpack_require__(70);
	var after = __webpack_require__(35).after;
	var omission = __webpack_require__(69);
	
	module.exports = omission({
	  html: html,
	  head: headOrColgroupOrCaption,
	  body: body,
	  p: p,
	  li: li,
	  dt: dt,
	  dd: dd,
	  rt: rubyElement,
	  rp: rubyElement,
	  optgroup: optgroup,
	  option: option,
	  menuitem: menuitem,
	  colgroup: headOrColgroupOrCaption,
	  caption: headOrColgroupOrCaption,
	  thead: thead,
	  tbody: tbody,
	  tfoot: tfoot,
	  tr: tr,
	  td: cells,
	  th: cells
	});
	
	/* Macro for `</head>`, `</colgroup>`, and `</caption>`. */
	function headOrColgroupOrCaption(node, index, parent) {
	  var next = after(parent, index, true);
	  return !next || (!is('comment', next) && !whiteSpaceLeft(next));
	}
	
	/* Whether to omit `</html>`. */
	function html(node, index, parent) {
	  var next = after(parent, index);
	  return !next || !is('comment', next);
	}
	
	/* Whether to omit `</body>`. */
	function body(node, index, parent) {
	  var next = after(parent, index);
	  return !next || !is('comment', next);
	}
	
	/* Whether to omit `</p>`. */
	function p(node, index, parent) {
	  var next = after(parent, index);
	
	  if (next) {
	    return element(next, [
	      'address', 'article', 'aside', 'blockquote', 'details',
	      'div', 'dl', 'fieldset', 'figcaption', 'figure', 'footer',
	      'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header',
	      'hgroup', 'hr', 'main', 'menu', 'nav', 'ol', 'p', 'pre',
	      'section', 'table', 'ul'
	    ]);
	  }
	
	  return !parent || !element(parent, [
	    'a', 'audio', 'del', 'ins', 'map', 'noscript', 'video'
	  ]);
	}
	
	/* Whether to omit `</li>`. */
	function li(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'li');
	}
	
	/* Whether to omit `</dt>`. */
	function dt(node, index, parent) {
	  var next = after(parent, index);
	  return next && element(next, ['dt', 'dd']);
	}
	
	/* Whether to omit `</dd>`. */
	function dd(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['dt', 'dd']);
	}
	
	/* Whether to omit `</rt>` or `</rp>`. */
	function rubyElement(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['rp', 'rt']);
	}
	
	/* Whether to omit `</optgroup>`. */
	function optgroup(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'optgroup');
	}
	
	/* Whether to omit `</option>`. */
	function option(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['option', 'optgroup']);
	}
	
	/* Whether to omit `</menuitem>`. */
	function menuitem(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['menuitem', 'hr', 'menu']);
	}
	
	/* Whether to omit `</thead>`. */
	function thead(node, index, parent) {
	  var next = after(parent, index);
	  return next && element(next, ['tbody', 'tfoot']);
	}
	
	/* Whether to omit `</tbody>`. */
	function tbody(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['tbody', 'tfoot']);
	}
	
	/* Whether to omit `</tfoot>`. */
	function tfoot(node, index, parent) {
	  return !after(parent, index);
	}
	
	/* Whether to omit `</tr>`. */
	function tr(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'tr');
	}
	
	/* Whether to omit `</td>` or `</th>`. */
	function cells(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['td', 'th']);
	}


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = omission;
	
	var own = {}.hasOwnProperty;
	
	/* Factory to check if a given node can have a tag omitted. */
	function omission(handlers) {
	  return omit;
	
	  /* Check if a given node can have a tag omitted.   */
	  function omit(node, index, parent) {
	    var name = node.tagName;
	    var fn = own.call(handlers, name) ? handlers[name] : false;
	
	    return fn ? fn(node, index, parent) : false;
	  }
	}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(26);
	var whiteSpace = __webpack_require__(73);
	
	module.exports = whiteSpaceLeft;
	
	/* Check if `node` starts with white-space. */
	function whiteSpaceLeft(node) {
	  return is('text', node) && whiteSpace(node.value.charAt(0));
	}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = one;
	
	var own = {}.hasOwnProperty;
	
	var handlers = {};
	
	handlers.root = __webpack_require__(67);
	handlers.text = __webpack_require__(72);
	handlers.element = __webpack_require__(170);
	handlers.doctype = __webpack_require__(169);
	handlers.comment = __webpack_require__(168);
	handlers.raw = __webpack_require__(176);
	
	/* Stringify `node`. */
	function one(ctx, node, index, parent) {
	  var type = node && node.type;
	
	  if (!type) {
	    throw new Error('Expected node, not `' + node + '`');
	  }
	
	  if (!own.call(handlers, type)) {
	    throw new Error('Cannot compile unknown node `' + type + '`');
	  }
	
	  return handlers[type](ctx, node, index, parent);
	}


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(8);
	var entities = __webpack_require__(42);
	
	module.exports = text;
	
	/* Stringify `text`. */
	function text(ctx, node, index, parent) {
	  var value = node.value;
	
	  return isLiteral(parent) ? value : entities(value, xtend(ctx.entities, {
	    subset: ['<', '&']
	  }));
	}
	
	/* Check if content of `node` should be escaped. */
	function isLiteral(node) {
	  return node && (node.tagName === 'script' || node.tagName === 'style');
	}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = interElementWhiteSpace
	
	/* HTML white-space expression.
	 * See <https://html.spec.whatwg.org/#space-character>. */
	var re = /[ \t\n\f\r]/g
	
	/* Check if `node` is a inter-element white-space. */
	function interElementWhiteSpace(node) {
	  var value
	
	  if (node && typeof node === 'object' && node.type === 'text') {
	    value = node.value || ''
	  } else if (typeof node === 'string') {
	    value = node
	  } else {
	    return false
	  }
	
	  return value.replace(re, '') === ''
	}


/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphabetical. */
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(75)
	var decimal = __webpack_require__(18)
	
	module.exports = alphanumerical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphanumerical. */
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is hexadecimal. */
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = longestStreak;
	
	/* Get the count of the longest repeating streak of
	 * `character` in `value`. */
	function longestStreak(value, character) {
	  var count = 0;
	  var maximum = 0;
	  var expected;
	  var index;
	
	  if (typeof character !== 'string' || character.length !== 1) {
	    throw new Error('Expected character');
	  }
	
	  value = String(value);
	  index = value.indexOf(character);
	  expected = index;
	
	  while (index !== -1) {
	    count++;
	
	    if (index === expected) {
	      if (count > maximum) {
	        maximum = count;
	      }
	    } else {
	      count = 1;
	    }
	
	    expected = index + 1;
	    index = value.indexOf(character, expected);
	  }
	
	  return maximum;
	}


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	/* Get markdown escapes. */
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = failsafe
	
	var u = __webpack_require__(11)
	var all = __webpack_require__(7)
	
	/* Return the content of a reference without definition
	 * as markdown. */
	function failsafe(h, node, definition) {
	  var subtype = node.referenceType
	
	  if (subtype !== 'collapsed' && subtype !== 'full' && !definition) {
	    if (node.type === 'imageReference') {
	      return u('text', '![' + node.alt + ']')
	    }
	
	    return [u('text', '[')].concat(all(h, node), u('text', ']'))
	  }
	}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = footnoteReference
	
	var u = __webpack_require__(11)
	
	/* Transform a reference to a footnote. */
	function footnoteReference(h, node) {
	  var identifier = node.identifier
	
	  return h(node.position, 'sup', {id: 'fnref-' + identifier}, [
	    h(node, 'a', {href: '#fn-' + identifier, className: ['footnote-ref']}, [
	      u('text', identifier)
	    ])
	  ])
	}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = list
	
	var wrap = __webpack_require__(17)
	var all = __webpack_require__(7)
	
	/* Transform a list. */
	function list(h, node) {
	  var props = {}
	  var name = node.ordered ? 'ol' : 'ul'
	
	  if (typeof node.start === 'number' && node.start !== 1) {
	    props.start = node.start
	  }
	
	  return h(node, name, props, wrap(all(h, node), true))
	}


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = thematicBreak
	
	/* Transform a thematic break / horizontal rule. */
	function thematicBreak(h, node) {
	  return h(node, 'hr')
	}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = one
	
	var u = __webpack_require__(11)
	var all = __webpack_require__(7)
	
	var own = {}.hasOwnProperty
	
	/* Transform an unknown node. */
	function unknown(h, node) {
	  if (text(node)) {
	    return h.augment(node, u('text', node.value))
	  }
	
	  return h(node, 'div', all(h, node))
	}
	
	/* Visit a node. */
	function one(h, node, parent) {
	  var type = node && node.type
	  var fn = own.call(h.handlers, type) ? h.handlers[type] : null
	
	  /* Fail on non-nodes. */
	  if (!type) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	
	  return (typeof fn === 'function' ? fn : unknown)(h, node, parent)
	}
	
	/* Check if the node should be renderered a text node. */
	function text(node) {
	  var data = node.data || {}
	
	  if (
	    own.call(data, 'hName') ||
	    own.call(data, 'hProperties') ||
	    own.call(data, 'hChildren')
	  ) {
	    return false
	  }
	
	  return 'value' in node
	}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:defaults
	 * @fileoverview Default options for `parse`.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = {
	  position: true,
	  gfm: true,
	  yaml: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(190),
	  breaks: false
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:link
	 * @fileoverview Locate a link.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:tag
	 * @fileoverview Locate a tag.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:util:get-indentation
	 * @fileoverview Get indentation.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/**
	 * Gets indentation information for a line.
	 *
	 * @param {string} value - Indented line.
	 * @return {Object} - Indetation information.
	 */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:util:html
	 * @fileoverview HTML regexes.
	 */
	
	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:defaults
	 * @fileoverview Default options for `stringify`.
	 */
	
	'use strict';
	
	module.exports = {
	  gfm: true,
	  commonmark: false,
	  pedantic: false,
	  entities: 'false',
	  setext: false,
	  closeAtx: false,
	  looseTable: false,
	  spacedTable: true,
	  paddedTable: true,
	  incrementListMarker: true,
	  fences: false,
	  fence: '`',
	  bullet: '-',
	  listItemIndent: 'tab',
	  rule: '*',
	  ruleSpaces: true,
	  ruleRepetition: 3,
	  strong: '*',
	  emphasis: '_'
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:entity-prefix-length
	 * @fileoverview Encode based on the identifier.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var decode = __webpack_require__(25);
	
	/* Expose. */
	module.exports = length;
	
	/**
	 * Returns the length of HTML entity that is a prefix of
	 * the given string (excluding the ampersand), 0 if it
	 * does not start with an entity.
	 *
	 * @example
	 *   entityPrefixLength('&copycat') // 4
	 *   entityPrefixLength('&foo &amp &bar') // 0
	 *
	 * @param {string} value - Input string.
	 * @return {number} - Length of an entity.
	 */
	function length(value) {
	  var prefix;
	
	  /* istanbul ignore if - Currently also tested for at
	   * implemention, but we keep it here because that’s
	   * proper. */
	  if (value.charAt(0) !== '&') {
	    return 0;
	  }
	
	  prefix = value.split('&', 2).join('&');
	
	  return prefix.length - decode(prefix).length;
	}


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:label
	 * @fileoverview Stringify a reference label.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = label;
	
	/**
	 * Stringify a reference label.
	 *
	 * Because link references are easily, mistakingly,
	 * created (for example, `[foo]`), reference nodes have
	 * an extra property depicting how it looked in the
	 * original document, so stringification can cause minimal
	 * changes.
	 *
	 * @param {Object} node - `linkReference` or
	 *   `imageReference` node.
	 * @return {string} - Markdown label reference.
	 */
	function label(node) {
	  var type = node.referenceType;
	  var value = type === 'full' ? node.identifier : '';
	
	  return type === 'shortcut' ? value : '[' + value + ']';
	}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:pad
	 * @fileoverview Pad a given value.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = pad;
	
	/* Constants. */
	var INDENT = 4;
	
	/**
	 * Pad `value` with `level * INDENT` spaces.  Respects
	 * lines. Ignores empty lines.
	 *
	 * @example
	 *   pad('foo', 1) // '    foo'
	 *
	 * @param {string} value - Content.
	 * @param {number} level - Indentation level.
	 * @return {string} - Padded `value`.
	 */
	function pad(value, level) {
	  var index;
	  var padding;
	
	  value = value.split('\n');
	
	  index = value.length;
	  padding = repeat(' ', level * INDENT);
	
	  while (index--) {
	    if (value[index].length !== 0) {
	      value[index] = padding + value[index];
	    }
	  }
	
	  return value.join('\n');
	}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:returner
	 * @fileoverview Return the given value.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = returner;
	
	/**
	 * @param {*} value - Anything.
	 * @return {*} - Given `value`.
	 */
	function returner(value) {
	  return value;
	}


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	/* Construct a state `toggler`: a function which inverses
	 * `property` in context based on its current value.
	 * The by `toggler` returned function restores that value. */
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(8)
	var inherits = __webpack_require__(178)
	
	module.exports = unherit
	
	/* Create a custom constructor which can be modified
	 * without affecting the original class. */
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  /* Clone values. */
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  /* Constructor accepting a single argument,
	   * which itself is an `arguments` object. */
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  /* Constructor accepting variadic arguments. */
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _remark = __webpack_require__(327);
	
	var _remark2 = _interopRequireDefault(_remark);
	
	var _remarkPresetLintRecommended = __webpack_require__(288);
	
	var _remarkPresetLintRecommended2 = _interopRequireDefault(_remarkPresetLintRecommended);
	
	var _remarkHtml = __webpack_require__(206);
	
	var _remarkHtml2 = _interopRequireDefault(_remarkHtml);
	
	__webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content;
	
	  var html = (0, _remark2.default)().use(_remarkPresetLintRecommended2.default).use(_remarkHtml2.default).processSync(content).toString();
	
	  return _react2.default.createElement('div', { className: 'html-content', dangerouslySetInnerHTML: { __html: html } });
	};
	
	HTMLContent.propTypes = {
	  content: _propTypes2.default.string
	};
	
	exports.default = HTMLContent;
	module.exports = exports['default'];

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = iterate
	
	var own = {}.hasOwnProperty
	
	function iterate(values, callback, context) {
	  var index = -1
	  var result
	
	  if (!values) {
	    throw new Error('Iterate requires that |this| not be ' + values)
	  }
	
	  if (!own.call(values, 'length')) {
	    throw new Error('Iterate requires that |this| has a `length`')
	  }
	
	  if (typeof callback !== 'function') {
	    throw new Error('`callback` must be a function')
	  }
	
	  /* The length might change, so we do not cache it. */
	  while (++index < values.length) {
	    /* Skip missing values. */
	    if (!(index in values)) {
	      continue
	    }
	
	    result = callback.call(context, values[index], index, values)
	
	    /* If `callback` returns a `number`, move `index` over to
	     * `number`. */
	    if (typeof result === 'number') {
	      /* Make sure that negative numbers do not break the loop. */
	      if (result < 0) {
	        index = 0
	      }
	
	      index = result - 1
	    }
	  }
	}


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AmazonLink = function (_Component) {
	  _inherits(AmazonLink, _Component);
	
	  function AmazonLink() {
	    _classCallCheck(this, AmazonLink);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AmazonLink.prototype.render = function render() {
	    var _props = this.props,
	        link = _props.link,
	        isInsideTable = _props.isInsideTable,
	        onClick = _props.onClick,
	        title = _props.title,
	        className = _props.className,
	        isBlack = _props.isBlack,
	        productName = _props.productName;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'amazon-link__wrapper' },
	      _react2.default.createElement(
	        'a',
	        {
	          className: (0, _classnames2.default)('amazon-link', className, {
	            'amazon-link--is-table': isInsideTable,
	            'amazon-link--is-black': isBlack
	          }),
	          target: '_blank',
	          onClick: onClick ? onClick : function () {},
	          rel: 'nofollow noopener',
	          href: link,
	          'data-vars-product-name': productName
	        },
	        title
	      )
	    );
	  };
	
	  return AmazonLink;
	}(_react.Component);
	
	AmazonLink.propTypes = {
	  isInsideTable: _propTypes2.default.bool,
	  isBlack: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  link: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  productName: _propTypes2.default.string.isRequired
	};
	
	exports.default = AmazonLink;
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUTHORS = {
	  'Liam Brooks': {
	    image_url: '/img/authors/Liam-Brooks-1.jpg',
	    about: 'Automotive Expert',
	    fb_page: 'https://www.facebook.com/liam.brooks.older'
	  },
	  'Jim Comey': {
	    image_url: '/img/authors/Jim-Comey-2.jpg',
	    about: 'Automotive Expert',
	    fb_page: 'https://www.facebook.com/liam.brooks.older'
	  }
	};
	
	var Author = function (_Component) {
	  _inherits(Author, _Component);
	
	  function Author() {
	    _classCallCheck(this, Author);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Author.prototype.render = function render() {
	    var name = this.props.name ? this.props.name : "Liam Brooks";
	    var created = this.props.created;
	    var updated = this.props.updated;
	    var updatedDate = new Date(updated);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'author' },
	      _react2.default.createElement(
	        'div',
	        { className: 'author__wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'author__image-wrapper' },
	          _react2.default.createElement('amp-img', {
	            'class': 'author__image',
	            src: AUTHORS[name].image_url,
	            width: '65',
	            height: '65',
	            layout: 'flex-item',
	            alt: name
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'author__content' },
	          _react2.default.createElement(
	            'address',
	            null,
	            'by ',
	            _react2.default.createElement(
	              'a',
	              { className: 'author__name', href: AUTHORS[name].fb_page, rel: 'author' },
	              name
	            ),
	            '  \xB7 ',
	            _react2.default.createElement(
	              'span',
	              { className: 'author__about' },
	              AUTHORS[name].about
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'author__created' },
	            'Published ',
	            _react2.default.createElement(
	              'time',
	              { pubdate: true, dateTime: created, title: created },
	              created
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'author__updated ga-test' },
	            'Updated ',
	            _react2.default.createElement(
	              'time',
	              { pubdate: true, dateTime: updated, title: updated },
	              updatedDate.toLocaleString('en-US', { month: "long" }),
	              ' ',
	              updatedDate.getFullYear()
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Author;
	}(_react.Component);
	
	Author.propTypes = {
	  name: _propTypes2.default.string,
	  created: _propTypes2.default.string,
	  updated: _propTypes2.default.string
	};
	
	exports.default = Author;
	module.exports = exports['default'];

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _htmlContent = __webpack_require__(103);
	
	var _htmlContent2 = _interopRequireDefault(_htmlContent);
	
	var _utils = __webpack_require__(14);
	
	__webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReviewContent = function ReviewContent(_ref) {
	  var content = _ref.content,
	      title = _ref.title,
	      isWide = _ref.isWide,
	      headingLevel = _ref.headingLevel;
	
	  var className = (0, _classnames2.default)("review-content", {
	    "review-content--is-wide": isWide
	  });
	  var Heading = headingLevel || 'h2';
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'review-content__wrapper' },
	      title ? _react2.default.createElement(
	        Heading,
	        { id: (0, _utils.titleToId)(title) },
	        title
	      ) : null,
	      content ? _react2.default.createElement(_htmlContent2.default, { content: content }) : null
	    )
	  );
	};
	
	ReviewContent.propTypes = {
	  content: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  isWide: _propTypes2.default.bool,
	  headingLevel: _propTypes2.default.string
	};
	
	exports.default = ReviewContent;
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(204);
	
	var _config = __webpack_require__(56);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialShare = function SocialShare(_ref) {
	  var image = _ref.image,
	      title = _ref.title,
	      currentPath = _ref.currentPath;
	  return _react2.default.createElement(
	    'div',
	    { className: 'social-share__container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'social-share__wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'social-share__title' },
	        'You can save or share this article:'
	      ),
	      _react2.default.createElement('amp-social-share', { 'class': 'social-share__item', 'data-param-app_id': '295182704556303', type: 'facebook' }),
	      _react2.default.createElement('amp-social-share', { 'class': 'social-share__item', type: 'twitter' }),
	      _react2.default.createElement('amp-social-share', { 'class': 'social-share__item', type: 'pinterest', 'data-param-media': _config2.default.siteUrl + image, 'data-param-url': _config2.default.siteUrl + currentPath, 'data-param-description': title })
	    )
	  );
	};
	
	exports.default = SocialShare;
	module.exports = exports['default'];

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {
	/**
	 * slice() reference.
	 */
	
	var slice = Array.prototype.slice;
	
	/**
	 * Expose `co`.
	 */
	
	module.exports = co;
	
	/**
	 * Wrap the given generator `fn` and
	 * return a thunk.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 * @api public
	 */
	
	function co(fn) {
	  var isGenFun = isGeneratorFunction(fn);
	
	  return function (done) {
	    var ctx = this;
	
	    // in toThunk() below we invoke co()
	    // with a generator, so optimize for
	    // this case
	    var gen = fn;
	
	    // we only need to parse the arguments
	    // if gen is a generator function.
	    if (isGenFun) {
	      var args = slice.call(arguments), len = args.length;
	      var hasCallback = len && 'function' == typeof args[len - 1];
	      done = hasCallback ? args.pop() : error;
	      gen = fn.apply(this, args);
	    } else {
	      done = done || error;
	    }
	
	    next();
	
	    // #92
	    // wrap the callback in a setImmediate
	    // so that any of its errors aren't caught by `co`
	    function exit(err, res) {
	      setImmediate(function(){
	        done.call(ctx, err, res);
	      });
	    }
	
	    function next(err, res) {
	      var ret;
	
	      // multiple args
	      if (arguments.length > 2) res = slice.call(arguments, 1);
	
	      // error
	      if (err) {
	        try {
	          ret = gen.throw(err);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // ok
	      if (!err) {
	        try {
	          ret = gen.next(res);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // done
	      if (ret.done) return exit(null, ret.value);
	
	      // normalize
	      ret.value = toThunk(ret.value, ctx);
	
	      // run
	      if ('function' == typeof ret.value) {
	        var called = false;
	        try {
	          ret.value.call(ctx, function(){
	            if (called) return;
	            called = true;
	            next.apply(ctx, arguments);
	          });
	        } catch (e) {
	          setImmediate(function(){
	            if (called) return;
	            called = true;
	            next(e);
	          });
	        }
	        return;
	      }
	
	      // invalid
	      next(new TypeError('You may only yield a function, promise, generator, array, or object, '
	        + 'but the following was passed: "' + String(ret.value) + '"'));
	    }
	  }
	}
	
	/**
	 * Convert `obj` into a normalized thunk.
	 *
	 * @param {Mixed} obj
	 * @param {Mixed} ctx
	 * @return {Function}
	 * @api private
	 */
	
	function toThunk(obj, ctx) {
	
	  if (isGeneratorFunction(obj)) {
	    return co(obj.call(ctx));
	  }
	
	  if (isGenerator(obj)) {
	    return co(obj);
	  }
	
	  if (isPromise(obj)) {
	    return promiseToThunk(obj);
	  }
	
	  if ('function' == typeof obj) {
	    return obj;
	  }
	
	  if (isObject(obj) || Array.isArray(obj)) {
	    return objectToThunk.call(ctx, obj);
	  }
	
	  return obj;
	}
	
	/**
	 * Convert an object of yieldables to a thunk.
	 *
	 * @param {Object} obj
	 * @return {Function}
	 * @api private
	 */
	
	function objectToThunk(obj){
	  var ctx = this;
	  var isArray = Array.isArray(obj);
	
	  return function(done){
	    var keys = Object.keys(obj);
	    var pending = keys.length;
	    var results = isArray
	      ? new Array(pending) // predefine the array length
	      : new obj.constructor();
	    var finished;
	
	    if (!pending) {
	      setImmediate(function(){
	        done(null, results)
	      });
	      return;
	    }
	
	    // prepopulate object keys to preserve key ordering
	    if (!isArray) {
	      for (var i = 0; i < pending; i++) {
	        results[keys[i]] = undefined;
	      }
	    }
	
	    for (var i = 0; i < keys.length; i++) {
	      run(obj[keys[i]], keys[i]);
	    }
	
	    function run(fn, key) {
	      if (finished) return;
	      try {
	        fn = toThunk(fn, ctx);
	
	        if ('function' != typeof fn) {
	          results[key] = fn;
	          return --pending || done(null, results);
	        }
	
	        fn.call(ctx, function(err, res){
	          if (finished) return;
	
	          if (err) {
	            finished = true;
	            return done(err);
	          }
	
	          results[key] = res;
	          --pending || done(null, results);
	        });
	      } catch (err) {
	        finished = true;
	        done(err);
	      }
	    }
	  }
	}
	
	/**
	 * Convert `promise` to a thunk.
	 *
	 * @param {Object} promise
	 * @return {Function}
	 * @api private
	 */
	
	function promiseToThunk(promise) {
	  return function(fn){
	    promise.then(function(res) {
	      fn(null, res);
	    }, fn);
	  }
	}
	
	/**
	 * Check if `obj` is a promise.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isPromise(obj) {
	  return obj && 'function' == typeof obj.then;
	}
	
	/**
	 * Check if `obj` is a generator.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGenerator(obj) {
	  return obj && 'function' == typeof obj.next && 'function' == typeof obj.throw;
	}
	
	/**
	 * Check if `obj` is a generator function.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGeneratorFunction(obj) {
	  return obj && obj.constructor && 'GeneratorFunction' == obj.constructor.name;
	}
	
	/**
	 * Check for plain object.
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(val) {
	  return val && Object == val.constructor;
	}
	
	/**
	 * Throw `err` in a new stack.
	 *
	 * This is used when co() is invoked
	 * without supplying a callback, which
	 * should only be for demonstrational
	 * purposes.
	 *
	 * @param {Error} err
	 * @api private
	 */
	
	function error(err) {
	  if (!err) return;
	  setImmediate(function(){
	    throw err;
	  });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(331).setImmediate))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var trim = __webpack_require__(13)
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = trim(input.slice(lastIndex, index))
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return trim(values.join(right + comma + left))
	}


/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = detab;
	
	var repeat = __webpack_require__(9);
	
	var TAB = 0x09;
	var LF = 0x0A;
	var CR = 0x0D;
	
	/* Replace tabs with spaces, being smart about which
	 * column the tab is at and which size should be used. */
	function detab(value, size) {
	  var string = typeof value === 'string';
	  var length = string && value.length;
	  var start = 0;
	  var index = -1;
	  var column = -1;
	  var tabSize = size || 4;
	  var results = [];
	  var code;
	  var add;
	
	  if (!string) {
	    throw new Error('detab expected string');
	  }
	
	  while (++index < length) {
	    code = value.charCodeAt(index);
	
	    if (code === TAB) {
	      add = tabSize - ((column + 1) % tabSize);
	      column += add;
	      results.push(value.slice(start, index) + repeat(' ', add));
	      start = index + 1;
	    } else if (code === LF || code === CR) {
	      column = -1;
	    } else {
	      column++;
	    }
	  }
	
	  results.push(value.slice(start));
	
	  return results.join('');
	}


/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(159);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(160);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	module.exports = __webpack_require__(166)


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	/* Dependencies. */
	var xtend = __webpack_require__(8)
	var defaults = __webpack_require__(187)
	
	/* Expose. */
	module.exports = wrapper
	
	var own = {}.hasOwnProperty
	
	/* Schema. */
	var NODES = {
	  root: {children: all},
	  doctype: handleDoctype,
	  comment: handleComment,
	  element: {
	    tagName: handleTagName,
	    properties: handleProperties,
	    children: all
	  },
	  text: {value: handleValue},
	  '*': {
	    data: allow,
	    position: allow
	  }
	}
	
	/* Sanitize `node`, according to `schema`. */
	function wrapper(node, schema) {
	  var ctx = {type: 'root', children: []}
	  var replace
	
	  if (!node || typeof node !== 'object' || !node.type) {
	    return ctx
	  }
	
	  replace = one(xtend(defaults, schema || {}), node, [])
	
	  if (!replace) {
	    return ctx
	  }
	
	  if ('length' in replace) {
	    if (replace.length === 1) {
	      return replace[0]
	    }
	
	    ctx.children = replace
	
	    return ctx
	  }
	
	  return replace
	}
	
	/* Sanitize `node`. */
	function one(schema, node, stack) {
	  var type = node && node.type
	  var replacement = {type: node.type}
	  var replace = true
	  var definition
	  var allowed
	  var result
	  var key
	
	  if (!own.call(NODES, type)) {
	    replace = false
	  } else {
	    definition = NODES[type]
	
	    if (typeof definition === 'function') {
	      definition = definition(schema, node)
	    }
	
	    if (!definition) {
	      replace = false
	    } else {
	      allowed = xtend(definition, NODES['*'])
	
	      for (key in allowed) {
	        result = allowed[key](schema, node[key], node, stack)
	
	        if (result === false) {
	          replace = false
	
	          /* Set the non-safe value. */
	          replacement[key] = node[key]
	        } else if (result !== null && result !== undefined) {
	          replacement[key] = result
	        }
	      }
	    }
	  }
	
	  if (!replace) {
	    if (
	      !replacement.children ||
	      replacement.children.length === 0 ||
	      schema.strip.indexOf(replacement.tagName) !== -1
	    ) {
	      return null
	    }
	
	    return replacement.children
	  }
	
	  return replacement
	}
	
	/* Sanitize `children`. */
	function all(schema, children, node, stack) {
	  var nodes = children || []
	  var length = nodes.length || 0
	  var results = []
	  var index = -1
	  var result
	
	  stack = stack.concat(node.tagName)
	
	  while (++index < length) {
	    result = one(schema, nodes[index], stack)
	
	    if (result) {
	      if ('length' in result) {
	        results = results.concat(result)
	      } else {
	        results.push(result)
	      }
	    }
	  }
	
	  return results
	}
	
	/* Sanitize `properties`. */
	function handleProperties(schema, properties, node, stack) {
	  var name = handleTagName(schema, node.tagName, node, stack)
	  var attrs = schema.attributes
	  var props = properties || {}
	  var result = {}
	  var allowed
	  var prop
	  var value
	
	  allowed = own.call(attrs, name) ? attrs[name] : []
	  allowed = [].concat(allowed, attrs['*'])
	
	  for (prop in props) {
	    value = props[prop]
	
	    if (
	      allowed.indexOf(prop) === -1 &&
	      !(data(prop) && allowed.indexOf('data*') !== -1)
	    ) {
	      continue
	    }
	
	    if (value && typeof value === 'object' && 'length' in value) {
	      value = handlePropertyValues(schema, value, prop)
	    } else {
	      value = handlePropertyValue(schema, value, prop)
	    }
	
	    if (value !== null && value !== undefined) {
	      result[prop] = value
	    }
	  }
	
	  return result
	}
	
	/* Sanitize a property value which is a list. */
	function handlePropertyValues(schema, values, prop) {
	  var length = values.length
	  var result = []
	  var index = -1
	  var value
	
	  while (++index < length) {
	    value = handlePropertyValue(schema, values[index], prop)
	
	    if (value !== null && value !== undefined) {
	      result.push(value)
	    }
	  }
	
	  return result
	}
	
	/* Sanitize a property value. */
	function handlePropertyValue(schema, value, prop) {
	  if (
	    typeof value !== 'boolean' &&
	    typeof value !== 'number' &&
	    typeof value !== 'string'
	  ) {
	    return null
	  }
	
	  if (!handleProtocol(schema, value, prop)) {
	    return null
	  }
	
	  if (schema.clobber.indexOf(prop) !== -1) {
	    value = schema.clobberPrefix + value
	  }
	
	  return value
	}
	
	/* Check whether `value` is a safe URL. */
	function handleProtocol(schema, value, prop) {
	  var protocols = schema.protocols
	  var protocol
	  var first
	  var colon
	  var length
	  var index
	
	  protocols = own.call(protocols, prop) ? protocols[prop].concat() : []
	
	  if (protocols.length === 0) {
	    return true
	  }
	
	  value = String(value)
	  first = value.charAt(0)
	
	  if (first === '#' || first === '/') {
	    return true
	  }
	
	  colon = value.indexOf(':')
	
	  if (colon === -1) {
	    return true
	  }
	
	  length = protocols.length
	  index = -1
	
	  while (++index < length) {
	    protocol = protocols[index]
	
	    if (
	      colon === protocol.length &&
	      value.slice(0, protocol.length) === protocol
	    ) {
	      return true
	    }
	  }
	
	  index = value.indexOf('?')
	
	  if (index !== -1 && colon > index) {
	    return true
	  }
	
	  index = value.indexOf('#')
	
	  if (index !== -1 && colon > index) {
	    return true
	  }
	
	  return false
	}
	
	/* Always return a valid HTML5 doctype. */
	function handleDoctypeName() {
	  return 'html'
	}
	
	/* Sanitize `tagName`. */
	function handleTagName(schema, tagName, node, stack) {
	  var name = typeof tagName === 'string' ? tagName : null
	  var ancestors = schema.ancestors
	  var length
	  var index
	
	  if (!name || name === '*' || schema.tagNames.indexOf(name) === -1) {
	    return false
	  }
	
	  ancestors = own.call(ancestors, name) ? ancestors[name] : []
	
	  /* Some nodes can break out of their context if they
	   * don’t have a certain ancestor. */
	  if (ancestors.length !== 0) {
	    length = ancestors.length + 1
	    index = -1
	
	    while (++index < length) {
	      if (!ancestors[index]) {
	        return false
	      }
	
	      if (stack.indexOf(ancestors[index]) !== -1) {
	        break
	      }
	    }
	  }
	
	  return name
	}
	
	function handleDoctype(schema) {
	  return schema.allowDoctypes ? {name: handleDoctypeName} : null
	}
	
	function handleComment(schema) {
	  return schema.allowComments ? {value: handleValue} : null
	}
	
	/* Sanitize `value`. */
	function handleValue(schema, value) {
	  return typeof value === 'string' ? value : ''
	}
	
	/* Allow `value`. */
	function allow(schema, value) {
	  return value
	}
	
	/* Check if `prop` is a data property. */
	function data(prop) {
	  return prop.length > 4 && prop.slice(0, 4).toLowerCase() === 'data'
	}


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(171);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = comment;
	
	/* Stringify a comment `node`. */
	function comment(ctx, node) {
	  return '<!--' + node.value + '-->';
	}


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = doctype;
	
	/* Stringify a doctype `node`. */
	function doctype(ctx, node) {
	  var pub = node.public;
	  var sys = node.system;
	  var val = '<!DOCTYPE';
	
	  if (!node.name) {
	    return val + '>';
	  }
	
	  val += ' ' + node.name;
	
	  if (pub != null) {
	    val += ' PUBLIC ' + smart(pub);
	  } else if (sys != null) {
	    val += ' SYSTEM';
	  }
	
	  if (sys != null) {
	    val += ' ' + smart(sys);
	  }
	
	  return val + '>';
	}
	
	function smart(value) {
	  var quote = value.indexOf('"') === -1 ? '"' : '\'';
	  return quote + value + quote;
	}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(8);
	var spaces = __webpack_require__(330).stringify;
	var commas = __webpack_require__(131).stringify;
	var information = __webpack_require__(205);
	var entities = __webpack_require__(42);
	var kebab = __webpack_require__(192);
	var ccount = __webpack_require__(57);
	var all = __webpack_require__(67);
	
	module.exports = element;
	
	/* Constants. */
	var DATA = 'data';
	var EMPTY = '';
	
	/* Characters. */
	var SPACE = ' ';
	var DQ = '"';
	var SQ = '\'';
	var EQ = '=';
	var LT = '<';
	var GT = '>';
	var SO = '/';
	
	/* Stringify an element `node`. */
	function element(ctx, node, index, parent) {
	  var name = node.tagName;
	  var content = all(ctx, name === 'template' ? node.content : node);
	  var selfClosing = ctx.voids.indexOf(name.toLowerCase()) !== -1;
	  var attrs = attributes(ctx, node.properties);
	  var omit = ctx.omit;
	  var value = '';
	
	  /* If the node is categorised as void, but it has
	   * children, remove the categorisation.  This
	   * enables for example `menuitem`s, which are
	   * void in W3C HTML but not void in WHATWG HTML, to
	   * be stringified properly. */
	  selfClosing = content ? false : selfClosing;
	
	  if (attrs || !omit || !omit.opening(node, index, parent)) {
	    value = LT + name + (attrs ? SPACE + attrs : EMPTY);
	
	    if (selfClosing && ctx.close) {
	      if (!ctx.tightClose || attrs.charAt(attrs.length - 1) === SO) {
	        value += SPACE;
	      }
	
	      value += SO;
	    }
	
	    value += GT;
	  }
	
	  value += content;
	
	  if (!selfClosing && (!omit || !omit.closing(node, index, parent))) {
	    value += LT + SO + name + GT;
	  }
	
	  return value;
	}
	
	/* Stringify all attributes. */
	function attributes(ctx, props) {
	  var values = [];
	  var key;
	  var value;
	  var result;
	  var length;
	  var index;
	  var last;
	
	  for (key in props) {
	    value = props[key];
	
	    if (value == null) {
	      continue;
	    }
	
	    result = attribute(ctx, key, value);
	
	    if (result) {
	      values.push(result);
	    }
	  }
	
	  length = values.length;
	  index = -1;
	
	  while (++index < length) {
	    result = values[index];
	    last = ctx.tight && result.charAt(result.length - 1);
	
	    /* In tight mode, don’t add a space after quoted attributes. */
	    if (index !== length - 1 && last !== DQ && last !== SQ) {
	      values[index] = result + SPACE;
	    }
	  }
	
	  return values.join(EMPTY);
	}
	
	/* Stringify one attribute. */
	function attribute(ctx, key, value) {
	  var info = information(key) || {};
	  var name;
	
	  if (
	    value == null ||
	    (typeof value === 'number' && isNaN(value)) ||
	    (!value && info.boolean) ||
	    (value === false && info.overloadedBoolean)
	  ) {
	    return EMPTY;
	  }
	
	  name = attributeName(ctx, key);
	
	  if ((value && info.boolean) || (value === true && info.overloadedBoolean)) {
	    return name;
	  }
	
	  return name + attributeValue(ctx, key, value);
	}
	
	/* Stringify the attribute name. */
	function attributeName(ctx, key) {
	  var info = information(key) || {};
	  var name = info.name || kebab(key);
	
	  if (
	    name.slice(0, DATA.length) === DATA &&
	    /[0-9]/.test(name.charAt(DATA.length))
	  ) {
	    name = DATA + '-' + name.slice(4);
	  }
	
	  return entities(name, xtend(ctx.entities, {
	    subset: ctx.NAME
	  }));
	}
	
	/* Stringify the attribute value. */
	function attributeValue(ctx, key, value) {
	  var info = information(key) || {};
	  var options = ctx.entities;
	  var quote = ctx.quote;
	  var alternative = ctx.alternative;
	  var unquoted;
	
	  if (typeof value === 'object' && 'length' in value) {
	    /* `spaces` doesn’t accept a second argument, but it’s
	     * given here just to keep the code cleaner. */
	    value = (info.commaSeparated ? commas : spaces)(value, {
	      padLeft: !ctx.tightLists
	    });
	  }
	
	  value = String(value);
	
	  if (value || !ctx.collapseEmpty) {
	    unquoted = value;
	
	    /* Check unquoted value. */
	    if (ctx.unquoted) {
	      unquoted = entities(value, xtend(options, {
	        subset: ctx.UNQUOTED,
	        attribute: true
	      }));
	    }
	
	    /* If `value` contains entities when unquoted... */
	    if (!ctx.unquoted || unquoted !== value) {
	      /* If the alternative is less common than `quote`, switch. */
	      if (
	        alternative &&
	        ccount(value, quote) > ccount(value, alternative)
	      ) {
	        quote = alternative;
	      }
	
	      value = entities(value, xtend(options, {
	        subset: quote === SQ ? ctx.SINGLE_QUOTED : ctx.DOUBLE_QUOTED,
	        attribute: true
	      }));
	
	      value = quote + value + quote;
	    }
	
	    /* Don’t add a `=` for unquoted empties. */
	    value = value ? EQ + value : value;
	  }
	
	  return value;
	}


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var voids = __webpack_require__(188);
	var omission = __webpack_require__(172);
	var one = __webpack_require__(71);
	
	module.exports = toHTML;
	
	/* Characters. */
	var NULL = '\0';
	var AMP = '&';
	var SPACE = ' ';
	var TAB = '\t';
	var GR = '`';
	var DQ = '"';
	var SQ = '\'';
	var EQ = '=';
	var LT = '<';
	var GT = '>';
	var SO = '/';
	var LF = '\n';
	var CR = '\r';
	var FF = '\f';
	
	/* https://html.spec.whatwg.org/#attribute-name-state */
	var NAME = [AMP, SPACE, TAB, LF, CR, FF, SO, GT, EQ];
	var CLEAN_NAME = NAME.concat(NULL, DQ, SQ, LT);
	
	/* In safe mode, all attribute values contain DQ (`"`),
	 * SQ (`'`), and GR (`` ` ``), as those can create XSS
	 * issues in older browsers:
	 * - https://html5sec.org/#59
	 * - https://html5sec.org/#102
	 * - https://html5sec.org/#108 */
	var QUOTES = [DQ, SQ, GR];
	
	/* https://html.spec.whatwg.org/#attribute-value-(unquoted)-state */
	var UQ_VALUE = [AMP, SPACE, TAB, LF, CR, FF, GT];
	var UQ_VALUE_CLEAN = UQ_VALUE.concat(NULL, DQ, SQ, LT, EQ, GR);
	
	/* https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state */
	var SQ_VALUE = [AMP, SQ];
	var SQ_VALUE_CLEAN = SQ_VALUE.concat(NULL);
	
	/* https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state */
	var DQ_VALUE = [AMP, DQ];
	var DQ_VALUE_CLEAN = DQ_VALUE.concat(NULL);
	
	/* Stringify the given HAST node. */
	function toHTML(node, options) {
	  var settings = options || {};
	  var quote = settings.quote || DQ;
	  var smart = settings.quoteSmart;
	  var errors = settings.allowParseErrors;
	  var characters = settings.allowDangerousCharacters;
	  var alternative = quote === DQ ? SQ : DQ;
	  var name = errors ? NAME : CLEAN_NAME;
	  var unquoted = errors ? UQ_VALUE : UQ_VALUE_CLEAN;
	  var singleQuoted = errors ? SQ_VALUE : SQ_VALUE_CLEAN;
	  var doubleQuoted = errors ? DQ_VALUE : DQ_VALUE_CLEAN;
	
	  if (quote !== DQ && quote !== SQ) {
	    throw new Error(
	      'Invalid quote `' + quote + '`, expected `' +
	      SQ + '` or `' + DQ + '`'
	    );
	  }
	
	  return one({
	    NAME: name.concat(characters ? [] : QUOTES),
	    UNQUOTED: unquoted.concat(characters ? [] : QUOTES),
	    DOUBLE_QUOTED: doubleQuoted.concat(characters ? [] : QUOTES),
	    SINGLE_QUOTED: singleQuoted.concat(characters ? [] : QUOTES),
	    omit: settings.omitOptionalTags && omission,
	    quote: quote,
	    alternative: smart ? alternative : null,
	    unquoted: Boolean(settings.preferUnquoted),
	    tight: settings.tightAttributes,
	    tightLists: settings.tightCommaSeparatedLists,
	    tightClose: settings.tightSelfClosing,
	    collapseEmpty: settings.collapseEmptyAttributes,
	    dangerous: settings.allowDangerousHTML,
	    voids: settings.voids || voids.concat(),
	    entities: settings.entities || {},
	    close: settings.closeSelfClosing
	  }, node);
	}


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports.opening = __webpack_require__(173);
	exports.closing = __webpack_require__(68);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(26);
	var element = __webpack_require__(66);
	var before = __webpack_require__(35).before;
	var first = __webpack_require__(174);
	var place = __webpack_require__(175);
	var whiteSpaceLeft = __webpack_require__(70);
	var closing = __webpack_require__(68);
	var omission = __webpack_require__(69);
	
	var own = {}.hasOwnProperty;
	
	module.exports = omission({
	  html: html,
	  head: head,
	  body: body,
	  colgroup: colgroup,
	  tbody: tbody
	});
	
	/* Whether to omit `<html>`. */
	function html(node) {
	  var head = first(node);
	  return !head || !is('comment', head);
	}
	
	/* Whether to omit `<head>`. */
	function head(node) {
	  var children = node.children;
	  var length = children.length;
	  var map = {};
	  var index = -1;
	  var child;
	  var name;
	
	  while (++index < length) {
	    child = children[index];
	    name = child.tagName;
	
	    if (
	      child.type === 'element' &&
	      (name === 'title' || name === 'base')
	    ) {
	      if (own.call(map, name)) {
	        return false;
	      }
	
	      map[name] = true;
	    }
	  }
	
	  return Boolean(length);
	}
	
	/* Whether to omit `<body>`. */
	function body(node) {
	  var head = first(node, true);
	
	  return !head || (
	    !is('comment', head) &&
	    !whiteSpaceLeft(head) &&
	    !element(head, ['meta', 'link', 'script', 'style', 'template'])
	  );
	}
	
	/* Whether to omit `<colgroup>`.
	 * The spec describes some logic for the opening tag,
	 * but it’s easier to implement in the closing tag, to
	 * the same effect, so we handle it there instead. */
	function colgroup(node, index, parent) {
	  var prev = before(parent, index);
	  var head = first(node, true);
	
	  /* Previous colgroup was already omitted. */
	  if (
	    element(prev, 'colgroup') &&
	    closing(prev, place(parent, prev), parent)
	  ) {
	    return false;
	  }
	
	  return head && element(head, 'col');
	}
	
	/* Whether to omit `<tbody>`. */
	function tbody(node, index, parent) {
	  var prev = before(parent, index);
	  var head = first(node);
	
	  /* Previous table section was already omitted. */
	  if (
	    element(prev, ['thead', 'tbody']) &&
	    closing(prev, place(parent, prev), parent)
	  ) {
	    return false;
	  }
	
	  return head && element(head, 'tr');
	}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var after = __webpack_require__(35).after;
	
	module.exports = first;
	
	/* Get the first child in `parent`. */
	function first(parent, includeWhiteSpace) {
	  return after(parent, -1, includeWhiteSpace);
	}


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = place;
	
	/* Get the position of `node` in `parent`. */
	function place(parent, child) {
	  return parent && parent.children && parent.children.indexOf(child);
	}


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var text = __webpack_require__(72);
	
	module.exports = raw;
	
	/* Stringify `raw`. */
	function raw(ctx, node) {
	  return ctx.dangerous ? node.value : text(ctx, node);
	}


/***/ }),
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/* WEBPACK VAR INJECTION */(function (module) {
		'use strict';

		var irregularPlurals = __webpack_require__(189);

		var map = new Map();
		// TODO: Use Object.entries when targeting Node.js 8
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = Object.keys(irregularPlurals)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var key = _step.value;

				map.set(key, irregularPlurals[key]);
			}

			// Ensure nobody can modify each others Map
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		Object.defineProperty(module, 'exports', {
			get: function get() {
				return map;
			}
		});

		/* WEBPACK VAR INJECTION */
	}).call(exports, __webpack_require__(343)(module));

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
	};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a word character. */
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = {"nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","shy":"­","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","quot":"\"","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ensp":" ","emsp":" ","thinsp":" ","zwnj":"‌","zwj":"‍","lrm":"‎","rlm":"‏","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = {"AEli":"Æ","AElig":"Æ","AM":"&","AMP":"&","Aacut":"Á","Aacute":"Á","Abreve":"Ă","Acir":"Â","Acirc":"Â","Acy":"А","Afr":"𝔄","Agrav":"À","Agrave":"À","Alpha":"Α","Amacr":"Ā","And":"⩓","Aogon":"Ą","Aopf":"𝔸","ApplyFunction":"⁡","Arin":"Å","Aring":"Å","Ascr":"𝒜","Assign":"≔","Atild":"Ã","Atilde":"Ã","Aum":"Ä","Auml":"Ä","Backslash":"∖","Barv":"⫧","Barwed":"⌆","Bcy":"Б","Because":"∵","Bernoullis":"ℬ","Beta":"Β","Bfr":"𝔅","Bopf":"𝔹","Breve":"˘","Bscr":"ℬ","Bumpeq":"≎","CHcy":"Ч","COP":"©","COPY":"©","Cacute":"Ć","Cap":"⋒","CapitalDifferentialD":"ⅅ","Cayleys":"ℭ","Ccaron":"Č","Ccedi":"Ç","Ccedil":"Ç","Ccirc":"Ĉ","Cconint":"∰","Cdot":"Ċ","Cedilla":"¸","CenterDot":"·","Cfr":"ℭ","Chi":"Χ","CircleDot":"⊙","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","Colon":"∷","Colone":"⩴","Congruent":"≡","Conint":"∯","ContourIntegral":"∮","Copf":"ℂ","Coproduct":"∐","CounterClockwiseContourIntegral":"∳","Cross":"⨯","Cscr":"𝒞","Cup":"⋓","CupCap":"≍","DD":"ⅅ","DDotrahd":"⤑","DJcy":"Ђ","DScy":"Ѕ","DZcy":"Џ","Dagger":"‡","Darr":"↡","Dashv":"⫤","Dcaron":"Ď","Dcy":"Д","Del":"∇","Delta":"Δ","Dfr":"𝔇","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","Diamond":"⋄","DifferentialD":"ⅆ","Dopf":"𝔻","Dot":"¨","DotDot":"⃜","DotEqual":"≐","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrow":"↓","DownArrowBar":"⤓","DownArrowUpArrow":"⇵","DownBreve":"̑","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVector":"↽","DownLeftVectorBar":"⥖","DownRightTeeVector":"⥟","DownRightVector":"⇁","DownRightVectorBar":"⥗","DownTee":"⊤","DownTeeArrow":"↧","Downarrow":"⇓","Dscr":"𝒟","Dstrok":"Đ","ENG":"Ŋ","ET":"Ð","ETH":"Ð","Eacut":"É","Eacute":"É","Ecaron":"Ě","Ecir":"Ê","Ecirc":"Ê","Ecy":"Э","Edot":"Ė","Efr":"𝔈","Egrav":"È","Egrave":"È","Element":"∈","Emacr":"Ē","EmptySmallSquare":"◻","EmptyVerySmallSquare":"▫","Eogon":"Ę","Eopf":"𝔼","Epsilon":"Ε","Equal":"⩵","EqualTilde":"≂","Equilibrium":"⇌","Escr":"ℰ","Esim":"⩳","Eta":"Η","Eum":"Ë","Euml":"Ë","Exists":"∃","ExponentialE":"ⅇ","Fcy":"Ф","Ffr":"𝔉","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","Fopf":"𝔽","ForAll":"∀","Fouriertrf":"ℱ","Fscr":"ℱ","GJcy":"Ѓ","G":">","GT":">","Gamma":"Γ","Gammad":"Ϝ","Gbreve":"Ğ","Gcedil":"Ģ","Gcirc":"Ĝ","Gcy":"Г","Gdot":"Ġ","Gfr":"𝔊","Gg":"⋙","Gopf":"𝔾","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","Gt":"≫","HARDcy":"Ъ","Hacek":"ˇ","Hat":"^","Hcirc":"Ĥ","Hfr":"ℌ","HilbertSpace":"ℋ","Hopf":"ℍ","HorizontalLine":"─","Hscr":"ℋ","Hstrok":"Ħ","HumpDownHump":"≎","HumpEqual":"≏","IEcy":"Е","IJlig":"Ĳ","IOcy":"Ё","Iacut":"Í","Iacute":"Í","Icir":"Î","Icirc":"Î","Icy":"И","Idot":"İ","Ifr":"ℑ","Igrav":"Ì","Igrave":"Ì","Im":"ℑ","Imacr":"Ī","ImaginaryI":"ⅈ","Implies":"⇒","Int":"∬","Integral":"∫","Intersection":"⋂","InvisibleComma":"⁣","InvisibleTimes":"⁢","Iogon":"Į","Iopf":"𝕀","Iota":"Ι","Iscr":"ℐ","Itilde":"Ĩ","Iukcy":"І","Ium":"Ï","Iuml":"Ï","Jcirc":"Ĵ","Jcy":"Й","Jfr":"𝔍","Jopf":"𝕁","Jscr":"𝒥","Jsercy":"Ј","Jukcy":"Є","KHcy":"Х","KJcy":"Ќ","Kappa":"Κ","Kcedil":"Ķ","Kcy":"К","Kfr":"𝔎","Kopf":"𝕂","Kscr":"𝒦","LJcy":"Љ","L":"<","LT":"<","Lacute":"Ĺ","Lambda":"Λ","Lang":"⟪","Laplacetrf":"ℒ","Larr":"↞","Lcaron":"Ľ","Lcedil":"Ļ","Lcy":"Л","LeftAngleBracket":"⟨","LeftArrow":"←","LeftArrowBar":"⇤","LeftArrowRightArrow":"⇆","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVector":"⇃","LeftDownVectorBar":"⥙","LeftFloor":"⌊","LeftRightArrow":"↔","LeftRightVector":"⥎","LeftTee":"⊣","LeftTeeArrow":"↤","LeftTeeVector":"⥚","LeftTriangle":"⊲","LeftTriangleBar":"⧏","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVector":"↿","LeftUpVectorBar":"⥘","LeftVector":"↼","LeftVectorBar":"⥒","Leftarrow":"⇐","Leftrightarrow":"⇔","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","LessLess":"⪡","LessSlantEqual":"⩽","LessTilde":"≲","Lfr":"𝔏","Ll":"⋘","Lleftarrow":"⇚","Lmidot":"Ŀ","LongLeftArrow":"⟵","LongLeftRightArrow":"⟷","LongRightArrow":"⟶","Longleftarrow":"⟸","Longleftrightarrow":"⟺","Longrightarrow":"⟹","Lopf":"𝕃","LowerLeftArrow":"↙","LowerRightArrow":"↘","Lscr":"ℒ","Lsh":"↰","Lstrok":"Ł","Lt":"≪","Map":"⤅","Mcy":"М","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","MinusPlus":"∓","Mopf":"𝕄","Mscr":"ℳ","Mu":"Μ","NJcy":"Њ","Nacute":"Ń","Ncaron":"Ň","Ncedil":"Ņ","Ncy":"Н","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","Nfr":"𝔑","NoBreak":"⁠","NonBreakingSpace":" ","Nopf":"ℕ","Not":"⫬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","NotLeftTriangle":"⋪","NotLeftTriangleBar":"⧏̸","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangle":"⋫","NotRightTriangleBar":"⧐̸","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","Nscr":"𝒩","Ntild":"Ñ","Ntilde":"Ñ","Nu":"Ν","OElig":"Œ","Oacut":"Ó","Oacute":"Ó","Ocir":"Ô","Ocirc":"Ô","Ocy":"О","Odblac":"Ő","Ofr":"𝔒","Ograv":"Ò","Ograve":"Ò","Omacr":"Ō","Omega":"Ω","Omicron":"Ο","Oopf":"𝕆","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","Or":"⩔","Oscr":"𝒪","Oslas":"Ø","Oslash":"Ø","Otild":"Õ","Otilde":"Õ","Otimes":"⨷","Oum":"Ö","Ouml":"Ö","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","PartialD":"∂","Pcy":"П","Pfr":"𝔓","Phi":"Φ","Pi":"Π","PlusMinus":"±","Poincareplane":"ℌ","Popf":"ℙ","Pr":"⪻","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","Prime":"″","Product":"∏","Proportion":"∷","Proportional":"∝","Pscr":"𝒫","Psi":"Ψ","QUO":"\"","QUOT":"\"","Qfr":"𝔔","Qopf":"ℚ","Qscr":"𝒬","RBarr":"⤐","RE":"®","REG":"®","Racute":"Ŕ","Rang":"⟫","Rarr":"↠","Rarrtl":"⤖","Rcaron":"Ř","Rcedil":"Ŗ","Rcy":"Р","Re":"ℜ","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","Rfr":"ℜ","Rho":"Ρ","RightAngleBracket":"⟩","RightArrow":"→","RightArrowBar":"⇥","RightArrowLeftArrow":"⇄","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVector":"⇂","RightDownVectorBar":"⥕","RightFloor":"⌋","RightTee":"⊢","RightTeeArrow":"↦","RightTeeVector":"⥛","RightTriangle":"⊳","RightTriangleBar":"⧐","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVector":"↾","RightUpVectorBar":"⥔","RightVector":"⇀","RightVectorBar":"⥓","Rightarrow":"⇒","Ropf":"ℝ","RoundImplies":"⥰","Rrightarrow":"⇛","Rscr":"ℛ","Rsh":"↱","RuleDelayed":"⧴","SHCHcy":"Щ","SHcy":"Ш","SOFTcy":"Ь","Sacute":"Ś","Sc":"⪼","Scaron":"Š","Scedil":"Ş","Scirc":"Ŝ","Scy":"С","Sfr":"𝔖","ShortDownArrow":"↓","ShortLeftArrow":"←","ShortRightArrow":"→","ShortUpArrow":"↑","Sigma":"Σ","SmallCircle":"∘","Sopf":"𝕊","Sqrt":"√","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","Sscr":"𝒮","Star":"⋆","Sub":"⋐","Subset":"⋐","SubsetEqual":"⊆","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","SuchThat":"∋","Sum":"∑","Sup":"⋑","Superset":"⊃","SupersetEqual":"⊇","Supset":"⋑","THOR":"Þ","THORN":"Þ","TRADE":"™","TSHcy":"Ћ","TScy":"Ц","Tab":"\t","Tau":"Τ","Tcaron":"Ť","Tcedil":"Ţ","Tcy":"Т","Tfr":"𝔗","Therefore":"∴","Theta":"Θ","ThickSpace":"  ","ThinSpace":" ","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","Topf":"𝕋","TripleDot":"⃛","Tscr":"𝒯","Tstrok":"Ŧ","Uacut":"Ú","Uacute":"Ú","Uarr":"↟","Uarrocir":"⥉","Ubrcy":"Ў","Ubreve":"Ŭ","Ucir":"Û","Ucirc":"Û","Ucy":"У","Udblac":"Ű","Ufr":"𝔘","Ugrav":"Ù","Ugrave":"Ù","Umacr":"Ū","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","Uopf":"𝕌","UpArrow":"↑","UpArrowBar":"⤒","UpArrowDownArrow":"⇅","UpDownArrow":"↕","UpEquilibrium":"⥮","UpTee":"⊥","UpTeeArrow":"↥","Uparrow":"⇑","Updownarrow":"⇕","UpperLeftArrow":"↖","UpperRightArrow":"↗","Upsi":"ϒ","Upsilon":"Υ","Uring":"Ů","Uscr":"𝒰","Utilde":"Ũ","Uum":"Ü","Uuml":"Ü","VDash":"⊫","Vbar":"⫫","Vcy":"В","Vdash":"⊩","Vdashl":"⫦","Vee":"⋁","Verbar":"‖","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","Vopf":"𝕍","Vscr":"𝒱","Vvdash":"⊪","Wcirc":"Ŵ","Wedge":"⋀","Wfr":"𝔚","Wopf":"𝕎","Wscr":"𝒲","Xfr":"𝔛","Xi":"Ξ","Xopf":"𝕏","Xscr":"𝒳","YAcy":"Я","YIcy":"Ї","YUcy":"Ю","Yacut":"Ý","Yacute":"Ý","Ycirc":"Ŷ","Ycy":"Ы","Yfr":"𝔜","Yopf":"𝕐","Yscr":"𝒴","Yuml":"Ÿ","ZHcy":"Ж","Zacute":"Ź","Zcaron":"Ž","Zcy":"З","Zdot":"Ż","ZeroWidthSpace":"​","Zeta":"Ζ","Zfr":"ℨ","Zopf":"ℤ","Zscr":"𝒵","aacut":"á","aacute":"á","abreve":"ă","ac":"∾","acE":"∾̳","acd":"∿","acir":"â","acirc":"â","acut":"´","acute":"´","acy":"а","aeli":"æ","aelig":"æ","af":"⁡","afr":"𝔞","agrav":"à","agrave":"à","alefsym":"ℵ","aleph":"ℵ","alpha":"α","amacr":"ā","amalg":"⨿","am":"&","amp":"&","and":"∧","andand":"⩕","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsd":"∡","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","aogon":"ą","aopf":"𝕒","ap":"≈","apE":"⩰","apacir":"⩯","ape":"≊","apid":"≋","apos":"'","approx":"≈","approxeq":"≊","arin":"å","aring":"å","ascr":"𝒶","ast":"*","asymp":"≈","asympeq":"≍","atild":"ã","atilde":"ã","aum":"ä","auml":"ä","awconint":"∳","awint":"⨑","bNot":"⫭","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","barvee":"⊽","barwed":"⌅","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","beta":"β","beth":"ℶ","between":"≬","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bnot":"⌐","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxDL":"╗","boxDR":"╔","boxDl":"╖","boxDr":"╓","boxH":"═","boxHD":"╦","boxHU":"╩","boxHd":"╤","boxHu":"╧","boxUL":"╝","boxUR":"╚","boxUl":"╜","boxUr":"╙","boxV":"║","boxVH":"╬","boxVL":"╣","boxVR":"╠","boxVh":"╫","boxVl":"╢","boxVr":"╟","boxbox":"⧉","boxdL":"╕","boxdR":"╒","boxdl":"┐","boxdr":"┌","boxh":"─","boxhD":"╥","boxhU":"╨","boxhd":"┬","boxhu":"┴","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxuL":"╛","boxuR":"╘","boxul":"┘","boxur":"└","boxv":"│","boxvH":"╪","boxvL":"╡","boxvR":"╞","boxvh":"┼","boxvl":"┤","boxvr":"├","bprime":"‵","breve":"˘","brvba":"¦","brvbar":"¦","bscr":"𝒷","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsol":"\\","bsolb":"⧅","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","bumpeq":"≏","cacute":"ć","cap":"∩","capand":"⩄","capbrcup":"⩉","capcap":"⩋","capcup":"⩇","capdot":"⩀","caps":"∩︀","caret":"⁁","caron":"ˇ","ccaps":"⩍","ccaron":"č","ccedi":"ç","ccedil":"ç","ccirc":"ĉ","ccups":"⩌","ccupssm":"⩐","cdot":"ċ","cedi":"¸","cedil":"¸","cemptyv":"⦲","cen":"¢","cent":"¢","centerdot":"·","cfr":"𝔠","chcy":"ч","check":"✓","checkmark":"✓","chi":"χ","cir":"○","cirE":"⧃","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledR":"®","circledS":"Ⓢ","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","clubs":"♣","clubsuit":"♣","colon":":","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","conint":"∮","copf":"𝕔","coprod":"∐","cop":"©","copy":"©","copysr":"℗","crarr":"↵","cross":"✗","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cup":"∪","cupbrcap":"⩈","cupcap":"⩆","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curre":"¤","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dArr":"⇓","dHar":"⥥","dagger":"†","daleth":"ℸ","darr":"↓","dash":"‐","dashv":"⊣","dbkarow":"⤏","dblac":"˝","dcaron":"ď","dcy":"д","dd":"ⅆ","ddagger":"‡","ddarr":"⇊","ddotseq":"⩷","de":"°","deg":"°","delta":"δ","demptyv":"⦱","dfisht":"⥿","dfr":"𝔡","dharl":"⇃","dharr":"⇂","diam":"⋄","diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","digamma":"ϝ","disin":"⋲","div":"÷","divid":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","dopf":"𝕕","dot":"˙","doteq":"≐","doteqdot":"≑","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","downarrow":"↓","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","dscr":"𝒹","dscy":"ѕ","dsol":"⧶","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","dzcy":"џ","dzigrarr":"⟿","eDDot":"⩷","eDot":"≑","eacut":"é","eacute":"é","easter":"⩮","ecaron":"ě","ecir":"ê","ecirc":"ê","ecolon":"≕","ecy":"э","edot":"ė","ee":"ⅇ","efDot":"≒","efr":"𝔢","eg":"⪚","egrav":"è","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","emacr":"ē","empty":"∅","emptyset":"∅","emptyv":"∅","emsp13":" ","emsp14":" ","emsp":" ","eng":"ŋ","ensp":" ","eogon":"ę","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","equals":"=","equest":"≟","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erDot":"≓","erarr":"⥱","escr":"ℯ","esdot":"≐","esim":"≂","eta":"η","et":"ð","eth":"ð","eum":"ë","euml":"ë","euro":"€","excl":"!","exist":"∃","expectation":"ℰ","exponentiale":"ⅇ","fallingdotseq":"≒","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","ffr":"𝔣","filig":"ﬁ","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","fopf":"𝕗","forall":"∀","fork":"⋔","forkv":"⫙","fpartint":"⨍","frac1":"¼","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac3":"¾","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","gE":"≧","gEl":"⪌","gacute":"ǵ","gamma":"γ","gammad":"ϝ","gap":"⪆","gbreve":"ğ","gcirc":"ĝ","gcy":"г","gdot":"ġ","ge":"≥","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","ges":"⩾","gescc":"⪩","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","gfr":"𝔤","gg":"≫","ggg":"⋙","gimel":"ℷ","gjcy":"ѓ","gl":"≷","glE":"⪒","gla":"⪥","glj":"⪤","gnE":"≩","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gneq":"⪈","gneqq":"≩","gnsim":"⋧","gopf":"𝕘","grave":"`","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","g":">","gt":">","gtcc":"⪧","gtcir":"⩺","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","hArr":"⇔","hairsp":" ","half":"½","hamilt":"ℋ","hardcy":"ъ","harr":"↔","harrcir":"⥈","harrw":"↭","hbar":"ℏ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","horbar":"―","hscr":"𝒽","hslash":"ℏ","hstrok":"ħ","hybull":"⁃","hyphen":"‐","iacut":"í","iacute":"í","ic":"⁣","icir":"î","icirc":"î","icy":"и","iecy":"е","iexc":"¡","iexcl":"¡","iff":"⇔","ifr":"𝔦","igrav":"ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","ijlig":"ĳ","imacr":"ī","image":"ℑ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","imof":"⊷","imped":"Ƶ","in":"∈","incare":"℅","infin":"∞","infintie":"⧝","inodot":"ı","int":"∫","intcal":"⊺","integers":"ℤ","intercal":"⊺","intlarhk":"⨗","intprod":"⨼","iocy":"ё","iogon":"į","iopf":"𝕚","iota":"ι","iprod":"⨼","iques":"¿","iquest":"¿","iscr":"𝒾","isin":"∈","isinE":"⋹","isindot":"⋵","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","itilde":"ĩ","iukcy":"і","ium":"ï","iuml":"ï","jcirc":"ĵ","jcy":"й","jfr":"𝔧","jmath":"ȷ","jopf":"𝕛","jscr":"𝒿","jsercy":"ј","jukcy":"є","kappa":"κ","kappav":"ϰ","kcedil":"ķ","kcy":"к","kfr":"𝔨","kgreen":"ĸ","khcy":"х","kjcy":"ќ","kopf":"𝕜","kscr":"𝓀","lAarr":"⇚","lArr":"⇐","lAtail":"⤛","lBarr":"⤎","lE":"≦","lEg":"⪋","lHar":"⥢","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","lambda":"λ","lang":"⟨","langd":"⦑","langle":"⟨","lap":"⪅","laqu":"«","laquo":"«","larr":"←","larrb":"⇤","larrbfs":"⤟","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","lat":"⪫","latail":"⤙","late":"⪭","lates":"⪭︀","lbarr":"⤌","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","lcaron":"ľ","lcedil":"ļ","lceil":"⌈","lcub":"{","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","leftarrow":"←","leftarrowtail":"↢","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","leftthreetimes":"⋋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","les":"⩽","lescc":"⪨","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","lessgtr":"≶","lesssim":"≲","lfisht":"⥼","lfloor":"⌊","lfr":"𝔩","lg":"≶","lgE":"⪑","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","ljcy":"љ","ll":"≪","llarr":"⇇","llcorner":"⌞","llhard":"⥫","lltri":"◺","lmidot":"ŀ","lmoust":"⎰","lmoustache":"⎰","lnE":"≨","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","longleftrightarrow":"⟷","longmapsto":"⟼","longrightarrow":"⟶","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","lstrok":"ł","l":"<","lt":"<","ltcc":"⪦","ltcir":"⩹","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltrPar":"⦖","ltri":"◃","ltrie":"⊴","ltrif":"◂","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","mDDot":"∺","mac":"¯","macr":"¯","male":"♂","malt":"✠","maltese":"✠","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","mcy":"м","mdash":"—","measuredangle":"∡","mfr":"𝔪","mho":"℧","micr":"µ","micro":"µ","mid":"∣","midast":"*","midcir":"⫰","middo":"·","middot":"·","minus":"−","minusb":"⊟","minusd":"∸","minusdu":"⨪","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","mopf":"𝕞","mp":"∓","mscr":"𝓂","mstpos":"∾","mu":"μ","multimap":"⊸","mumap":"⊸","nGg":"⋙̸","nGt":"≫⃒","nGtv":"≫̸","nLeftarrow":"⇍","nLeftrightarrow":"⇎","nLl":"⋘̸","nLt":"≪⃒","nLtv":"≪̸","nRightarrow":"⇏","nVDash":"⊯","nVdash":"⊮","nabla":"∇","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natur":"♮","natural":"♮","naturals":"ℕ","nbs":" ","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","ncaron":"ň","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","ncy":"н","ndash":"–","ne":"≠","neArr":"⇗","nearhk":"⤤","nearr":"↗","nearrow":"↗","nedot":"≐̸","nequiv":"≢","nesear":"⤨","nesim":"≂̸","nexist":"∄","nexists":"∄","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","ngsim":"≵","ngt":"≯","ngtr":"≯","nhArr":"⇎","nharr":"↮","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","njcy":"њ","nlArr":"⇍","nlE":"≦̸","nlarr":"↚","nldr":"‥","nle":"≰","nleftarrow":"↚","nleftrightarrow":"↮","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nlsim":"≴","nlt":"≮","nltri":"⋪","nltrie":"⋬","nmid":"∤","nopf":"𝕟","no":"¬","not":"¬","notin":"∉","notinE":"⋹̸","notindot":"⋵̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","npar":"∦","nparallel":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","npre":"⪯̸","nprec":"⊀","npreceq":"⪯̸","nrArr":"⇏","nrarr":"↛","nrarrc":"⤳̸","nrarrw":"↝̸","nrightarrow":"↛","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","ntild":"ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","nu":"ν","num":"#","numero":"№","numsp":" ","nvDash":"⊭","nvHarr":"⤄","nvap":"≍⃒","nvdash":"⊬","nvge":"≥⃒","nvgt":">⃒","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwArr":"⇖","nwarhk":"⤣","nwarr":"↖","nwarrow":"↖","nwnear":"⤧","oS":"Ⓢ","oacut":"ó","oacute":"ó","oast":"⊛","ocir":"ô","ocirc":"ô","ocy":"о","odash":"⊝","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","oelig":"œ","ofcir":"⦿","ofr":"𝔬","ogon":"˛","ograv":"ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","omacr":"ō","omega":"ω","omicron":"ο","omid":"⦶","ominus":"⊖","oopf":"𝕠","opar":"⦷","operp":"⦹","oplus":"⊕","or":"∨","orarr":"↻","ord":"º","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oscr":"ℴ","oslas":"ø","oslash":"ø","osol":"⊘","otild":"õ","otilde":"õ","otimes":"⊗","otimesas":"⨶","oum":"ö","ouml":"ö","ovbar":"⌽","par":"¶","para":"¶","parallel":"∥","parsim":"⫳","parsl":"⫽","part":"∂","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","pfr":"𝔭","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plus":"+","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plusdo":"∔","plusdu":"⨥","pluse":"⩲","plusm":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","pointint":"⨕","popf":"𝕡","poun":"£","pound":"£","pr":"≺","prE":"⪳","prap":"⪷","prcue":"≼","pre":"⪯","prec":"≺","precapprox":"⪷","preccurlyeq":"≼","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","precsim":"≾","prime":"′","primes":"ℙ","prnE":"⪵","prnap":"⪹","prnsim":"⋨","prod":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","propto":"∝","prsim":"≾","prurel":"⊰","pscr":"𝓅","psi":"ψ","puncsp":" ","qfr":"𝔮","qint":"⨌","qopf":"𝕢","qprime":"⁗","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quo":"\"","quot":"\"","rAarr":"⇛","rArr":"⇒","rAtail":"⤜","rBarr":"⤏","rHar":"⥤","race":"∽̱","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","rangd":"⦒","range":"⦥","rangle":"⟩","raqu":"»","raquo":"»","rarr":"→","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","rarrtl":"↣","rarrw":"↝","ratail":"⤚","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","rcaron":"ř","rcedil":"ŗ","rceil":"⌉","rcub":"}","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","rect":"▭","re":"®","reg":"®","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","rhard":"⇁","rharu":"⇀","rharul":"⥬","rho":"ρ","rhov":"ϱ","rightarrow":"→","rightarrowtail":"↣","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","rightthreetimes":"⋌","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoust":"⎱","rmoustache":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","roplus":"⨮","rotimes":"⨵","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","rsaquo":"›","rscr":"𝓇","rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","ruluhar":"⥨","rx":"℞","sacute":"ś","sbquo":"‚","sc":"≻","scE":"⪴","scap":"⪸","scaron":"š","sccue":"≽","sce":"⪰","scedil":"ş","scirc":"ŝ","scnE":"⪶","scnap":"⪺","scnsim":"⋩","scpolint":"⨓","scsim":"≿","scy":"с","sdot":"⋅","sdotb":"⊡","sdote":"⩦","seArr":"⇘","searhk":"⤥","searr":"↘","searrow":"↘","sec":"§","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","sfr":"𝔰","sfrown":"⌢","sharp":"♯","shchcy":"щ","shcy":"ш","shortmid":"∣","shortparallel":"∥","sh":"­","shy":"­","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","softcy":"ь","sol":"/","solb":"⧄","solbar":"⌿","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","squ":"□","square":"□","squarf":"▪","squf":"▪","srarr":"→","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","subE":"⫅","subdot":"⪽","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","subseteq":"⊆","subseteqq":"⫅","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succ":"≻","succapprox":"⪸","succcurlyeq":"≽","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","sum":"∑","sung":"♪","sup":"⊃","sup1":"¹","sup2":"²","sup3":"³","supE":"⫆","supdot":"⪾","supdsub":"⫘","supe":"⊇","supedot":"⫄","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swArr":"⇙","swarhk":"⤦","swarr":"↙","swarrow":"↙","swnwar":"⤪","szli":"ß","szlig":"ß","target":"⌖","tau":"τ","tbrk":"⎴","tcaron":"ť","tcedil":"ţ","tcy":"т","tdot":"⃛","telrec":"⌕","tfr":"𝔱","there4":"∴","therefore":"∴","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","thinsp":" ","thkap":"≈","thksim":"∼","thor":"þ","thorn":"þ","tilde":"˜","time":"×","times":"×","timesb":"⊠","timesbar":"⨱","timesd":"⨰","tint":"∭","toea":"⤨","top":"⊤","topbot":"⌶","topcir":"⫱","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","tscr":"𝓉","tscy":"ц","tshcy":"ћ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","uArr":"⇑","uHar":"⥣","uacut":"ú","uacute":"ú","uarr":"↑","ubrcy":"ў","ubreve":"ŭ","ucir":"û","ucirc":"û","ucy":"у","udarr":"⇅","udblac":"ű","udhar":"⥮","ufisht":"⥾","ufr":"𝔲","ugrav":"ù","ugrave":"ù","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","umacr":"ū","um":"¨","uml":"¨","uogon":"ų","uopf":"𝕦","uparrow":"↑","updownarrow":"↕","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","upsi":"υ","upsih":"ϒ","upsilon":"υ","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","uring":"ů","urtri":"◹","uscr":"𝓊","utdot":"⋰","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","uum":"ü","uuml":"ü","uwangle":"⦧","vArr":"⇕","vBar":"⫨","vBarv":"⫩","vDash":"⊨","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vcy":"в","vdash":"⊢","vee":"∨","veebar":"⊻","veeeq":"≚","vellip":"⋮","verbar":"|","vert":"|","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","vopf":"𝕧","vprop":"∝","vrtri":"⊳","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","vzigzag":"⦚","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","wedgeq":"≙","weierp":"℘","wfr":"𝔴","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","xfr":"𝔵","xhArr":"⟺","xharr":"⟷","xi":"ξ","xlArr":"⟸","xlarr":"⟵","xmap":"⟼","xnis":"⋻","xodot":"⨀","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrArr":"⟹","xrarr":"⟶","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","yacut":"ý","yacute":"ý","yacy":"я","ycirc":"ŷ","ycy":"ы","ye":"¥","yen":"¥","yfr":"𝔶","yicy":"ї","yopf":"𝕪","yscr":"𝓎","yucy":"ю","yum":"ÿ","yuml":"ÿ","zacute":"ź","zcaron":"ž","zcy":"з","zdot":"ż","zeetrf":"ℨ","zeta":"ζ","zfr":"𝔷","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = {"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"li":["ol","ul"],"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","h7","h8","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details"],"attributes":{"a":["href"],"img":["src","longDesc"],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","axis","border","cellPadding","cellSpacing","char","charoff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hspace","isMap","id","label","lang","maxLength","media","method","multiple","name","nohref","noshade","nowrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","valign","value","vspace","width","itemProp"]}}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = ["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";

	module.exports = { "addendum": "addenda", "aircraft": "aircraft", "alga": "algae", "alumna": "alumnae", "alumnus": "alumni", "amoeba": "amoebae", "analysis": "analyses", "antenna": "antennae", "antithesis": "antitheses", "apex": "apices", "appendix": "appendices", "automaton": "automata", "axis": "axes", "bacillus": "bacilli", "bacterium": "bacteria", "barracks": "barracks", "basis": "bases", "beau": "beaux", "bison": "bison", "buffalo": "buffalo", "bureau": "bureaus", "cactus": "cacti", "calf": "calves", "carp": "carp", "census": "censuses", "chassis": "chassis", "cherub": "cherubim", "child": "children", "château": "châteaus", "cod": "cod", "codex": "codices", "concerto": "concerti", "corpus": "corpora", "crisis": "crises", "criterion": "criteria", "curriculum": "curricula", "datum": "data", "deer": "deer", "diagnosis": "diagnoses", "die": "dice", "dwarf": "dwarfs", "echo": "echoes", "elf": "elves", "elk": "elk", "ellipsis": "ellipses", "embargo": "embargoes", "emphasis": "emphases", "erratum": "errata", "faux pas": "faux pas", "fez": "fezes", "firmware": "firmware", "fish": "fish", "focus": "foci", "foot": "feet", "formula": "formulae", "fungus": "fungi", "gallows": "gallows", "genus": "genera", "goose": "geese", "graffito": "graffiti", "grouse": "grouse", "half": "halves", "hero": "heroes", "hoof": "hooves", "hovercraft": "hovercraft", "hypothesis": "hypotheses", "index": "indices", "kakapo": "kakapo", "knife": "knives", "larva": "larvae", "leaf": "leaves", "libretto": "libretti", "life": "lives", "loaf": "loaves", "locus": "loci", "louse": "lice", "man": "men", "matrix": "matrices", "means": "means", "medium": "media", "memorandum": "memoranda", "millennium": "millennia", "minutia": "minutiae", "moose": "moose", "mouse": "mice", "nebula": "nebulae", "nemesis": "nemeses", "neurosis": "neuroses", "news": "news", "nucleus": "nuclei", "oasis": "oases", "offspring": "offspring", "opus": "opera", "ovum": "ova", "ox": "oxen", "paralysis": "paralyses", "parenthesis": "parentheses", "person": "people", "phenomenon": "phenomena", "phylum": "phyla", "pike": "pike", "polyhedron": "polyhedra", "potato": "potatoes", "prognosis": "prognoses", "quiz": "quizzes", "radius": "radii", "referendum": "referenda", "salmon": "salmon", "scarf": "scarves", "self": "selves", "series": "series", "sheep": "sheep", "shelf": "shelves", "shrimp": "shrimp", "spacecraft": "spacecraft", "species": "species", "spectrum": "spectra", "squid": "squid", "stimulus": "stimuli", "stratum": "strata", "swine": "swine", "syllabus": "syllabi", "symposium": "symposia", "synopsis": "synopses", "synthesis": "syntheses", "tableau": "tableaus", "that": "those", "thesis": "theses", "thief": "thieves", "this": "these", "tomato": "tomatoes", "tooth": "teeth", "trout": "trout", "tuna": "tuna", "vertebra": "vertebrae", "vertex": "vertices", "veto": "vetoes", "vita": "vitae", "vortex": "vortices", "watercraft": "watercraft", "wharf": "wharves", "wife": "wives", "wolf": "wolves", "woman": "women" };

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = ["cent","copy","divide","gt","lt","not","para","times"]

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = markdownTable
	
	/* Expressions. */
	var EXPRESSION_DOT = /\./
	var EXPRESSION_LAST_DOT = /\.[^.]*$/
	
	/* Allowed alignment values. */
	var LEFT = 'l'
	var RIGHT = 'r'
	var CENTER = 'c'
	var DOT = '.'
	var NULL = ''
	
	var ALLIGNMENT = [LEFT, RIGHT, CENTER, DOT, NULL]
	var MIN_CELL_SIZE = 3
	
	/* Characters. */
	var COLON = ':'
	var DASH = '-'
	var PIPE = '|'
	var SPACE = ' '
	var NEW_LINE = '\n'
	
	/* Create a table from a matrix of strings. */
	function markdownTable(table, options) {
	  var settings = options || {}
	  var delimiter = settings.delimiter
	  var start = settings.start
	  var end = settings.end
	  var alignment = settings.align
	  var calculateStringLength = settings.stringLength || lengthNoop
	  var cellCount = 0
	  var rowIndex = -1
	  var rowLength = table.length
	  var sizes = []
	  var align
	  var rule
	  var rows
	  var row
	  var cells
	  var index
	  var position
	  var size
	  var value
	  var spacing
	  var before
	  var after
	
	  alignment = alignment ? alignment.concat() : []
	
	  if (delimiter === null || delimiter === undefined) {
	    delimiter = SPACE + PIPE + SPACE
	  }
	
	  if (start === null || start === undefined) {
	    start = PIPE + SPACE
	  }
	
	  if (end === null || end === undefined) {
	    end = SPACE + PIPE
	  }
	
	  while (++rowIndex < rowLength) {
	    row = table[rowIndex]
	
	    index = -1
	
	    if (row.length > cellCount) {
	      cellCount = row.length
	    }
	
	    while (++index < cellCount) {
	      position = row[index] ? dotindex(row[index]) : null
	
	      if (!sizes[index]) {
	        sizes[index] = MIN_CELL_SIZE
	      }
	
	      if (position > sizes[index]) {
	        sizes[index] = position
	      }
	    }
	  }
	
	  if (typeof alignment === 'string') {
	    alignment = pad(cellCount, alignment).split('')
	  }
	
	  /* Make sure only valid alignments are used. */
	  index = -1
	
	  while (++index < cellCount) {
	    align = alignment[index]
	
	    if (typeof align === 'string') {
	      align = align.charAt(0).toLowerCase()
	    }
	
	    if (ALLIGNMENT.indexOf(align) === -1) {
	      align = NULL
	    }
	
	    alignment[index] = align
	  }
	
	  rowIndex = -1
	  rows = []
	
	  while (++rowIndex < rowLength) {
	    row = table[rowIndex]
	
	    index = -1
	    cells = []
	
	    while (++index < cellCount) {
	      value = row[index]
	
	      value = stringify(value)
	
	      if (alignment[index] === DOT) {
	        position = dotindex(value)
	
	        size =
	          sizes[index] +
	          (EXPRESSION_DOT.test(value) ? 0 : 1) -
	          (calculateStringLength(value) - position)
	
	        cells[index] = value + pad(size - 1)
	      } else {
	        cells[index] = value
	      }
	    }
	
	    rows[rowIndex] = cells
	  }
	
	  sizes = []
	  rowIndex = -1
	
	  while (++rowIndex < rowLength) {
	    cells = rows[rowIndex]
	
	    index = -1
	
	    while (++index < cellCount) {
	      value = cells[index]
	
	      if (!sizes[index]) {
	        sizes[index] = MIN_CELL_SIZE
	      }
	
	      size = calculateStringLength(value)
	
	      if (size > sizes[index]) {
	        sizes[index] = size
	      }
	    }
	  }
	
	  rowIndex = -1
	
	  while (++rowIndex < rowLength) {
	    cells = rows[rowIndex]
	
	    index = -1
	
	    if (settings.pad !== false) {
	      while (++index < cellCount) {
	        value = cells[index]
	
	        position = sizes[index] - (calculateStringLength(value) || 0)
	        spacing = pad(position)
	
	        if (alignment[index] === RIGHT || alignment[index] === DOT) {
	          value = spacing + value
	        } else if (alignment[index] === CENTER) {
	          position /= 2
	
	          if (position % 1 === 0) {
	            before = position
	            after = position
	          } else {
	            before = position + 0.5
	            after = position - 0.5
	          }
	
	          value = pad(before) + value + pad(after)
	        } else {
	          value += spacing
	        }
	
	        cells[index] = value
	      }
	    }
	
	    rows[rowIndex] = cells.join(delimiter)
	  }
	
	  if (settings.rule !== false) {
	    index = -1
	    rule = []
	
	    while (++index < cellCount) {
	      /* When `pad` is false, make the rule the same size as the first row. */
	      if (settings.pad === false) {
	        value = table[0][index]
	        spacing = calculateStringLength(stringify(value))
	        spacing = spacing > MIN_CELL_SIZE ? spacing : MIN_CELL_SIZE
	      } else {
	        spacing = sizes[index]
	      }
	
	      align = alignment[index]
	
	      /* When `align` is left, don't add colons. */
	      value = align === RIGHT || align === NULL ? DASH : COLON
	      value += pad(spacing - 2, DASH)
	      value += align !== LEFT && align !== NULL ? COLON : DASH
	
	      rule[index] = value
	    }
	
	    rows.splice(1, 0, rule.join(delimiter))
	  }
	
	  return start + rows.join(end + NEW_LINE + start) + end
	}
	
	function stringify(value) {
	  return value === null || value === undefined ? '' : String(value)
	}
	
	/* Get the length of `value`. */
	function lengthNoop(value) {
	  return String(value).length
	}
	
	/* Get a string consisting of `length` `character`s. */
	function pad(length, character) {
	  return new Array(length + 1).join(character || SPACE)
	}
	
	/* Get the position of the last dot in `value`. */
	function dotindex(value) {
	  var match = EXPRESSION_LAST_DOT.exec(value)
	
	  return match ? match.index + 1 : value.length
	}


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = marker;
	
	/* HTML type. */
	var T_HTML = 'html';
	
	/* Expression for eliminating extra spaces */
	var SPACES = /\s+/g;
	
	/* Expression for parsing parameters. */
	var PARAMETERS = new RegExp(
	  '\\s+' +
	  '(' +
	    '[-a-z0-9_]+' +
	  ')' +
	  '(?:' +
	    '=' +
	    '(?:' +
	      '"' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^"]' +
	        ')+' +
	      ')' +
	      '"' +
	      '|' +
	      '\'' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^\']' +
	        ')+' +
	      ')' +
	      '\'' +
	      '|' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^"\'\\s]' +
	        ')+' +
	      ')' +
	    ')' +
	  ')?',
	  'gi'
	);
	
	var MARKER = new RegExp(
	  '(' +
	    '\\s*' +
	    '<!--' +
	    '\\s*' +
	    '([a-zA-Z0-9-]+)' +
	    '(\\s+([\\s\\S]*?))?' +
	    '\\s*' +
	    '-->' +
	    '\\s*' +
	  ')'
	);
	
	/* Parse a comment marker */
	function marker(node) {
	  var value;
	  var match;
	  var params;
	
	  if (!node || node.type !== T_HTML) {
	    return null;
	  }
	
	  value = node.value;
	  match = value.match(MARKER);
	
	  if (!match || match[1].length !== value.length) {
	    return null;
	  }
	
	  params = parameters(match[3] || '');
	
	  if (!params) {
	    return null;
	  }
	
	  return {
	    name: match[2],
	    attributes: match[4] || '',
	    parameters: params,
	    node: node
	  };
	}
	
	/* eslint-disable max-params */
	
	/* Parse `value` into an object. */
	function parameters(value) {
	  var attributes = {};
	  var rest = value.replace(PARAMETERS, function ($0, $1, $2, $3, $4) {
	    var result = $2 || $3 || $4 || '';
	
	    if (result === 'true' || result === '') {
	      result = true;
	    } else if (result === 'false') {
	      result = false;
	    } else if (!isNaN(result)) {
	      result = Number(result);
	    }
	
	    attributes[$1] = result;
	
	    return '';
	  });
	
	  return rest.replace(SPACES, '') ? null : attributes;
	}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var visit = __webpack_require__(4);
	var modify = __webpack_require__(336);
	
	/* Expose. */
	module.exports = compact;
	
	/* Make an MDAST tree compact by merging adjacent text
	 * nodes. */
	function compact(tree, commonmark) {
	  var modifier = modify(iterator);
	
	  visit(tree, visitor);
	
	  return tree;
	
	  function visitor(node) {
	    if (node.children) {
	      modifier(node);
	    }
	  }
	
	  function iterator(child, index, parent) {
	    var siblings = parent.children;
	    var prev = index && siblings[index - 1];
	
	    if (
	      prev &&
	      child.type === prev.type &&
	      mergeable(prev, commonmark) &&
	      mergeable(child, commonmark)
	    ) {
	      if (child.value) {
	        prev.value += child.value;
	      }
	
	      if (child.children) {
	        prev.children = prev.children.concat(child.children);
	      }
	
	      siblings.splice(index, 1);
	
	      if (prev.position && child.position) {
	        prev.position.end = child.position.end;
	      }
	
	      return index;
	    }
	  }
	}
	
	function mergeable(node, commonmark) {
	  var start;
	  var end;
	
	  if (node.type === 'text') {
	    if (!node.position) {
	      return true;
	    }
	
	    start = node.position.start;
	    end = node.position.end;
	
	    /* Only merge nodes which occupy the same size as their `value`. */
	    return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	  }
	
	  return commonmark && node.type === 'blockquote';
	}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(4);
	
	module.exports = getDefinitionFactory;
	
	var own = {}.hasOwnProperty;
	
	/* Get a definition in `node` by `identifier`. */
	function getDefinitionFactory(node, options) {
	  return getterFactory(gather(node, options));
	}
	
	/* Gather all definitions in `node` */
	function gather(node, options) {
	  var cache = {};
	
	  if (!node || !node.type) {
	    throw new Error('mdast-util-definitions expected node');
	  }
	
	  visit(node, 'definition', options && options.commonmark ? commonmark : normal);
	
	  return cache;
	
	  function commonmark(definition) {
	    var id = normalise(definition.identifier);
	    if (!own.call(cache, id)) {
	      cache[id] = definition;
	    }
	  }
	
	  function normal(definition) {
	    cache[normalise(definition.identifier)] = definition;
	  }
	}
	
	/* Factory to get a node from the given definition-cache. */
	function getterFactory(cache) {
	  return getter;
	
	  /* Get a node from the bound definition-cache. */
	  function getter(identifier) {
	    var id = identifier && normalise(identifier);
	    return id && own.call(cache, id) ? cache[id] : null;
	  }
	}
	
	function normalise(identifier) {
	  return identifier.toUpperCase();
	}


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = style;
	
	/* Check the style of a heading. */
	function style(node, relative) {
	  var last = node.children[node.children.length - 1];
	  var depth = node.depth;
	  var pos = node && node.position && node.position.end;
	  var final = last && last.position && last.position.end;
	
	  if (!pos) {
	    return null;
	  }
	
	  /* This can only occur for `'atx'` and `'atx-closed'`
	   * headings.  This might incorrectly match `'atx'`
	   * headings with lots of trailing white space as an
	   * `'atx-closed'` heading. */
	  if (!last) {
	    if (pos.column - 1 <= depth * 2) {
	      return consolidate(depth, relative);
	    }
	
	    return 'atx-closed';
	  }
	
	  if (final.line + 1 === pos.line) {
	    return 'setext';
	  }
	
	  if (final.column + depth < pos.column) {
	    return 'atx-closed';
	  }
	
	  return consolidate(depth, relative);
	}
	
	/* Get the probable style of an atx-heading, depending on
	 * preferred style. */
	function consolidate(depth, relative) {
	  return depth < 3 ? 'atx' : relative === 'atx' || relative === 'setext' ? relative : null;
	}


/***/ }),
/* 198 */,
/* 199 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(8);
	var toHAST = __webpack_require__(207);
	var toHTML = __webpack_require__(167);
	var sanitize = __webpack_require__(165);
	
	module.exports = plugin;
	
	function plugin(options) {
	  var settings = options || {};
	  var clean = settings.sanitize;
	  var schema = clean && typeof clean === 'object' ? clean : null;
	  var handlers = settings.handlers || {};
	
	  this.Compiler = compiler;
	
	  function compiler(node, file) {
	    var root = node && node.type && node.type === 'root';
	    var hast = toHAST(node, {allowDangerousHTML: !clean, handlers: handlers});
	    var result;
	
	    if (file.extname) {
	      file.extname = '.html';
	    }
	
	    if (clean) {
	      hast = sanitize(hast, schema);
	    }
	
	    result = toHTML(hast, xtend(settings, {
	      allowDangerousHTML: !clean
	    }));
	
	    /* Add a final newline. */
	    if (root && result.charAt(result.length - 1) !== '\n') {
	      result += '\n';
	    }
	
	    return result;
	  }
	}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	module.exports = __webpack_require__(229)


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = generateFootnotes
	
	var thematicBreak = __webpack_require__(86)
	var list = __webpack_require__(85)
	var wrap = __webpack_require__(17)
	
	/* Transform all footnote definitions, if any. */
	function generateFootnotes(h) {
	  var footnotes = h.footnotes
	  var length = footnotes.length
	  var index = -1
	  var listItems = []
	  var def
	
	  if (!length) {
	    return null
	  }
	
	  while (++index < length) {
	    def = footnotes[index]
	
	    listItems[index] = {
	      type: 'listItem',
	      data: {hProperties: {id: 'fn-' + def.identifier}},
	      children: def.children.concat({
	        type: 'link',
	        url: '#fnref-' + def.identifier,
	        data: {hProperties: {className: ['footnote-backref']}},
	        children: [{type: 'text', value: '↩'}]
	      }),
	      position: def.position
	    }
	  }
	
	  return h(
	    null,
	    'div',
	    {className: ['footnotes']},
	    wrap(
	      [
	        thematicBreak(h),
	        list(h, {
	          type: 'list',
	          ordered: true,
	          children: listItems
	        })
	      ],
	      true
	    )
	  )
	}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = blockquote
	
	var wrap = __webpack_require__(17)
	var all = __webpack_require__(7)
	
	/* Transform a block quote. */
	function blockquote(h, node) {
	  return h(node, 'blockquote', wrap(all(h, node), true))
	}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = hardBreak
	
	var u = __webpack_require__(11)
	
	/* Transform an inline break. */
	function hardBreak(h, node) {
	  return [h(node, 'br'), u('text', '\n')]
	}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = code
	
	var detab = __webpack_require__(155)
	var u = __webpack_require__(11)
	
	/* Transform a code block. */
	function code(h, node) {
	  var value = node.value ? detab(node.value + '\n') : ''
	  var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/)
	  var props = {}
	
	  if (lang) {
	    props.className = ['language-' + lang]
	  }
	
	  return h(node.position, 'pre', [h(node, 'code', props, [u('text', value)])])
	}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = strikethrough
	
	var all = __webpack_require__(7)
	
	/* Transform deletions. */
	function strikethrough(h, node) {
	  return h(node, 'del', all(h, node))
	}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = emphasis
	
	var all = __webpack_require__(7)
	
	/* Transform emphasis. */
	function emphasis(h, node) {
	  return h(node, 'em', all(h, node))
	}


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = footnote
	
	var footnoteReference = __webpack_require__(84)
	
	/* Transform an inline footnote. */
	function footnote(h, node) {
	  var identifiers = []
	  var identifier = 1
	  var footnotes = h.footnotes
	  var length = footnotes.length
	  var index = -1
	
	  while (++index < length) {
	    identifiers[index] = footnotes[index].identifier
	  }
	
	  while (identifiers.indexOf(String(identifier)) !== -1) {
	    identifier++
	  }
	
	  identifier = String(identifier)
	
	  footnotes.push({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: [{type: 'paragraph', children: node.children}],
	    position: node.position
	  })
	
	  return footnoteReference(h, {
	    type: 'footnoteReference',
	    identifier: identifier,
	    position: node.position
	  })
	}


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = heading
	
	var all = __webpack_require__(7)
	
	/* Transform a heading. */
	function heading(h, node) {
	  return h(node, 'h' + node.depth, all(h, node))
	}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = html
	
	var u = __webpack_require__(11)
	
	/* Return either a `raw` node, in dangerous mode, or
	 * nothing. */
	function html(h, node) {
	  return h.dangerous ? h.augment(node, u('raw', node.value)) : null
	}


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = imageReference
	
	var normalize = __webpack_require__(24)
	var failsafe = __webpack_require__(83)
	
	/* Transform a reference to an image. */
	function imageReference(h, node) {
	  var def = h.definition(node.identifier)
	  var props = {src: normalize((def && def.url) || ''), alt: node.alt}
	
	  if (def && def.title !== null && def.title !== undefined) {
	    props.title = def.title
	  }
	
	  return failsafe(h, node, def) || h(node, 'img', props)
	}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(24)
	
	module.exports = image
	
	/* Transform an image. */
	function image(h, node) {
	  var props = {src: normalize(node.url), alt: node.alt}
	
	  if (node.title !== null && node.title !== undefined) {
	    props.title = node.title
	  }
	
	  return h(node, 'img', props)
	}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = {
	  blockquote: __webpack_require__(209),
	  break: __webpack_require__(210),
	  code: __webpack_require__(211),
	  delete: __webpack_require__(212),
	  emphasis: __webpack_require__(213),
	  footnoteReference: __webpack_require__(84),
	  footnote: __webpack_require__(214),
	  heading: __webpack_require__(215),
	  html: __webpack_require__(216),
	  imageReference: __webpack_require__(217),
	  image: __webpack_require__(218),
	  inlineCode: __webpack_require__(220),
	  linkReference: __webpack_require__(221),
	  link: __webpack_require__(222),
	  listItem: __webpack_require__(223),
	  list: __webpack_require__(85),
	  paragraph: __webpack_require__(224),
	  root: __webpack_require__(225),
	  strong: __webpack_require__(226),
	  table: __webpack_require__(227),
	  text: __webpack_require__(228),
	  thematicBreak: __webpack_require__(86),
	  toml: ignore,
	  yaml: ignore,
	  definition: ignore,
	  footnoteDefinition: ignore
	}
	
	/* Return nothing for nodes which are ignored. */
	function ignore() {
	  return null
	}


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = inlineCode
	
	var collapse = __webpack_require__(59)
	var u = __webpack_require__(11)
	
	/* Transform inline code. */
	function inlineCode(h, node) {
	  return h(node, 'code', [u('text', collapse(node.value))])
	}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = linkReference
	
	var normalize = __webpack_require__(24)
	var failsafe = __webpack_require__(83)
	var all = __webpack_require__(7)
	
	/* Transform a reference to a link. */
	function linkReference(h, node) {
	  var def = h.definition(node.identifier)
	  var props = {href: normalize((def && def.url) || '')}
	
	  if (def && def.title !== null && def.title !== undefined) {
	    props.title = def.title
	  }
	
	  return failsafe(h, node, def) || h(node, 'a', props, all(h, node))
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(24)
	var all = __webpack_require__(7)
	
	module.exports = link
	
	/* Transform a link. */
	function link(h, node) {
	  var props = {href: normalize(node.url)}
	
	  if (node.title !== null && node.title !== undefined) {
	    props.title = node.title
	  }
	
	  return h(node, 'a', props, all(h, node))
	}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = listItem
	
	var u = __webpack_require__(11)
	var wrap = __webpack_require__(17)
	var all = __webpack_require__(7)
	
	/* Transform a list-item. */
	function listItem(h, node, parent) {
	  var children = node.children
	  var head = children[0]
	  var props = {}
	  var single = false
	  var result
	  var container
	
	  if (
	    (!parent || !parent.loose) &&
	    children.length === 1 &&
	    head.type === 'paragraph'
	  ) {
	    single = true
	  }
	
	  result = all(h, single ? head : node)
	
	  if (typeof node.checked === 'boolean') {
	    if (!single && (!head || head.type !== 'paragraph')) {
	      result.unshift(h(null, 'p', []))
	    }
	
	    container = single ? result : result[0].children
	
	    if (container.length !== 0) {
	      container.unshift(u('text', ' '))
	    }
	
	    container.unshift(
	      h(null, 'input', {
	        type: 'checkbox',
	        checked: node.checked,
	        disabled: true
	      })
	    )
	
	    /* According to github-markdown-css, this class hides bullet. */
	    props.className = ['task-list-item']
	  }
	
	  if (!single && result.length !== 0) {
	    result = wrap(result, true)
	  }
	
	  return h(node, 'li', props, result)
	}


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = paragraph
	
	var all = __webpack_require__(7)
	
	/* Transform a paragraph. */
	function paragraph(h, node) {
	  return h(node, 'p', all(h, node))
	}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = root
	
	var u = __webpack_require__(11)
	var wrap = __webpack_require__(17)
	var all = __webpack_require__(7)
	
	/* Transform a `root`. */
	function root(h, node) {
	  return h.augment(node, u('root', wrap(all(h, node))))
	}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = strong
	
	var all = __webpack_require__(7)
	
	/* Transform importance. */
	function strong(h, node) {
	  return h(node, 'strong', all(h, node))
	}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = table
	
	var position = __webpack_require__(12)
	var wrap = __webpack_require__(17)
	var all = __webpack_require__(7)
	
	/* Transform a table. */
	function table(h, node) {
	  var rows = node.children
	  var index = rows.length
	  var align = node.align
	  var alignLength = align.length
	  var result = []
	  var pos
	  var row
	  var out
	  var name
	  var cell
	
	  while (index--) {
	    row = rows[index].children
	    name = index === 0 ? 'th' : 'td'
	    pos = alignLength
	    out = []
	
	    while (pos--) {
	      cell = row[pos]
	      out[pos] = h(cell, name, {align: align[pos]}, cell ? all(h, cell) : [])
	    }
	
	    result[index] = h(rows[index], 'tr', wrap(out, true))
	  }
	
	  return h(
	    node,
	    'table',
	    wrap(
	      [
	        h(result[0].position, 'thead', wrap([result[0]], true)),
	        h(
	          {
	            start: position.start(result[1]),
	            end: position.end(result[result.length - 1])
	          },
	          'tbody',
	          wrap(result.slice(1), true)
	        )
	      ],
	      true
	    )
	  )
	}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = text
	
	var u = __webpack_require__(11)
	var trimLines = __webpack_require__(332)
	
	/* Transform text. */
	function text(h, node) {
	  return h.augment(node, u('text', trimLines(node.value)))
	}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = toHAST
	
	var xtend = __webpack_require__(8)
	var u = __webpack_require__(11)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	var definitions = __webpack_require__(196)
	var one = __webpack_require__(87)
	var footer = __webpack_require__(208)
	var handlers = __webpack_require__(219)
	
	/* Factory to transform. */
	function factory(tree, options) {
	  var settings = options || {}
	  var dangerous = settings.allowDangerousHTML
	
	  h.dangerous = dangerous
	  h.definition = definitions(tree, settings)
	  h.footnotes = []
	  h.augment = augment
	  h.handlers = xtend(handlers, settings.handlers || {})
	
	  visit(tree, 'footnoteDefinition', visitor)
	
	  return h
	
	  /* Finalise the created `right`, a HAST node, from
	   * `left`, an MDAST node.   */
	  function augment(left, right) {
	    var data
	    var ctx
	
	    /* Handle `data.hName`, `data.hProperties, `hChildren`. */
	    if (left && 'data' in left) {
	      data = left.data
	
	      if (right.type === 'element' && data.hName) {
	        right.tagName = data.hName
	      }
	
	      if (right.type === 'element' && data.hProperties) {
	        right.properties = xtend(right.properties, data.hProperties)
	      }
	
	      if (right.children && data.hChildren) {
	        right.children = data.hChildren
	      }
	    }
	
	    ctx = left && left.position ? left : {position: left}
	
	    if (!generated(ctx)) {
	      right.position = {
	        start: position.start(ctx),
	        end: position.end(ctx)
	      }
	    }
	
	    return right
	  }
	
	  /* Create an element for a `node`. */
	  function h(node, tagName, props, children) {
	    if (
	      (children === undefined || children === null) &&
	      typeof props === 'object' &&
	      'length' in props
	    ) {
	      children = props
	      props = {}
	    }
	
	    return augment(node, {
	      type: 'element',
	      tagName: tagName,
	      properties: props || {},
	      children: children || []
	    })
	  }
	
	  function visitor(definition) {
	    h.footnotes.push(definition)
	  }
	}
	
	/* Transform `tree`, which is an MDAST node, to a HAST node. */
	function toHAST(tree, options) {
	  var h = factory(tree, options)
	  var node = one(h, tree)
	  var footnotes = footer(h)
	
	  if (node && node.children && footnotes) {
	    node.children = node.children.concat(u('text', '\n'), footnotes)
	  }
	
	  return node
	}


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module final-newline
	 * @fileoverview
	 *   Warn when a newline at the end of a file is missing. Empty files are allowed.
	 *
	 *   See [StackExchange](http://unix.stackexchange.com/questions/18743) for why.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   always adds a final newline to files.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 *   ## Example
	 *
	 *   ##### `valid.md`
	 *
	 *   ###### In
	 *
	 *   Note: `␊` represents LF.
	 *
	 *   ```markdown
	 *   Alpha␊
	 *   ```
	 *
	 *   ###### Out
	 *
	 *   No messages.
	 *
	 *   ##### `invalid.md`
	 *
	 *   ###### In
	 *
	 *   Note: The below file does not have a final newline.
	 *
	 *   ```markdown
	 *   Bravo
	 *   ```
	 *
	 *   ###### Out
	 *
	 *   ```text
	 *   1:1: Missing newline character at end of file
	 *   ```
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	
	module.exports = rule('remark-lint:final-newline', finalNewline)
	
	function finalNewline(tree, file) {
	  var contents = String(file)
	  var last = contents.length - 1
	
	  if (last > -1 && contents.charAt(last) !== '\n') {
	    file.message('Missing newline character at end of file')
	  }
	}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module hard-break-spaces
	 * @fileoverview
	 *   Warn when too many spaces are used to create a hard break.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Lorem ipsum··
	 *   dolor sit amet
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Lorem ipsum···
	 *   dolor sit amet.
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:12-2:1: Use two spaces for hard line breaks
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule('remark-lint:hard-break-spaces', hardBreakSpaces)
	
	var reason = 'Use two spaces for hard line breaks'
	
	function hardBreakSpaces(tree, file) {
	  var contents = String(file)
	
	  visit(tree, 'break', visitor)
	
	  function visitor(node) {
	    var value
	
	    if (!generated(node)) {
	      value = contents
	        .slice(position.start(node).offset, position.end(node).offset)
	        .split('\n', 1)[0]
	        .replace(/\r$/, '')
	
	      if (value.length > 2) {
	        file.message(reason, node)
	      }
	    }
	  }
	}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module list-item-bullet-indent
	 * @fileoverview
	 *   Warn when list item bullets are indented.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   removes all indentation before bullets.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Paragraph.
	 *
	 *   * List item
	 *   * List item
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Paragraph.
	 *
	 *   ·* List item
	 *   ·* List item
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   3:3: Incorrect indentation before bullet: remove 1 space
	 *   4:3: Incorrect indentation before bullet: remove 1 space
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var plural = __webpack_require__(37)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:list-item-bullet-indent',
	  listItemBulletIndent
	)
	
	var start = position.start
	
	function listItemBulletIndent(tree, file) {
	  var contents = String(file)
	
	  visit(tree, 'list', visitor)
	
	  function visitor(node) {
	    node.children.forEach(visitItems)
	  }
	
	  function visitItems(item) {
	    var final
	    var indent
	    var reason
	
	    if (!generated(item)) {
	      final = start(item.children[0])
	      indent = contents.slice(start(item).offset, final.offset).match(/^\s*/)[0]
	        .length
	
	      if (indent !== 0) {
	        reason =
	          'Incorrect indentation before bullet: remove ' +
	          indent +
	          ' ' +
	          plural('space', indent)
	
	        file.message(reason, {
	          line: final.line,
	          column: final.column - indent
	        })
	      }
	    }
	  }
	}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module list-item-indent
	 * @fileoverview
	 *   Warn when the spacing between a list item’s bullet and its content
	 *   violates a given style.
	 *
	 *   Options: `'tab-size'`, `'mixed'`, or `'space'`, default: `'tab-size'`.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   uses `'tab-size'` (named `'tab'` there) by default to ensure markdown is
	 *   seen the same way across vendors. This can be configured with the
	 *   [`listItemIndent`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify#optionslistitemindent)
	 *   option. This rule’s `'space'` option is named `'1'` there.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List
	 *   ····item.
	 *
	 *   Paragraph.
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "valid.md", "setting": "mixed"}
	 *
	 *   *·List item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List item
	 *
	 *   Paragraph.
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "valid.md", "setting": "space"}
	 *
	 *   *·List item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List item
	 *
	 *   Paragraph.
	 *
	 *   *·List
	 *   ··item.
	 *
	 *   *·List
	 *   ··item.
	 *
	 * @example {"name": "invalid.md", "setting": "space", "label": "input"}
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "invalid.md", "setting": "space", "label": "output"}
	 *
	 *    1:5: Incorrect list-item indent: remove 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "tab-size", "label": "input"}
	 *
	 *   *·List
	 *   ··item.
	 *
	 * @example {"name": "invalid.md", "setting": "tab-size", "label": "output"}
	 *
	 *    1:3: Incorrect list-item indent: add 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "mixed", "label": "input"}
	 *
	 *   *···List item.
	 *
	 * @example {"name": "invalid.md", "setting": "mixed", "label": "output"}
	 *
	 *    1:5: Incorrect list-item indent: remove 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "invalid", "label": "output", "config": {"positionless": true}}
	 *
	 *    1:1: Invalid list-item indent style `invalid`: use either `'tab-size'`, `'space'`, or `'mixed'`
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var plural = __webpack_require__(37)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule('remark-lint:list-item-indent', listItemIndent)
	
	var start = position.start
	
	var styles = {'tab-size': true, mixed: true, space: true}
	
	function listItemIndent(tree, file, pref) {
	  var contents = String(file)
	
	  pref = typeof pref === 'string' ? pref : 'tab-size'
	
	  if (styles[pref] !== true) {
	    file.fail(
	      'Invalid list-item indent style `' +
	        pref +
	        "`: use either `'tab-size'`, `'space'`, or `'mixed'`"
	    )
	  }
	
	  visit(tree, 'list', visitor)
	
	  function visitor(node) {
	    var loose = node.loose
	
	    if (!generated(node)) {
	      node.children.forEach(visitItem)
	    }
	
	    function visitItem(item) {
	      var head = item.children[0]
	      var final = start(head)
	      var marker
	      var bulletSize
	      var style
	      var diff
	      var reason
	
	      marker = contents
	        .slice(start(item).offset, final.offset)
	        .replace(/\[[x ]?]\s*$/i, '')
	
	      bulletSize = marker.trimRight().length
	
	      style =
	        pref === 'tab-size' || (pref === 'mixed' && loose)
	          ? Math.ceil(bulletSize / 4) * 4
	          : bulletSize + 1
	
	      if (marker.length !== style) {
	        diff = style - marker.length
	
	        reason =
	          'Incorrect list-item indent: ' +
	          (diff > 0 ? 'add' : 'remove') +
	          ' ' +
	          Math.abs(diff) +
	          ' ' +
	          plural('space', diff)
	
	        file.message(reason, final)
	      }
	    }
	  }
	}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-auto-link-without-protocol
	 * @fileoverview
	 *   Warn for angle-bracketed links without protocol.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   adds a protocol where needed.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   <http://www.example.com>
	 *   <mailto:foo@bar.com>
	 *
	 *   Most markdown vendors don’t recognize the following as a link:
	 *   <www.example.com>
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   <foo@bar.com>
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:14: All automatic links must start with a protocol
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	var toString = __webpack_require__(36)
	
	module.exports = rule(
	  'remark-lint:no-auto-link-without-protocol',
	  noAutoLinkWithoutProtocol
	)
	
	var start = position.start
	var end = position.end
	
	/* Protocol expression. See:
	 * http://en.wikipedia.org/wiki/URI_scheme#Generic_syntax */
	var protocol = /^[a-z][a-z+.-]+:\/?/i
	
	var reason = 'All automatic links must start with a protocol'
	
	function noAutoLinkWithoutProtocol(tree, file) {
	  visit(tree, 'link', visitor)
	
	  function visitor(node) {
	    var children
	
	    if (!generated(node)) {
	      children = node.children
	
	      if (
	        start(node).column === start(children[0]).column - 1 &&
	        end(node).column === end(children[children.length - 1]).column + 1 &&
	        !protocol.test(toString(node))
	      ) {
	        file.message(reason, node)
	      }
	    }
	  }
	}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-blockquote-without-marker
	 * @fileoverview
	 *   Warn when blank lines without markers (`>`) are found in a blockquote.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   adds markers to every line in a blockquote.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   > Foo...
	 *   >
	 *   > ...Bar.
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   > Foo...
	 *
	 *   > ...Bar.
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   2:1: Missing marker in blockquote
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var vfileLocation = __webpack_require__(44)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:no-blockquote-without-marker',
	  noBlockquoteWithoutMarker
	)
	
	var reason = 'Missing marker in blockquote'
	
	function noBlockquoteWithoutMarker(tree, file) {
	  var contents = String(file)
	  var location = vfileLocation(file)
	  var last = contents.length
	
	  visit(tree, 'blockquote', visitor)
	
	  function visitor(node) {
	    var indent = node.position && node.position.indent
	    var start
	    var length
	    var index
	    var line
	    var offset
	    var character
	    var pos
	
	    if (generated(node) || !indent || indent.length === 0) {
	      return
	    }
	
	    start = position.start(node).line
	    length = indent.length
	    index = -1
	
	    while (++index < length) {
	      line = start + index + 1
	      pos = {line: line, column: indent[index]}
	      offset = location.toOffset(pos) - 1
	
	      while (++offset < last) {
	        character = contents.charAt(offset)
	
	        if (character === '>') {
	          break
	        }
	
	        /* istanbul ignore else - just for safety */
	        if (character !== ' ' && character !== '\t') {
	          file.message(reason, pos)
	          break
	        }
	      }
	    }
	  }
	}


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-duplicate-definitions
	 * @fileoverview
	 *   Warn when duplicate definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo]: bar
	 *   [baz]: qux
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [foo]: bar
	 *   [foo]: qux
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   2:1-2:11: Do not use definitions with the same identifier (1:1)
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	var stringify = __webpack_require__(100)
	var visit = __webpack_require__(4)
	
	module.exports = rule(
	  'remark-lint:no-duplicate-definitions',
	  noDuplicateDefinitions
	)
	
	var reason = 'Do not use definitions with the same identifier'
	
	function noDuplicateDefinitions(tree, file) {
	  var map = {}
	
	  visit(tree, ['definition', 'footnoteDefinition'], validate)
	
	  function validate(node) {
	    var identifier
	    var duplicate
	
	    if (!generated(node)) {
	      identifier = node.identifier
	      duplicate = map[identifier]
	
	      if (duplicate && duplicate.type) {
	        file.message(
	          reason + ' (' + stringify(position.start(duplicate)) + ')',
	          node
	        )
	      }
	
	      map[identifier] = node
	    }
	  }
	}


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-heading-content-indent
	 * @fileoverview
	 *   Warn when a heading’s content is indented.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   removes all unneeded padding around a heading’s content.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   #·Foo
	 *
	 *   ## Bar·##
	 *
	 *     ##·Baz
	 *
	 *   Setext headings are not affected.
	 *
	 *   Baz
	 *   ===
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   #··Foo
	 *
	 *   ## Bar··##
	 *
	 *     ##··Baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:4: Remove 1 space before this heading’s content
	 *   3:7: Remove 1 space after this heading’s content
	 *   5:7: Remove 1 space before this heading’s content
	 *
	 * @example {"name": "empty-heading.md"}
	 *
	 *   #··
	 *
	 * @example {"name": "tight.md", "config":{"pedantic":true}, "label": "input"}
	 *
	 *   In pedantic mode, headings without spacing can also be detected:
	 *
	 *   ##No spacing left, too much right··##
	 *
	 * @example {"name": "tight.md", "label": "output"}
	 *
	 *   3:3: Add 1 space before this heading’s content
	 *   3:34: Remove 1 space after this heading’s content
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var style = __webpack_require__(197)
	var plural = __webpack_require__(37)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:no-heading-content-indent',
	  noHeadingContentIndent
	)
	
	var start = position.start
	var end = position.end
	
	function noHeadingContentIndent(tree, file) {
	  var contents = String(file)
	
	  visit(tree, 'heading', visitor)
	
	  function visitor(node) {
	    var depth
	    var children
	    var type
	    var head
	    var initial
	    var final
	    var diff
	    var index
	    var char
	    var reason
	
	    if (generated(node)) {
	      return
	    }
	
	    depth = node.depth
	    children = node.children
	    type = style(node, 'atx')
	
	    if (type === 'atx' || type === 'atx-closed') {
	      initial = start(node)
	      index = initial.offset
	      char = contents.charAt(index)
	
	      while (char && char !== '#') {
	        char = contents.charAt(++index)
	      }
	
	      /* istanbul ignore if - CR/LF bug: remarkjs/remark#195. */
	      if (!char) {
	        return
	      }
	
	      index = depth + (index - initial.offset)
	      head = start(children[0]).column
	
	      /* Ignore empty headings. */
	      if (!head) {
	        return
	      }
	
	      diff = head - initial.column - 1 - index
	
	      if (diff) {
	        reason =
	          (diff > 0 ? 'Remove' : 'Add') +
	          ' ' +
	          Math.abs(diff) +
	          ' ' +
	          plural('space', diff) +
	          ' before this heading’s content'
	
	        file.message(reason, start(children[0]))
	      }
	    }
	
	    /* Closed ATX-heading always must have a space
	     * between their content and the final hashes,
	     * thus, there is no `add x spaces`. */
	    if (type === 'atx-closed') {
	      final = end(children[children.length - 1])
	      diff = end(node).column - final.column - 1 - depth
	
	      if (diff) {
	        reason =
	          'Remove ' +
	          diff +
	          ' ' +
	          plural('space', diff) +
	          ' after this heading’s content'
	
	        file.message(reason, final)
	      }
	    }
	  }
	}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-inline-padding
	 * @fileoverview
	 *   Warn when inline nodes are padded with spaces between their markers and
	 *   content.
	 *
	 *   Warns for emphasis, strong, delete, images, and links.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Alpha, *bravo*, _charlie_, [delta](http://echo.fox/trot)
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Alpha, * bravo *, _ charlie _, [ delta ](http://echo.fox/trot)
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:8-1:17: Don’t pad `emphasis` with inner spaces
	 *   1:19-1:30: Don’t pad `emphasis` with inner spaces
	 *   1:32-1:63: Don’t pad `link` with inner spaces
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var generated = __webpack_require__(6)
	var toString = __webpack_require__(36)
	
	module.exports = rule('remark-lint:no-inline-padding', noInlinePadding)
	
	function noInlinePadding(tree, file) {
	  visit(tree, ['emphasis', 'strong', 'delete', 'image', 'link'], visitor)
	
	  function visitor(node) {
	    var contents
	
	    if (!generated(node)) {
	      contents = toString(node)
	
	      if (
	        contents.charAt(0) === ' ' ||
	        contents.charAt(contents.length - 1) === ' '
	      ) {
	        file.message('Don’t pad `' + node.type + '` with inner spaces', node)
	      }
	    }
	  }
	}


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-literal-urls
	 * @fileoverview
	 *   Warn when URLs without angle-brackets are used.
	 *
	 *   ## Fix
	 *
	 *   [`remark-stringify`](https://github.com/remarkjs/remark/tree/master/packages/remark-stringify)
	 *   never creates literal URLs and always uses angle-brackets.
	 *
	 *   See [Using remark to fix your markdown](https://github.com/remarkjs/remark-lint#using-remark-to-fix-your-markdown)
	 *   on how to automatically fix warnings for this rule.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   <http://foo.bar/baz>
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:19: Don’t use literal URLs without angle brackets
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	var toString = __webpack_require__(36)
	
	module.exports = rule('remark-lint:no-literal-urls', noLiteralURLs)
	
	var start = position.start
	var end = position.end
	var mailto = 'mailto:'
	var reason = 'Don’t use literal URLs without angle brackets'
	
	function noLiteralURLs(tree, file) {
	  visit(tree, 'link', visitor)
	
	  function visitor(node) {
	    var children = node.children
	    var value = toString(node)
	
	    if (
	      !generated(node) &&
	      start(node).column === start(children[0]).column &&
	      end(node).column === end(children[children.length - 1]).column &&
	      (node.url === mailto + value || node.url === value)
	    ) {
	      file.message(reason, node)
	    }
	  }
	}


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-shortcut-reference-image
	 * @fileoverview
	 *   Warn when shortcut reference images are used.
	 *
	 *   Shortcut references render as images when a definition is found, and as
	 *   plain text without definition.  Sometimes, you don’t intend to create an
	 *   image from the reference, but this rule still warns anyway.  In that case,
	 *   you can escape the reference like so: `!\[foo]`.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   ![foo][]
	 *
	 *   [foo]: http://foo.bar/baz.png
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   ![foo]
	 *
	 *   [foo]: http://foo.bar/baz.png
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:7: Use the trailing [] on reference images
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:no-shortcut-reference-image',
	  noShortcutReferenceImage
	)
	
	var reason = 'Use the trailing [] on reference images'
	
	function noShortcutReferenceImage(tree, file) {
	  visit(tree, 'imageReference', visitor)
	
	  function visitor(node) {
	    if (!generated(node) && node.referenceType === 'shortcut') {
	      file.message(reason, node)
	    }
	  }
	}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-shortcut-reference-link
	 * @fileoverview
	 *   Warn when shortcut reference links are used.
	 *
	 *   Shortcut references render as links when a definition is found, and as
	 *   plain text without definition.  Sometimes, you don’t intend to create a
	 *   link from the reference, but this rule still warns anyway.  In that case,
	 *   you can escape the reference like so: `\[foo]`.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [foo]
	 *
	 *   [foo]: http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:6: Use the trailing [] on reference links
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:no-shortcut-reference-link',
	  noShortcutReferenceLink
	)
	
	var reason = 'Use the trailing [] on reference links'
	
	function noShortcutReferenceLink(tree, file) {
	  visit(tree, 'linkReference', visitor)
	
	  function visitor(node) {
	    if (!generated(node) && node.referenceType === 'shortcut') {
	      file.message(reason, node)
	    }
	  }
	}


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module no-undefined-references
	 * @fileoverview
	 *   Warn when references to undefined definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [bar][]
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:8: Found reference to undefined definition
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var generated = __webpack_require__(6)
	var visit = __webpack_require__(4)
	
	module.exports = rule(
	  'remark-lint:no-undefined-references',
	  noUndefinedReferences
	)
	
	var reason = 'Found reference to undefined definition'
	
	function noUndefinedReferences(tree, file) {
	  var map = {}
	
	  visit(tree, ['definition', 'footnoteDefinition'], mark)
	  visit(tree, ['imageReference', 'linkReference', 'footnoteReference'], find)
	
	  function mark(node) {
	    if (!generated(node)) {
	      map[node.identifier.toUpperCase()] = true
	    }
	  }
	
	  function find(node) {
	    if (!generated(node) && !map[node.identifier.toUpperCase()]) {
	      file.message(reason, node)
	    }
	  }
	}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module no-unused-definitions
	 * @fileoverview
	 *   Warn when unused definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [bar]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:27: Found unused definition
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var generated = __webpack_require__(6)
	var visit = __webpack_require__(4)
	
	module.exports = rule('remark-lint:no-unused-definitions', noUnusedDefinitions)
	
	var reason = 'Found unused definition'
	
	function noUnusedDefinitions(tree, file) {
	  var map = {}
	  var identifier
	  var entry
	
	  visit(tree, ['definition', 'footnoteDefinition'], find)
	  visit(tree, ['imageReference', 'linkReference', 'footnoteReference'], mark)
	
	  for (identifier in map) {
	    entry = map[identifier]
	
	    if (!entry.used) {
	      file.message(reason, entry.node)
	    }
	  }
	
	  function find(node) {
	    if (!generated(node)) {
	      map[node.identifier.toUpperCase()] = {node: node, used: false}
	    }
	  }
	
	  function mark(node) {
	    var info = map[node.identifier.toUpperCase()]
	
	    if (!generated(node) && info) {
	      info.used = true
	    }
	  }
	}


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module ordered-list-marker-style
	 * @fileoverview
	 *   Warn when the list-item marker style of ordered lists violate a given
	 *   style.
	 *
	 *   Options: `'consistent'`, `'.'`, or `')'`, default: `'consistent'`.
	 *
	 *   `'consistent'` detects the first used list style and warns when subsequent
	 *   lists use different styles.
	 *
	 *   Note: `)` is only supported in CommonMark.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   1.  Foo
	 *
	 *
	 *   1.  Bar
	 *
	 *   Unordered lists are not affected by this rule.
	 *
	 *   * Foo
	 *
	 * @example {"name": "valid.md", "setting": "."}
	 *
	 *   1.  Foo
	 *
	 *   2.  Bar
	 *
	 * @example {"name": "valid.md", "setting": ")", "config": {"commonmark": true}}
	 *
	 *   <!-- This requires commonmark. -->
	 *
	 *   1)  Foo
	 *
	 *   2)  Bar
	 *
	 * @example {"name": "invalid.md", "label": "input", "config": {"commonmark": true}}
	 *
	 *   1.  Foo
	 *
	 *   2)  Bar
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   3:1-3:8: Marker style should be `.`
	 *
	 * @example {"name": "invalid.md", "label": "output", "setting": "!", "config": {"positionless": true}}
	 *
	 *   1:1: Invalid ordered list-item marker style `!`: use either `'.'` or `')'`
	 */
	
	'use strict'
	
	var rule = __webpack_require__(5)
	var visit = __webpack_require__(4)
	var position = __webpack_require__(12)
	var generated = __webpack_require__(6)
	
	module.exports = rule(
	  'remark-lint:ordered-list-marker-style',
	  orderedListMarkerStyle
	)
	
	var start = position.start
	
	var styles = {
	  ')': true,
	  '.': true,
	  null: true
	}
	
	function orderedListMarkerStyle(tree, file, pref) {
	  var contents = String(file)
	
	  pref = typeof pref !== 'string' || pref === 'consistent' ? null : pref
	
	  if (styles[pref] !== true) {
	    file.fail(
	      'Invalid ordered list-item marker style `' +
	        pref +
	        "`: use either `'.'` or `')'`"
	    )
	  }
	
	  visit(tree, 'list', visitor)
	
	  function visitor(node) {
	    var children = node.children
	    var length = node.ordered ? children.length : 0
	    var index = -1
	    var marker
	    var child
	
	    while (++index < length) {
	      child = children[index]
	
	      if (!generated(child)) {
	        marker = contents
	          .slice(start(child).offset, start(child.children[0]).offset)
	          .replace(/\s|\d/g, '')
	          .replace(/\[[x ]?]\s*$/i, '')
	
	        if (pref) {
	          if (marker !== pref) {
	            file.message('Marker style should be `' + pref + '`', child)
	          }
	        } else {
	          pref = marker
	        }
	      }
	    }
	  }
	}


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var control = __webpack_require__(246)
	
	module.exports = lint
	
	/* `remark-lint`.  This adds support for ignoring stuff from
	 * messages (`<!--lint ignore-->`).
	 * All rules are in their own packages and presets. */
	function lint() {
	  this.use(lintMessageControl)
	}
	
	function lintMessageControl() {
	  return control({name: 'lint', source: 'remark-lint'})
	}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var control = __webpack_require__(334);
	var marker = __webpack_require__(194);
	var xtend = __webpack_require__(8);
	
	module.exports = messageControl;
	
	function messageControl(options) {
	  var settings = options || {};
	
	  return control(xtend(options, {
	    marker: settings.marker || marker,
	    test: settings.test || 'html'
	  }));
	}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(99);
	var xtend = __webpack_require__(8);
	var Parser = __webpack_require__(257);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:decode
	 * @fileoverview Decode entities.
	 */
	
	'use strict';
	
	var entities = __webpack_require__(25);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position) {
	    return entities(value, {
	      position: normalize(position),
	      warning: handleWarning
	    });
	  }
	}


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:break
	 * @fileoverview Locate a break.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:code-inline
	 * @fileoverview Locate inline code.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:delete
	 * @fileoverview Locate strikethrough.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:emphasis
	 * @fileoverview Locate italics / emphasis.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:escape
	 * @fileoverview Locate an escape.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:strong
	 * @fileoverview Locate bold / strong / importance.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:locate:url
	 * @fileoverview Locate a URL.
	 */
	
	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:parse
	 * @fileoverview Parse the document
	 */
	
	'use strict';
	
	var xtend = __webpack_require__(8);
	var removePosition = __webpack_require__(337);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse
	 * @fileoverview Markdown parser.
	 */
	
	'use strict';
	
	var xtend = __webpack_require__(8);
	var toggle = __webpack_require__(98);
	var vfileLocation = __webpack_require__(44);
	var unescape = __webpack_require__(286);
	var decode = __webpack_require__(248);
	var tokenizer = __webpack_require__(285);
	
	module.exports = Parser;
	
	/* Construct a new parser. */
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	/* Prototype. */
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(258);
	proto.parse = __webpack_require__(256);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(88);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  yamlFrontMatter: __webpack_require__(284),
	  newline: __webpack_require__(276),
	  indentedCode: __webpack_require__(263),
	  fencedCode: __webpack_require__(262),
	  blockquote: __webpack_require__(260),
	  atxHeading: __webpack_require__(270),
	  thematicBreak: __webpack_require__(282),
	  list: __webpack_require__(275),
	  setextHeading: __webpack_require__(271),
	  html: __webpack_require__(272),
	  footnote: __webpack_require__(269),
	  definition: __webpack_require__(265),
	  table: __webpack_require__(280),
	  paragraph: __webpack_require__(277)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(268),
	  autoLink: __webpack_require__(259),
	  url: __webpack_require__(283),
	  html: __webpack_require__(273),
	  link: __webpack_require__(274),
	  reference: __webpack_require__(278),
	  strong: __webpack_require__(279),
	  emphasis: __webpack_require__(267),
	  deletion: __webpack_require__(266),
	  code: __webpack_require__(264),
	  break: __webpack_require__(261),
	  text: __webpack_require__(281)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse
	 * @fileoverview Markdown parser.
	 */
	
	'use strict';
	
	var xtend = __webpack_require__(8);
	var escapes = __webpack_require__(80);
	var defaults = __webpack_require__(88);
	
	module.exports = setOptions;
	
	/* Set options. */
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error(
	        'Invalid value `' + value + '` ' +
	        'for setting `options.' + key + '`'
	      );
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:auto-link
	 * @fileoverview Tokenise an auto-link.
	 */
	
	'use strict';
	
	var decode = __webpack_require__(25);
	var locate = __webpack_require__(90);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenize;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === ' ' ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === ' ' || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove support for escapes in autolinks. */
	  tokenize = self.inlineTokenizers.escape;
	  self.inlineTokenizers.escape = null;
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers.escape = tokenize;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link),
	    children: content
	  });
	}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:blockquote
	 * @fileoverview Tokenise blockquote.
	 */
	
	'use strict';
	
	var trim = __webpack_require__(13);
	var interrupt = __webpack_require__(38);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:break
	 * @fileoverview Tokenise a break.
	 */
	
	'use strict';
	
	var locate = __webpack_require__(249);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	/* Tokenise a break. */
	function hardBreak(eat, value, silent) {
	  var self = this;
	  var breaks = self.options.breaks;
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (!breaks && index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:code-fenced
	 * @fileoverview Tokenise fenced code.
	 */
	
	'use strict';
	
	var trim = __webpack_require__(43);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	/* Tokenise fenced code. */
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:code-indented
	 * @fileoverview Tokenise indented code.
	 */
	
	'use strict';
	
	var repeat = __webpack_require__(9);
	var trim = __webpack_require__(43);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:code-inline
	 * @fileoverview Tokenise inline code.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(250);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:definition
	 * @fileoverview Tokenise a definition.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	var normalize = __webpack_require__(39);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	/* Tokenise a definition. */
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL);
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:delete
	 * @fileoverview Tokenise strikethrough.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(251);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	/* Tokenise strikethrough. */
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:emphasis
	 * @fileoverview Tokenise emphasis.
	 */
	
	'use strict';
	
	var trim = __webpack_require__(13);
	var word = __webpack_require__(183);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(252);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	/* Tokenise emphasis. */
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:escape
	 * @fileoverview Tokenise an escape.
	 */
	
	'use strict';
	
	var locate = __webpack_require__(253);
	
	module.exports = escape;
	escape.locator = locate;
	
	/* Tokenise an escape. */
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:footnote-definition
	 * @fileoverview Tokenise footnote definition.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	var normalize = __webpack_require__(39);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	/* Tokenise a footnote definition. */
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:heading-atx
	 * @fileoverview Tokenise an ATX-style heading.
	 */
	
	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	/* Tokenise an ATX-style heading. */
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:heading-setext
	 * @fileoverview Tokenise an setext-style heading.
	 */
	
	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	/* Tokenise an setext-style heading. */
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:html-block
	 * @fileoverview Tokenise block HTML.
	 */
	
	'use strict';
	
	var openCloseTag = __webpack_require__(92).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	/* Tokenise block HTML. */
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:html-inline
	 * @fileoverview Tokenise inline HTML.
	 */
	
	'use strict';
	
	var alphabetical = __webpack_require__(75);
	var locate = __webpack_require__(90);
	var tag = __webpack_require__(92).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	/* Tokenise inline HTML. */
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:link
	 * @fileoverview Tokenise a link.
	 */
	
	'use strict';
	
	var has = __webpack_require__(164);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(89);
	
	module.exports = link;
	link.locator = locate;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	/* Tokenise a link. */
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (gfm) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && has(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (commonmark) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && has(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end);
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:list
	 * @fileoverview Tokenise a list.
	 */
	
	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(13);
	var repeat = __webpack_require__(9);
	var decimal = __webpack_require__(18);
	var getIndent = __webpack_require__(91);
	var removeIndent = __webpack_require__(287);
	var interrupt = __webpack_require__(38);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	/* Tokenise a list. */
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	/**
	 * Create a list-item node.
	 *
	 * @example
	 *   listItem('- _foo_', now());
	 *
	 * @param {Object} ctx - Parser.
	 * @param {Object} value - List-item.
	 * @param {Object} position - List-item location.
	 * @return {Object} - `listItem` node.
	 */
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:newline
	 * @fileoverview Tokenise a newline.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:paragraph
	 * @fileoverview Tokenise a paragraph.
	 */
	
	'use strict';
	
	var trim = __webpack_require__(13);
	var decimal = __webpack_require__(18);
	var trimTrailingLines = __webpack_require__(43);
	var interrupt = __webpack_require__(38);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:reference
	 * @fileoverview Tokenise a reference.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(89);
	var normalize = __webpack_require__(39);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	/* Tokenise a reference. */
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (
	    self.options.footnotes &&
	    type === T_LINK &&
	    value.charAt(index) === C_CARET
	  ) {
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type === T_FOOTNOTE && referenceType !== REFERENCE_TYPE_SHORTCUT) {
	    type = T_LINK;
	    intro = C_BRACKET_OPEN + C_CARET;
	    content = C_CARET + content;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:strong
	 * @fileoverview Tokenise strong.
	 */
	
	'use strict';
	
	var trim = __webpack_require__(13);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(254);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	/* Tokenise strong. */
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:table
	 * @fileoverview Tokenise a table.
	 */
	
	'use strict';
	
	var whitespace = __webpack_require__(10);
	
	module.exports = table;
	table.notInList = true;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	/* Tokenise a table. */
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:text
	 * @fileoverview Tokenise text.
	 */
	
	'use strict';
	
	module.exports = text;
	
	/* Tokenise text. */
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:thematic-break
	 * @fileoverview Tokenise a thematic break.
	 */
	
	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	/* Tokenise a thematic break. */
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:url
	 * @fileoverview Tokenise a URL.
	 */
	
	'use strict';
	
	var decode = __webpack_require__(25);
	var whitespace = __webpack_require__(10);
	var locate = __webpack_require__(255);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	/* Tokenise a URL. */
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue),
	    children: content
	  });
	}


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenize:yaml
	 * @fileoverview Tokenise YAML.
	 */
	
	'use strict';
	
	module.exports = yaml;
	yaml.onlyAtStart = true;
	
	var FENCE = '---';
	var C_DASH = '-';
	var C_NEWLINE = '\n';
	
	/* Tokenise YAML. */
	function yaml(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var index;
	  var length;
	  var character;
	  var queue;
	
	  if (
	    !self.options.yaml ||
	    value.charAt(0) !== C_DASH ||
	    value.charAt(1) !== C_DASH ||
	    value.charAt(2) !== C_DASH ||
	    value.charAt(3) !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  subvalue = FENCE + C_NEWLINE;
	  content = '';
	  queue = '';
	  index = 3;
	  length = value.length;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_DASH &&
	      (queue || !content) &&
	      value.charAt(index + 1) === C_DASH &&
	      value.charAt(index + 2) === C_DASH
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      subvalue += queue + FENCE;
	
	      return eat(subvalue)({
	        type: 'yaml',
	        value: content
	      });
	    }
	
	    if (character === C_NEWLINE) {
	      queue += character;
	    } else {
	      subvalue += queue + character;
	      content += queue + character;
	      queue = '';
	    }
	  }
	}


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:tokenizer
	 * @fileoverview Markdown tokenizer.
	 */
	
	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /**
	     * Update line, column, and offset based on
	     * `value`.
	     *
	     * @example
	     *   updatePosition('foo');
	     *
	     * @param {string} subvalue - Subvalue to eat.
	     */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /**
	     * Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets.
	     *
	     * @return {Function} - `done`, to be called when
	     *   the last character is eaten.
	     */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /**
	       * Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets.
	       *
	       * @return {Array.<number>} - Offset.
	       */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /**
	     * Get the current position.
	     *
	     * @example
	     *   position = now(); // {line: 1, column: 1, offset: 0}
	     *
	     * @return {Object} - Current Position.
	     */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /**
	     * Store position information for a node.
	     *
	     * @example
	     *   start = now();
	     *   updatePosition('foo');
	     *   location = new Position(start);
	     *   // {
	     *   //   start: {line: 1, column: 1, offset: 0},
	     *   //   end: {line: 1, column: 3, offset: 2}
	     *   // }
	     *
	     * @param {Object} start - Starting position.
	     */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /**
	     * Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules.
	     *
	     * @example
	     *   // When the current value is set to `foo bar`.
	     *   validateEat('foo');
	     *   eat('foo');
	     *
	     *   validateEat('bar');
	     *   // throws, because the space is not eaten.
	     *
	     * @param {string} subvalue - Value to be eaten.
	     * @throws {Error} - When `subvalue` cannot be eaten.
	     */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /**
	     * Mark position and patch `node.position`.
	     *
	     * @example
	     *   var update = position();
	     *   updatePosition('foo');
	     *   update({});
	     *   // {
	     *   //   position: {
	     *   //     start: {line: 1, column: 1, offset: 0},
	     *   //     end: {line: 1, column: 3, offset: 2}
	     *   //   }
	     *   // }
	     *
	     * @returns {Function} - Updater.
	     */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /**
	       * Add the position to a node.
	       *
	       * @example
	       *   update({type: 'text', value: 'foo'});
	       *
	       * @param {Node} node - Node to attach position
	       *   on.
	       * @param {Array} [indent] - Indentation for
	       *   `node`.
	       * @return {Node} - `node`.
	       */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /**
	     * Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible.
	     *
	     * @example
	     *   add({});
	     *
	     *   add({}, {children: []});
	     *
	     * @param {Object} node - Node to add.
	     * @param {Object} [parent] - Parent to insert into.
	     * @return {Object} - Added or merged into node.
	     */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /**
	     * Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`.
	     *
	     * @example
	     *   eat('foo')({type: 'text', value: 'foo'});
	     *
	     * @param {string} subvalue - Removed from `value`,
	     *   and passed to `updatePosition`.
	     * @return {Function} - Wrapper around `add`, which
	     *   also adds `position` to node.
	     */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /**
	       * Add the given arguments, add `position` to
	       * the returned node, and return the node.
	       *
	       * @param {Object} node - Node to add.
	       * @param {Object} [parent] - Node to insert into.
	       * @return {Node} - Added node.
	       */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /**
	       * Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       *
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       *
	       * See `apply` above for what parameters are
	       * expected.
	       *
	       * @return {Node} - Added node.
	       */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /**
	       * Test the position, after eating, and reverse
	       * to a not-eaten state.
	       *
	       * @return {Position} - Position after eating `subvalue`.
	       */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:unescape
	 * @fileoverview Unescape escapes.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:parse:util:remove-indentation
	 * @fileoverview Remove indentation.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var trim = __webpack_require__(13);
	var repeat = __webpack_require__(9);
	var getIndent = __webpack_require__(91);
	
	/* Expose. */
	module.exports = indentation;
	
	/* Characters. */
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/**
	 * Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible).
	 *
	 * @example
	 *   removeIndentation('  foo'); // 'foo'
	 *   removeIndentation('    foo', 2); // '  foo'
	 *   removeIndentation('\tfoo', 2); // '  foo'
	 *   removeIndentation('  foo\n bar'); // ' foo\n bar'
	 *
	 * @param {string} value - Value to trim.
	 * @param {number?} [maximum] - Maximum indentation
	 *   to remove.
	 * @return {string} - Unindented `value`.
	 */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @fileoverview
	 *   remark preset to configure remark-lint with settings that
	 *   prevent mistakes or syntaxes that do not work correctly
	 *   across vendors.
	 */
	
	'use strict'
	
	module.exports.plugins = [
	  __webpack_require__(245),
	  /* Unix compatibility. */
	  __webpack_require__(230),
	  /* Rendering across vendors differs greatly
	   * if using other styles. */
	  __webpack_require__(232),
	  [__webpack_require__(233), 'tab-size'],
	  /* Differs or unsupported across vendors. */
	  __webpack_require__(234),
	  __webpack_require__(235),
	  __webpack_require__(239),
	  [__webpack_require__(244), '.'],
	  /* Mistakes. */
	  __webpack_require__(231),
	  __webpack_require__(236),
	  __webpack_require__(237),
	  __webpack_require__(238),
	  __webpack_require__(240),
	  __webpack_require__(241),
	  __webpack_require__(242),
	  __webpack_require__(243)
	]


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(99);
	var xtend = __webpack_require__(8);
	var Compiler = __webpack_require__(290);
	
	module.exports = stringify;
	stringify.Compiler = Compiler;
	
	function stringify(options) {
	  var Local = unherit(Compiler);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Compiler = Local;
	}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify
	 * @fileoverview Markdown compiler
	 */
	
	'use strict';
	
	/* Dependencies. */
	var xtend = __webpack_require__(8);
	var toggle = __webpack_require__(98);
	
	/* Expose. */
	module.exports = Compiler;
	
	/**
	 * Construct a new compiler.
	 *
	 * @constructor
	 * @class {Compiler}
	 * @param {File} file - Virtual file.
	 */
	function Compiler(tree, file) {
	  this.inLink = false;
	  this.inTable = false;
	  this.tree = tree;
	  this.file = file;
	  this.options = xtend(this.options);
	  this.setOptions({});
	}
	
	/* Cache prototype. */
	var proto = Compiler.prototype;
	
	/* Enter and exit helpers. */
	proto.enterLink = toggle('inLink', false);
	proto.enterTable = toggle('inTable', false);
	proto.enterLinkReference = __webpack_require__(300);
	
	/* Configuration. */
	proto.options = __webpack_require__(93);
	proto.setOptions = __webpack_require__(298);
	
	proto.compile = __webpack_require__(294);
	proto.visit = __webpack_require__(295);
	proto.all = __webpack_require__(292);
	proto.block = __webpack_require__(293);
	proto.visitOrderedItems = __webpack_require__(296);
	proto.visitUnorderedItems = __webpack_require__(297);
	
	/* Expose visitors. */
	proto.visitors = {
	  root: __webpack_require__(320),
	  text: __webpack_require__(324),
	  heading: __webpack_require__(310),
	  paragraph: __webpack_require__(319),
	  blockquote: __webpack_require__(301),
	  list: __webpack_require__(318),
	  listItem: __webpack_require__(317),
	  inlineCode: __webpack_require__(314),
	  yaml: __webpack_require__(326),
	  code: __webpack_require__(303),
	  html: __webpack_require__(311),
	  thematicBreak: __webpack_require__(325),
	  strong: __webpack_require__(321),
	  emphasis: __webpack_require__(306),
	  break: __webpack_require__(302),
	  delete: __webpack_require__(305),
	  link: __webpack_require__(316),
	  linkReference: __webpack_require__(315),
	  imageReference: __webpack_require__(312),
	  definition: __webpack_require__(304),
	  image: __webpack_require__(313),
	  footnote: __webpack_require__(309),
	  footnoteReference: __webpack_require__(308),
	  footnoteDefinition: __webpack_require__(307),
	  table: __webpack_require__(323),
	  tableCell: __webpack_require__(322)
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:escape
	 * @fileoverview Escape text to prevent it turning
	 *   into markdown syntax.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var decimal = __webpack_require__(18);
	var alphanumeric = __webpack_require__(180);
	var whitespace = __webpack_require__(10);
	var escapes = __webpack_require__(80);
	var prefix = __webpack_require__(94);
	
	/* Expose. */
	module.exports = factory;
	
	/* Constants. */
	var BACKSLASH = '\\';
	var BULLETS = ['*', '-', '+'];
	var ALLIGNMENT = [':', '-', ' ', '|'];
	var entities = {'<': '&lt;', ':': '&#x3A;', '&': '&amp;', '|': '&#x7C;', '~': '&#x7E;'};
	
	/**
	 * Factory to escape characters.
	 *
	 * @example
	 *   var escape = escapeFactory({ commonmark: true });
	 *   escape('x*x', { type: 'text', value: 'x*x' }) // 'x\\*x'
	 *
	 * @param {Object} options - Compiler options.
	 * @return {function(value, node, parent): string} - Function which
	 *   takes a value and a node and (optionally) its parent and returns
	 *   its escaped value.
	 */
	function factory(options) {
	  return escape;
	
	  /**
	   * Escape punctuation characters in a node's value.
	   *
	   * @param {string} value - Value to escape.
	   * @param {Object} node - Node in which `value` exists.
	   * @param {Object} [parent] - Parent of `node`.
	   * @return {string} - Escaped `value`.
	   */
	  function escape(value, node, parent) {
	    var self = this;
	    var gfm = options.gfm;
	    var commonmark = options.commonmark;
	    var pedantic = options.pedantic;
	    var markers = commonmark ? ['.', ')'] : ['.'];
	    var siblings = parent && parent.children;
	    var index = siblings && siblings.indexOf(node);
	    var prev = siblings && siblings[index - 1];
	    var next = siblings && siblings[index + 1];
	    var length = value.length;
	    var escapable = escapes(options);
	    var position = -1;
	    var queue = [];
	    var escaped = queue;
	    var afterNewLine;
	    var character;
	    var wordCharBefore;
	    var wordCharAfter;
	    var offset;
	    var replace;
	
	    if (prev) {
	      afterNewLine = text(prev) && /\n\s*$/.test(prev.value);
	    } else {
	      afterNewLine = !parent || parent.type === 'root' || parent.type === 'paragraph';
	    }
	
	    function one(character) {
	      return escapable.indexOf(character) === -1 ?
	        entities[character] : BACKSLASH + character;
	    }
	
	    while (++position < length) {
	      character = value.charAt(position);
	      replace = false;
	
	      if (character === '\n') {
	        afterNewLine = true;
	      } else if (
	        character === BACKSLASH ||
	        character === '`' ||
	        character === '*' ||
	        character === '[' ||
	        character === '<' ||
	        (character === '&' && prefix(value.slice(position)) > 0) ||
	        (character === ']' && self.inLink) ||
	        (gfm && character === '~' && value.charAt(position + 1) === '~') ||
	        (gfm && character === '|' && (self.inTable || alignment(value, position))) ||
	        (
	          character === '_' &&
	          /* Delegate leading/trailing underscores
	           * to the multinode version below. */
	          position > 0 &&
	          position < length - 1 &&
	          (
	              pedantic ||
	              !alphanumeric(value.charAt(position - 1)) ||
	              !alphanumeric(value.charAt(position + 1))
	          )
	        ) ||
	        (gfm && !self.inLink && character === ':' && protocol(queue.join('')))
	      ) {
	        replace = true;
	      } else if (afterNewLine) {
	        if (
	          character === '>' ||
	          character === '#' ||
	          BULLETS.indexOf(character) !== -1
	        ) {
	          replace = true;
	        } else if (decimal(character)) {
	          offset = position + 1;
	
	          while (offset < length) {
	            if (!decimal(value.charAt(offset))) {
	              break;
	            }
	
	            offset++;
	          }
	
	          if (markers.indexOf(value.charAt(offset)) !== -1) {
	            next = value.charAt(offset + 1);
	
	            if (!next || next === ' ' || next === '\t' || next === '\n') {
	              queue.push(value.slice(position, offset));
	              position = offset;
	              character = value.charAt(position);
	              replace = true;
	            }
	          }
	        }
	      }
	
	      if (afterNewLine && !whitespace(character)) {
	        afterNewLine = false;
	      }
	
	      queue.push(replace ? one(character) : character);
	    }
	
	    /* Multi-node versions. */
	    if (siblings && text(node)) {
	      /* Check for an opening parentheses after a
	       * link-reference (which can be joined by
	       * white-space). */
	      if (prev && prev.referenceType === 'shortcut') {
	        position = -1;
	        length = escaped.length;
	
	        while (++position < length) {
	          character = escaped[position];
	
	          if (character === ' ' || character === '\t') {
	            continue;
	          }
	
	          if (character === '(' || character === ':') {
	            escaped[position] = one(character);
	          }
	
	          break;
	        }
	
	        /* If the current node is all spaces / tabs,
	         * preceded by a shortcut, and followed by
	         * a text starting with `(`, escape it. */
	        if (
	          text(next) &&
	          position === length &&
	          next.value.charAt(0) === '('
	        ) {
	          escaped.push(BACKSLASH);
	        }
	      }
	
	      /* Ensure non-auto-links are not seen as links.
	       * This pattern needs to check the preceding
	       * nodes too. */
	      if (
	        gfm &&
	        !self.inLink &&
	        text(prev) &&
	        value.charAt(0) === ':' &&
	        protocol(prev.value.slice(-6))
	      ) {
	        escaped[0] = one(':');
	      }
	
	      /* Escape ampersand if it would otherwise
	       * start an entity. */
	      if (
	        text(next) &&
	        value.charAt(length - 1) === '&' &&
	        prefix('&' + next.value) !== 0
	      ) {
	        escaped[escaped.length - 1] = one('&');
	      }
	
	      /* Escape double tildes in GFM. */
	      if (
	        gfm &&
	        text(next) &&
	        value.charAt(length - 1) === '~' &&
	        next.value.charAt(0) === '~'
	      ) {
	        escaped.splice(escaped.length - 1, 0, BACKSLASH);
	      }
	
	      /* Escape underscores, but not mid-word (unless
	       * in pedantic mode). */
	      wordCharBefore = text(prev) && alphanumeric(prev.value.slice(-1));
	      wordCharAfter = text(next) && alphanumeric(next.value.charAt(0));
	
	      if (length === 1) {
	        if (value === '_' && (pedantic || !wordCharBefore || !wordCharAfter)) {
	          escaped.unshift(BACKSLASH);
	        }
	      } else {
	        if (
	          value.charAt(0) === '_' &&
	          (pedantic || !wordCharBefore || !alphanumeric(value.charAt(1)))
	        ) {
	          escaped.unshift(BACKSLASH);
	        }
	
	        if (
	          value.charAt(length - 1) === '_' &&
	          (pedantic || !wordCharAfter || !alphanumeric(value.charAt(length - 2)))
	        ) {
	          escaped.splice(escaped.length - 1, 0, BACKSLASH);
	        }
	      }
	    }
	
	    return escaped.join('');
	  }
	}
	
	/**
	 * Check if `index` in `value` is inside an alignment row.
	 */
	function alignment(value, index) {
	  var start = value.lastIndexOf('\n', index);
	  var end = value.indexOf('\n', index);
	
	  start = start === -1 ? -1 : start;
	  end = end === -1 ? value.length : end;
	
	  while (++start < end) {
	    if (ALLIGNMENT.indexOf(value.charAt(start)) === -1) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Check if `node` is a text node.
	 */
	function text(node) {
	  return node && node.type === 'text';
	}
	
	/**
	 * Check if `value` ends in a protocol.
	 */
	function protocol(value) {
	  var val = value.slice(-6).toLowerCase();
	  return val === 'mailto' || val.slice(-5) === 'https' || val.slice(-4) === 'http';
	}


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:all
	 * @fileoverview Stringify children in a node.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = all;
	
	/**
	 * Visit all children of `parent`.
	 *
	 * @param {Object} parent - Parent node of children.
	 * @return {Array.<string>} - List of compiled children.
	 */
	function all(parent) {
	  var self = this;
	  var children = parent.children;
	  var length = children.length;
	  var results = [];
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = self.visit(children[index], parent);
	  }
	
	  return results;
	}


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:block
	 * @fileoverview Stringify a block.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = block;
	
	/**
	 * Stringify a block node with block children (e.g., `root`
	 * or `blockquote`).
	 *
	 * Knows about code following a list, or adjacent lists
	 * with similar bullets, and places an extra newline
	 * between them.
	 *
	 * @param {Object} node
	 * @return {string} - Compiled children.
	 */
	function block(node) {
	  var self = this;
	  var values = [];
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var child;
	  var prev;
	
	  while (++index < length) {
	    child = children[index];
	
	    if (prev) {
	      /* Duplicate nodes, such as a list
	       * directly following another list,
	       * often need multiple new lines.
	       *
	       * Additionally, code blocks following a list
	       * might easily be mistaken for a paragraph
	       * in the list itself. */
	      if (child.type === prev.type && prev.type === 'list') {
	        values.push(prev.ordered === child.ordered ? '\n\n\n' : '\n\n');
	      } else if (prev.type === 'list' && child.type === 'code' && !child.lang) {
	        values.push('\n\n\n');
	      } else {
	        values.push('\n\n');
	      }
	    }
	
	    values.push(self.visit(child, node));
	
	    prev = child;
	  }
	
	  return values.join('');
	}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:compile
	 * @fileoverview Compile the given node.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var compact = __webpack_require__(195);
	
	/* Expose. */
	module.exports = compile;
	
	/**
	 * Stringify the given tree.
	 *
	 * @param {Node} node - Syntax tree.
	 * @return {string} - Markdown document.
	 */
	function compile() {
	  return this.visit(compact(this.tree, this.options.commonmark));
	}


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:one
	 * @fileoverview Stringify a node.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = one;
	
	/**
	 * Visit a node.
	 *
	 * @param {Object} node - Node.
	 * @param {Object?} [parent] - `node`s parent.
	 * @return {string} - Compiled `node`.
	 */
	function one(node, parent) {
	  var self = this;
	  var visitors = self.visitors;
	
	  /* Fail on unknown nodes. */
	  if (typeof visitors[node.type] !== 'function') {
	    self.file.fail(
	      new Error(
	        'Missing compiler for node of type `' +
	        node.type + '`: `' + node + '`'
	      ),
	      node
	    );
	  }
	
	  return visitors[node.type].call(self, node, parent);
	}


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:ordered-items
	 * @fileoverview Stringify ordered list items.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = orderedItems;
	
	/**
	 * Visit ordered list items.
	 *
	 * Starts the list with
	 * `node.start` and increments each following list item
	 * bullet by one:
	 *
	 *     2. foo
	 *     3. bar
	 *
	 * In `incrementListMarker: false` mode, does not increment
	 * each marker and stays on `node.start`:
	 *
	 *     1. foo
	 *     1. bar
	 *
	 * Adds an extra line after an item if it has
	 * `loose: true`.
	 *
	 * @param {Object} node - `list` node with
	 *   `ordered: true`.
	 * @return {string} - Compiled children.
	 */
	function orderedItems(node) {
	  var self = this;
	  var fn = self.visitors.listItem;
	  var increment = self.options.incrementListMarker;
	  var values = [];
	  var start = node.start;
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var bullet;
	
	  while (++index < length) {
	    bullet = (increment ? start + index : start) + '.';
	    values[index] = fn.call(self, children[index], node, index, bullet);
	  }
	
	  return values.join('\n');
	}


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:macro:unordered-items
	 * @fileoverview Stringify unordered list items.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = unorderedItems;
	
	/**
	 * Visit unordered list items.
	 *
	 * Uses `options.bullet` as each item's bullet.
	 *
	 * @param {Object} node - `list` node with
	 *   `ordered: false`.
	 * @return {string} - Compiled children.
	 */
	function unorderedItems(node) {
	  var self = this;
	  var bullet = self.options.bullet;
	  var fn = self.visitors.listItem;
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var values = [];
	
	  while (++index < length) {
	    values[index] = fn.call(self, children[index], node, index, bullet);
	  }
	
	  return values.join('\n');
	}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:set-options
	 * @fileoverview Set configuration.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var xtend = __webpack_require__(8);
	var encode = __webpack_require__(42);
	var defaults = __webpack_require__(93);
	var escapeFactory = __webpack_require__(291);
	var returner = __webpack_require__(97);
	
	/* Expose. */
	module.exports = setOptions;
	
	/* Map of applicable enum's. */
	var maps = {
	  entities: {true: true, false: true, numbers: true, escape: true},
	  bullet: {'*': true, '-': true, '+': true},
	  rule: {'-': true, _: true, '*': true},
	  listItemIndent: {tab: true, mixed: true, 1: true},
	  emphasis: {_: true, '*': true},
	  strong: {_: true, '*': true},
	  fence: {'`': true, '~': true}
	};
	
	/* Expose `validate`. */
	var validate = {
	  boolean: validateBoolean,
	  string: validateString,
	  number: validateNumber
	};
	
	/**
	 * Set options.  Does not overwrite previously set
	 * options.
	 *
	 * @this {Compiler}
	 * @throws {Error} - When an option is invalid.
	 * @param {Object?} [options] - Stringify settings.
	 * @return {Compiler} - `self`.
	 */
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var ruleRepetition;
	  var key;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error('Invalid value `' + options + '` for setting `options`');
	  }
	
	  for (key in defaults) {
	    validate[typeof defaults[key]](options, key, current[key], maps[key]);
	  }
	
	  ruleRepetition = options.ruleRepetition;
	
	  if (ruleRepetition && ruleRepetition < 3) {
	    raise(ruleRepetition, 'options.ruleRepetition');
	  }
	
	  self.encode = encodeFactory(String(options.entities));
	  self.escape = escapeFactory(options);
	
	  self.options = options;
	
	  return self;
	}
	
	/**
	 * Throw an exception with in its `message` `value`
	 * and `name`.
	 *
	 * @param {*} value - Invalid value.
	 * @param {string} name - Setting name.
	 */
	function raise(value, name) {
	  throw new Error('Invalid value `' + value + '` for setting `' + name + '`');
	}
	
	/**
	 * Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean.
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   a boolean.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {boolean} def - Default value.
	 */
	function validateBoolean(context, name, def) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  if (typeof value !== 'boolean') {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/**
	 * Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean.
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   a number.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {number} def - Default value.
	 */
	function validateNumber(context, name, def) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  if (isNaN(value)) {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/**
	 * Validate a value to be in `map`. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * in `map`.
	 *
	 * @throws {Error} - When a setting is neither omitted nor
	 *   in `map`.
	 * @param {Object} context - Settings.
	 * @param {string} name - Setting name.
	 * @param {string} def - Default value.
	 * @param {Object} map - Enum.
	 */
	function validateString(context, name, def, map) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  value = String(value);
	
	  if (!(value in map)) {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/**
	 * Factory to encode HTML entities.
	 * Creates a no-operation function when `type` is
	 * `'false'`, a function which encodes using named
	 * references when `type` is `'true'`, and a function
	 * which encodes using numbered references when `type` is
	 * `'numbers'`.
	 *
	 * @param {string} type - Either `'true'`, `'false'`, or
	 *   `'numbers'`.
	 * @return {function(string): string} - Function which
	 *   takes a value and returns its encoded version.
	 */
	function encodeFactory(type) {
	  var options = {};
	
	  if (type === 'false') {
	    return returner;
	  }
	
	  if (type === 'true') {
	    options.useNamedReferences = true;
	  }
	
	  if (type === 'escape') {
	    options.escapeOnly = true;
	    options.useNamedReferences = true;
	  }
	
	  return wrapped;
	
	  /**
	   * Encode HTML entities using the bound options.
	   *
	   * @param {string} value - Content.
	   * @param {Object} [node] - Node which is compiled.
	   * @return {string} - Encoded content.
	   */
	  function wrapped(value) {
	    return encode(value, options);
	  }
	}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:copy-identifier-encoding
	 * @fileoverview Encode based on the identifier.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var entityPrefixLength = __webpack_require__(94);
	
	/* Expose. */
	module.exports = copy;
	
	/* Punctuation characters. */
	var PUNCTUATION = /[-!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~_]/;
	
	/**
	 * For shortcut and collapsed reference links, the contents
	 * is also an identifier, so we need to restore the original
	 * encoding and escaping that were present in the source
	 * string.
	 *
	 * This function takes the unescaped & unencoded value from
	 * shortcut's child nodes and the identifier and encodes
	 * the former according to the latter.
	 *
	 * @example
	 *   copyIdentifierEncoding('a*b', 'a\\*b*c')
	 *   // 'a\\*b*c'
	 *
	 * @param {string} value - Unescaped and unencoded stringified
	 *   link value.
	 * @param {string} identifier - Link identifier.
	 * @return {string} - Encoded link value.
	 */
	function copy(value, identifier) {
	  var length = value.length;
	  var count = identifier.length;
	  var result = [];
	  var position = 0;
	  var index = 0;
	  var start;
	
	  while (index < length) {
	    /* Take next non-punctuation characters from `value`. */
	    start = index;
	
	    while (index < length && !PUNCTUATION.test(value.charAt(index))) {
	      index += 1;
	    }
	
	    result.push(value.slice(start, index));
	
	    /* Advance `position` to the next punctuation character. */
	    while (position < count && !PUNCTUATION.test(identifier.charAt(position))) {
	      position += 1;
	    }
	
	    /* Take next punctuation characters from `identifier`. */
	    start = position;
	
	    while (position < count && PUNCTUATION.test(identifier.charAt(position))) {
	      if (identifier.charAt(position) === '&') {
	        position += entityPrefixLength(identifier.slice(position));
	      }
	
	      position += 1;
	    }
	
	    result.push(identifier.slice(start, position));
	
	    /* Advance `index` to the next non-punctuation character. */
	    while (index < length && PUNCTUATION.test(value.charAt(index))) {
	      index += 1;
	    }
	  }
	
	  return result.join('');
	}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:util:enter-link-reference
	 * @fileoverview Enter a reference.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var returner = __webpack_require__(97);
	
	/* Expose. */
	module.exports = enter;
	
	/**
	 * Shortcut and collapsed link references need no escaping
	 * and encoding during the processing of child nodes (it
	 * must be implied from identifier).
	 *
	 * This toggler turns encoding and escaping off for shortcut
	 * and collapsed references.
	 *
	 * Implies `enterLink`.
	 *
	 * @param {Compiler} compiler - Compiler instance.
	 * @param {LinkReference} node - LinkReference node.
	 * @return {Function} - Exit state.
	 */
	function enter(compiler, node) {
	  var encode = compiler.encode;
	  var escape = compiler.escape;
	  var exit = compiler.enterLink();
	
	  if (
	    node.referenceType !== 'shortcut' &&
	    node.referenceType !== 'collapsed'
	  ) {
	    return exit;
	  }
	
	  compiler.escape = returner;
	  compiler.encode = returner;
	
	  return function () {
	    compiler.encode = encode;
	    compiler.escape = escape;
	    exit();
	  };
	}


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:blockquote
	 * @fileoverview Stringify a blockquote.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = blockquote;
	
	/**
	 * Stringify a blockquote.
	 *
	 * @param {Object} node - `blockquote` node.
	 * @return {string} - Markdown blockquote.
	 */
	function blockquote(node) {
	  var values = this.block(node).split('\n');
	  var result = [];
	  var length = values.length;
	  var index = -1;
	  var value;
	
	  while (++index < length) {
	    value = values[index];
	    result[index] = (value ? ' ' : '') + value;
	  }
	
	  return '>' + result.join('\n>');
	}


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:break
	 * @fileoverview Stringify a break.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = lineBreak;
	
	/* Constants. */
	var map = {true: '\\\n', false: '  \n'};
	
	/**
	 * Stringify a hard break.
	 *
	 * In Commonmark mode, trailing backslash form is used in order
	 * to preserve trailing whitespace that the line may end with,
	 * and also for better visibility.
	 *
	 * @return {string} - Markdown break.
	 */
	function lineBreak() {
	  return map[this.options.commonmark];
	}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:code
	 * @fileoverview Stringify code.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var streak = __webpack_require__(79);
	var repeat = __webpack_require__(9);
	var pad = __webpack_require__(96);
	
	/* Expose. */
	module.exports = code;
	
	/* Constants. */
	var FENCE = /([`~])\1{2}/;
	
	/**
	 * Stringify code.
	 *
	 * Creates indented code when:
	 *
	 * - No language tag exists;
	 * - Not in `fences: true` mode;
	 * - A non-empty value exists.
	 *
	 * Otherwise, GFM fenced code is created:
	 *
	 *     ```js
	 *     foo();
	 *     ```
	 *
	 * When in ``fence: `~` `` mode, uses tildes as fences:
	 *
	 *     ~~~js
	 *     foo();
	 *     ~~~
	 *
	 * Knows about internal fences (Note: GitHub/Kramdown does
	 * not support this):
	 *
	 *     ````javascript
	 *     ```markdown
	 *     foo
	 *     ```
	 *     ````
	 *
	 * Supports named entities in the language flag with
	 * `settings.encode` mode.
	 *
	 * @param {Object} node - `code` node.
	 * @param {Object} parent - Parent of `node`.
	 * @return {string} - Markdown code.
	 */
	function code(node, parent) {
	  var self = this;
	  var value = node.value;
	  var options = self.options;
	  var marker = options.fence;
	  var language = self.encode(node.lang || '', node);
	  var fence;
	
	  /* Without (needed) fences. */
	  if (!language && !options.fences && value) {
	    /* Throw when pedantic, in a list item which
	     * isn’t compiled using a tab. */
	    if (
	      parent &&
	      parent.type === 'listItem' &&
	      options.listItemIndent !== 'tab' &&
	      options.pedantic
	    ) {
	      self.file.fail(
	        'Cannot indent code properly. See http://git.io/vgFvT',
	        node.position
	      );
	    }
	
	    return pad(value, 1);
	  }
	
	  fence = streak(value, marker) + 1;
	
	  /* Fix GFM / RedCarpet bug, where fence-like characters
	   * inside fenced code can exit a code-block.
	   * Yes, even when the outer fence uses different
	   * characters, or is longer.
	   * Thus, we can only pad the code to make it work. */
	  if (FENCE.test(value)) {
	    value = pad(value, 1);
	  }
	
	  fence = repeat(marker, Math.max(fence, 3));
	
	  return fence + language + '\n' + value + '\n' + fence;
	}


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:definition
	 * @fileoverview Stringify a definition.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var uri = __webpack_require__(41);
	var title = __webpack_require__(40);
	
	/* Expose. */
	module.exports = definition;
	
	/**
	 * Stringify an URL definition.
	 *
	 * Is smart about enclosing `url` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    [foo]: <foo at bar dot com> 'An "example" e-mail'
	 *
	 * @param {Object} node - `definition` node.
	 * @return {string} - Markdown definition.
	 */
	function definition(node) {
	  var content = uri(node.url);
	
	  if (node.title) {
	    content += ' ' + title(node.title);
	  }
	
	  return '[' + node.identifier + ']: ' + content;
	}


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:delete
	 * @fileoverview Stringify a delete.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = strikethrough;
	
	/**
	 * Stringify a `delete`.
	 *
	 * @param {Object} node - `delete` node.
	 * @return {string} - Markdown strikethrough.
	 */
	function strikethrough(node) {
	  return '~~' + this.all(node).join('') + '~~';
	}


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:emphasis
	 * @fileoverview Stringify a emphasis.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = emphasis;
	
	/**
	 * Stringify a `emphasis`.
	 *
	 * The marker used is configurable through `emphasis`, which
	 * defaults to an underscore (`'_'`) but also accepts an
	 * asterisk (`'*'`):
	 *
	 *     *foo*
	 *
	 * @param {Object} node - `emphasis` node.
	 * @return {string} - Markdown emphasis.
	 */
	function emphasis(node) {
	  var marker = this.options.emphasis;
	  return marker + this.all(node).join('') + marker;
	}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:footnote-definition
	 * @fileoverview Stringify a footnote-definition.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = footnoteDefinition;
	
	/**
	 * Stringify a footnote definition.
	 *
	 * @param {Object} node - `footnoteDefinition` node.
	 * @return {string} - Markdown footnote definition.
	 */
	function footnoteDefinition(node) {
	  var id = node.identifier.toLowerCase();
	  var content = this.all(node).join('\n\n' + repeat(' ', 4));
	
	  return '[^' + id + ']: ' + content;
	}


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:footnote-reference
	 * @fileoverview Stringify a footnote reference.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = footnoteReference;
	
	/**
	 * Stringify a footnote reference.
	 *
	 * @param {Object} node - `footnoteReference` node.
	 * @return {string} - Markdown footnote reference.
	 */
	function footnoteReference(node) {
	  return '[^' + node.identifier + ']';
	}


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:footnote
	 * @fileoverview Stringify a footnote.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = footnote;
	
	/**
	 * Stringify a footnote.
	 *
	 * @param {Object} node - `footnote` node.
	 * @return {string} - Markdown footnote.
	 */
	function footnote(node) {
	  return '[^' + this.all(node).join('') + ']';
	}


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:heading
	 * @fileoverview Stringify a heading.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = heading;
	
	/**
	 * Stringify heading.
	 *
	 * In `setext: true` mode and when `depth` is smaller than
	 * three, creates a setext header:
	 *
	 *     Foo
	 *     ===
	 *
	 * Otherwise, an ATX header is generated:
	 *
	 *     ### Foo
	 *
	 * In `closeAtx: true` mode, the header is closed with
	 * hashes:
	 *
	 *     ### Foo ###
	 *
	 * @param {Object} node - `heading` node.
	 * @return {string} - Markdown heading.
	 */
	function heading(node) {
	  var self = this;
	  var depth = node.depth;
	  var setext = self.options.setext;
	  var closeAtx = self.options.closeAtx;
	  var content = self.all(node).join('');
	  var prefix;
	
	  if (setext && depth < 3) {
	    return content + '\n' + repeat(depth === 1 ? '=' : '-', content.length);
	  }
	
	  prefix = repeat('#', node.depth);
	
	  return prefix + ' ' + content + (closeAtx ? ' ' + prefix : '');
	}


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:html
	 * @fileoverview Stringify html.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = html;
	
	/**
	 * Stringify html.
	 *
	 * @param {Object} node - `html` node.
	 * @return {string} - html.
	 */
	function html(node) {
	  return node.value;
	}


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:image-reference
	 * @fileoverview Stringify an image reference.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var label = __webpack_require__(95);
	
	/* Expose. */
	module.exports = imageReference;
	
	/**
	 * Stringify an image reference.
	 *
	 * @param {Object} node - `imageReference` node.
	 * @return {string} - Markdown image reference.
	 */
	function imageReference(node) {
	  return '![' + (this.encode(node.alt, node) || '') + ']' + label(node);
	}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:image
	 * @fileoverview Stringify an image.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var uri = __webpack_require__(41);
	var title = __webpack_require__(40);
	
	/* Expose. */
	module.exports = image;
	
	/**
	 * Stringify an image.
	 *
	 * Is smart about enclosing `url` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    ![foo](</fav icon.png> 'My "favourite" icon')
	 *
	 * Supports named entities in `url`, `alt`, and `title`
	 * when in `settings.encode` mode.
	 *
	 * @param {Object} node - `image` node.
	 * @return {string} - Markdown image.
	 */
	function image(node) {
	  var self = this;
	  var content = uri(self.encode(node.url || '', node));
	  var exit = self.enterLink();
	  var alt = self.encode(self.escape(node.alt || '', node));
	
	  exit();
	
	  if (node.title) {
	    content += ' ' + title(self.encode(node.title, node));
	  }
	
	  return '![' + alt + '](' + content + ')';
	}


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:inline-code
	 * @fileoverview Stringify inline code.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var streak = __webpack_require__(79);
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = inlineCode;
	
	/**
	 * Stringify inline code.
	 *
	 * Knows about internal ticks (`\``), and ensures one more
	 * tick is used to enclose the inline code:
	 *
	 *     ```foo ``bar`` baz```
	 *
	 * Even knows about inital and final ticks:
	 *
	 *     `` `foo ``
	 *     `` foo` ``
	 *
	 * @param {Object} node - `inlineCode` node.
	 * @return {string} - Markdown inline code.
	 */
	function inlineCode(node) {
	  var value = node.value;
	  var ticks = repeat('`', streak(value, '`') + 1);
	  var start = ticks;
	  var end = ticks;
	
	  if (value.charAt(0) === '`') {
	    start += ' ';
	  }
	
	  if (value.charAt(value.length - 1) === '`') {
	    end = ' ' + end;
	  }
	
	  return start + value + end;
	}


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:link-reference
	 * @fileoverview Stringify a link reference.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var copy = __webpack_require__(299);
	var label = __webpack_require__(95);
	
	/* Expose. */
	module.exports = linkReference;
	
	/**
	 * Stringify a link reference.
	 *
	 * @param {Object} node - `linkReference` node.
	 * @return {string} - Markdown link reference.
	 */
	function linkReference(node) {
	  var self = this;
	  var type = node.referenceType;
	  var exit = self.enterLinkReference(self, node);
	  var value = self.all(node).join('');
	
	  exit();
	
	  if (type === 'shortcut' || type === 'collapsed') {
	    value = copy(value, node.identifier);
	  }
	
	  return '[' + value + ']' + label(node);
	}


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:link
	 * @fileoverview Stringify a link.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var uri = __webpack_require__(41);
	var title = __webpack_require__(40);
	
	/* Expose. */
	module.exports = link;
	
	/* Expression for a protocol:
	 * http://en.wikipedia.org/wiki/URI_scheme#Generic_syntax */
	var PROTOCOL = /^[a-z][a-z+.-]+:\/?/i;
	
	/**
	 * Stringify a link.
	 *
	 * When no title exists, the compiled `children` equal
	 * `url`, and `url` starts with a protocol, an auto
	 * link is created:
	 *
	 *     <http://example.com>
	 *
	 * Otherwise, is smart about enclosing `url` (see
	 * `encloseURI()`) and `title` (see `encloseTitle()`).
	 *
	 *    [foo](<foo at bar dot com> 'An "example" e-mail')
	 *
	 * Supports named entities in the `url` and `title` when
	 * in `settings.encode` mode.
	 *
	 * @param {Object} node - `link` node.
	 * @return {string} - Markdown link.
	 */
	function link(node) {
	  var self = this;
	  var content = self.encode(node.url || '', node);
	  var exit = self.enterLink();
	  var escaped = self.encode(self.escape(node.url || '', node));
	  var value = self.all(node).join('');
	
	  exit();
	
	  if (
	    node.title == null &&
	    PROTOCOL.test(content) &&
	    (escaped === value || escaped === 'mailto:' + value)
	  ) {
	    /* Backslash escapes do not work in autolinks,
	     * so we do not escape. */
	    return uri(self.encode(node.url), true);
	  }
	
	  content = uri(content);
	
	  if (node.title) {
	    content += ' ' + title(self.encode(self.escape(node.title, node), node));
	  }
	
	  return '[' + value + '](' + content + ')';
	}


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:list-item
	 * @fileoverview Stringify a list item.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	var pad = __webpack_require__(96);
	
	/* Expose. */
	module.exports = listItem;
	
	/* Which checkbox to use. */
	var CHECKBOX_MAP = {
	  undefined: '',
	  null: '',
	  true: '[x] ',
	  false: '[ ] '
	};
	
	/**
	 * Stringify a list item.
	 *
	 * Prefixes the content with a checked checkbox when
	 * `checked: true`:
	 *
	 *     [x] foo
	 *
	 * Prefixes the content with an unchecked checkbox when
	 * `checked: false`:
	 *
	 *     [ ] foo
	 *
	 * @param {Object} node - `listItem` node.
	 * @param {Object} parent - `list` node.
	 * @param {number} position - Index of `node` in `parent`.
	 * @param {string} bullet - Bullet to use.  This, and the
	 *   `listItemIndent` setting define the used indent.
	 * @return {string} - Markdown list item.
	 */
	function listItem(node, parent, position, bullet) {
	  var self = this;
	  var style = self.options.listItemIndent;
	  var loose = node.loose;
	  var children = node.children;
	  var length = children.length;
	  var values = [];
	  var index = -1;
	  var value;
	  var indent;
	  var spacing;
	
	  while (++index < length) {
	    values[index] = self.visit(children[index], node);
	  }
	
	  value = CHECKBOX_MAP[node.checked] + values.join(loose ? '\n\n' : '\n');
	
	  if (style === '1' || (style === 'mixed' && value.indexOf('\n') === -1)) {
	    indent = bullet.length + 1;
	    spacing = ' ';
	  } else {
	    indent = Math.ceil((bullet.length + 1) / 4) * 4;
	    spacing = repeat(' ', indent - bullet.length);
	  }
	
	  value = bullet + spacing + pad(value, indent / 4).slice(indent);
	
	  if (loose && parent.children.length - 1 !== position) {
	    value += '\n';
	  }
	
	  return value;
	}


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:list
	 * @fileoverview Stringify a list.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = list;
	
	/* Which method to use based on `list.ordered`. */
	var ORDERED_MAP = {
	  true: 'visitOrderedItems',
	  false: 'visitUnorderedItems'
	};
	
	/**
	 * Stringify a list. See `Compiler#visitOrderedList()` and
	 * `Compiler#visitUnorderedList()` for internal working.
	 *
	 * @param {Object} node - `list` node.
	 * @return {string} - Markdown list.
	 */
	function list(node) {
	  return this[ORDERED_MAP[node.ordered]](node);
	}


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:paragraph
	 * @fileoverview Stringify a paragraph.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = paragraph;
	
	/**
	 * Stringify a paragraph.
	 *
	 * @param {Object} node - `paragraph` node.
	 * @return {string} - Markdown paragraph.
	 */
	function paragraph(node) {
	  return this.all(node).join('');
	}


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:root
	 * @fileoverview Stringify a root.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = root;
	
	/**
	 * Stringify a root.
	 *
	 * Adds a final newline to ensure valid POSIX files.
	 *
	 * @param {Object} node - `root` node.
	 * @return {string} - Document.
	 */
	function root(node) {
	  return this.block(node) + '\n';
	}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:strong
	 * @fileoverview Stringify a strong.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = strong;
	
	/**
	 * Stringify a `strong`.
	 *
	 * The marker used is configurable by `strong`, which
	 * defaults to an asterisk (`'*'`) but also accepts an
	 * underscore (`'_'`):
	 *
	 *     __foo__
	 *
	 * @param {Object} node - `strong` node.
	 * @return {string} - Markdown strong.
	 */
	function strong(node) {
	  var marker = repeat(this.options.strong, 2);
	  return marker + this.all(node).join('') + marker;
	}


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:table-cell
	 * @fileoverview Stringify a table-cell.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = tableCell;
	
	/**
	 * Stringify a table cell.
	 *
	 * @param {Object} node - `tableCell` node.
	 * @return {string} - Markdown table cell.
	 */
	function tableCell(node) {
	  return this.all(node).join('');
	}


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:table
	 * @fileoverview Stringify a table.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var markdownTable = __webpack_require__(193);
	
	/* Expose. */
	module.exports = table;
	
	/**
	 * Stringify table.
	 *
	 * Creates a fenced table by default, but not in
	 * `looseTable: true` mode:
	 *
	 *     Foo | Bar
	 *     :-: | ---
	 *     Baz | Qux
	 *
	 * NOTE: Be careful with `looseTable: true` mode, as a
	 * loose table inside an indented code block on GitHub
	 * renders as an actual table!
	 *
	 * Creates a spaced table by default, but not in
	 * `spacedTable: false`:
	 *
	 *     |Foo|Bar|
	 *     |:-:|---|
	 *     |Baz|Qux|
	 *
	 * @param {Object} node - `table` node.
	 * @return {string} - Markdown table.
	 */
	function table(node) {
	  var self = this;
	  var loose = self.options.looseTable;
	  var spaced = self.options.spacedTable;
	  var pad = self.options.paddedTable;
	  var rows = node.children;
	  var index = rows.length;
	  var exit = self.enterTable();
	  var result = [];
	  var start;
	  var end;
	
	  while (index--) {
	    result[index] = self.all(rows[index]);
	  }
	
	  exit();
	
	  if (loose) {
	    start = '';
	    end = '';
	  } else if (spaced) {
	    start = '| ';
	    end = ' |';
	  } else {
	    start = '|';
	    end = '|';
	  }
	
	  return markdownTable(result, {
	    align: node.align,
	    pad: pad,
	    start: start,
	    end: end,
	    delimiter: spaced ? ' | ' : '|'
	  });
	}


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:text
	 * @fileoverview Stringify a text.
	 */
	
	'use strict';
	
	/* Expose. */
	module.exports = text;
	
	/**
	 * Stringify text.
	 *
	 * Supports named entities in `settings.encode: true` mode:
	 *
	 *     AT&amp;T
	 *
	 * Supports numbered entities in `settings.encode: numbers`
	 * mode:
	 *
	 *     AT&#x26;T
	 *
	 * @param {Object} node - `text` node.
	 * @param {Object?} [parent] - Parent of `node`.
	 * @return {string} - Markdown text.
	 */
	function text(node, parent) {
	  return this.encode(this.escape(node.value, node, parent), node);
	}


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:thematic-break
	 * @fileoverview Stringify a thematic-break.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = thematic;
	
	/**
	 * Stringify a `thematic-break`.
	 *
	 * The character used is configurable through `rule`: (`'_'`)
	 *
	 *     ___
	 *
	 * The number of repititions is defined through
	 * `ruleRepetition`: (`6`)
	 *
	 *     ******
	 *
	 * Whether spaces delimit each character, is configured
	 * through `ruleSpaces`: (`true`)
	 *
	 *     * * *
	 *
	 * @return {string} - Markdown thematic break.
	 */
	function thematic() {
	  var options = this.options;
	  var rule = repeat(options.rule, options.ruleRepetition);
	  return options.ruleSpaces ? rule.split('').join(' ') : rule;
	}


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module remark:stringify:visitors:yaml
	 * @fileoverview Stringify yaml.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var repeat = __webpack_require__(9);
	
	/* Expose. */
	module.exports = yaml;
	
	/**
	 * Stringify `yaml`.
	 *
	 * @param {Object} node - `yaml` node.
	 * @return {string} - Markdown yaml.
	 */
	function yaml(node) {
	  var marker = repeat('-', 3);
	  return marker + (node.value ? '\n' + node.value : '') + '\n' + marker;
	}


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unified = __webpack_require__(335);
	var parse = __webpack_require__(247);
	var stringify = __webpack_require__(289);
	
	module.exports = unified().use(parse).use(stringify).freeze();


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)))

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	
	/**
	 * An Array.prototype.slice.call(arguments) alternative
	 *
	 * @param {Object} args something with a length
	 * @param {Number} slice
	 * @param {Number} sliceEnd
	 * @api public
	 */
	
	module.exports = function (args, slice, sliceEnd) {
	  var ret = [];
	  var len = args.length;
	
	  if (0 === len) return ret;
	
	  var start = slice < 0
	    ? Math.max(0, slice + len)
	    : slice || 0;
	
	  if (sliceEnd !== undefined) {
	    len = sliceEnd < 0
	      ? sliceEnd + len
	      : sliceEnd
	  }
	
	  while (len-- > start) {
	    ret[len - start] = args[len];
	  }
	
	  return ret;
	}
	


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(13)
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = trim(String(value || empty))
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return trim(values.join(space))
	}


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(328);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimLines
	
	var ws = /[ \t]*\n+[ \t]*/g
	var newline = '\n'
	
	function trimLines(value) {
	  return String(value).replace(ws, newline)
	}


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = trough
	
	/* Methods. */
	var slice = [].slice
	
	/* Create new middleware. */
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  /* Run `fns`.  Last argument must be
	   * a completion handler. */
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    /* Run the next `fn`, if any. */
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      /* Copy non-nully input into values. */
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      /* Next or done. */
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  /* Add `fn` to the list. */
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}
	
	/* Wrap `fn`.  Can be sync or async; return a promise,
	 * receive a completion handler, return new values and
	 * errors. */
	function wrap(fn, next) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (err) {
	      /* Well, this is quite the pickle.  `fn` received
	       * a callback and invoked it (thus continuing the
	       * pipeline), but later also threw an error.
	       * We’re not about to restart the pipeline again,
	       * so the only thing left to do is to throw the
	       * thing instea. */
	      if (callback && invoked) {
	        throw err
	      }
	
	      return done(err)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  /* Invoke `next`, only once. */
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      next.apply(null, arguments)
	    }
	  }
	
	  /* Invoke `done` with one value.
	   * Tracks if an error is passed, too. */
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(13)
	var location = __webpack_require__(44)
	var visit = __webpack_require__(4)
	
	/* Map of allowed verbs. */
	var ALLOWED_VERBS = {
	  enable: true,
	  disable: true,
	  ignore: true
	}
	
	module.exports = messageControl
	
	function messageControl(options) {
	  var name = options && options.name
	  var marker = options && options.marker
	  var test = options && options.test
	  var sources
	  var known
	  var reset
	  var enable
	  var disable
	
	  if (!name) {
	    throw new Error('Expected `name` in `options`, got `' + name + '`')
	  }
	
	  if (!marker) {
	    throw new Error('Expected `name` in `options`, got `' + name + '`')
	  }
	
	  if (!test) {
	    throw new Error('Expected `test` in `options`, got `' + test + '`')
	  }
	
	  known = options.known
	  reset = options.reset
	  enable = options.enable || []
	  disable = options.disable || []
	  sources = options.source
	
	  if (!sources) {
	    sources = [name]
	  } else if (typeof sources === 'string') {
	    sources = [sources]
	  }
	
	  return transformer
	
	  function transformer(tree, file) {
	    var toOffset = location(file).toOffset
	    var initial = !reset
	    var gaps = detectGaps(tree, file)
	    var scope = {}
	    var globals = []
	
	    visit(tree, test, visitor)
	
	    file.messages = file.messages.filter(filter)
	
	    function visitor(node, position, parent) {
	      var mark = marker(node)
	      var ruleIds
	      var ruleId
	      var verb
	      var index
	      var length
	      var next
	      var pos
	      var tail
	
	      if (!mark || mark.name !== options.name) {
	        return
	      }
	
	      ruleIds = mark.attributes.split(/\s/g)
	      verb = ruleIds.shift()
	      next = parent.children[position + 1]
	      pos = mark.node.position && mark.node.position.start
	      tail = next && next.position && next.position.end
	
	      if (!verb || !ALLOWED_VERBS[verb] === true) {
	        file.fail(
	          'Unknown keyword `' +
	            verb +
	            '`: expected ' +
	            "`'enable'`, `'disable'`, or `'ignore'`",
	          mark.node
	        )
	      }
	
	      length = ruleIds.length
	      index = -1
	
	      while (++index < length) {
	        ruleId = ruleIds[index]
	
	        if (isKnown(ruleId, verb, mark.node)) {
	          toggle(pos, verb === 'enable', ruleId)
	
	          if (verb === 'ignore') {
	            toggle(tail, true, ruleId)
	          }
	        }
	      }
	
	      /* Apply to all rules. */
	      if (!length) {
	        if (verb === 'ignore') {
	          toggle(pos, false)
	          toggle(tail, true)
	        } else {
	          toggle(pos, verb === 'enable')
	          reset = verb !== 'enable'
	        }
	      }
	    }
	
	    function filter(message) {
	      var gapIndex = gaps.length
	      var ruleId = message.ruleId
	      var ranges = scope[ruleId]
	      var pos
	
	      /* Keep messages from a different source. */
	      if (!message.source || sources.indexOf(message.source) === -1) {
	        return true
	      }
	
	      /* We only ignore messages if they‘re disabled,
	       * *not* when they’re not in the document. */
	      if (!message.line) {
	        message.line = 1
	      }
	
	      if (!message.column) {
	        message.column = 1
	      }
	
	      /* Check whether the warning is inside a gap. */
	      pos = toOffset(message)
	
	      while (gapIndex--) {
	        if (gaps[gapIndex].start <= pos && gaps[gapIndex].end > pos) {
	          return false
	        }
	      }
	
	      /* Check whether allowed by specific and global states. */
	      return check(message, ranges, ruleId) && check(message, globals)
	    }
	
	    /* Helper to check (and possibly warn) if a ruleId is unknown. */
	    function isKnown(ruleId, verb, pos) {
	      var result = known ? known.indexOf(ruleId) !== -1 : true
	
	      if (!result) {
	        file.warn('Unknown rule: cannot ' + verb + " `'" + ruleId + "'`", pos)
	      }
	
	      return result
	    }
	
	    /* Get the latest state of a rule. When without `ruleId`, gets global state. */
	    function getState(ruleId) {
	      var ranges = ruleId ? scope[ruleId] : globals
	
	      if (ranges && ranges.length !== 0) {
	        return ranges[ranges.length - 1].state
	      }
	
	      if (!ruleId) {
	        return !reset
	      }
	
	      if (reset) {
	        return enable.indexOf(ruleId) !== -1
	      }
	
	      return disable.indexOf(ruleId) === -1
	    }
	
	    /* Handle a rule. */
	    function toggle(pos, state, ruleId) {
	      var markers = ruleId ? scope[ruleId] : globals
	      var currentState
	      var previousState
	
	      if (!markers) {
	        markers = []
	        scope[ruleId] = markers
	      }
	
	      previousState = getState(ruleId)
	      currentState = state
	
	      if (currentState !== previousState) {
	        markers.push({state: currentState, position: pos})
	      }
	
	      /* Toggle all known rules. */
	      if (!ruleId) {
	        for (ruleId in scope) {
	          toggle(pos, state, ruleId)
	        }
	      }
	    }
	
	    /* Check all `ranges` for `message`. */
	    function check(message, ranges, id) {
	      /* Check the state at the message's position. */
	      var index = ranges && ranges.length
	      var length = -1
	      var range
	
	      while (--index > length) {
	        range = ranges[index]
	
	        /* istanbul ignore if - generated marker. */
	        if (!range.position || !range.position.line || !range.position.column) {
	          continue
	        }
	
	        if (
	          range.position.line < message.line ||
	          (range.position.line === message.line &&
	            range.position.column < message.column)
	        ) {
	          return range.state === true
	        }
	      }
	
	      /* The first marker ocurred after the first
	       * message, so we check the initial state. */
	      if (!id) {
	        return initial || reset
	      }
	
	      return reset ? enable.indexOf(id) !== -1 : disable.indexOf(id) === -1
	    }
	  }
	}
	
	/* Detect gaps in `ast`. */
	function detectGaps(tree, file) {
	  var lastNode = tree.children[tree.children.length - 1]
	  var offset = 0
	  var isGap = false
	  var gaps = []
	
	  /* Find all gaps. */
	  visit(tree, one)
	
	  /* Get the end of the document.
	   * This detects if the last node was the last node.
	   * If not, there’s an extra gap between the last node
	   * and the end of the document. */
	  if (
	    lastNode &&
	    lastNode.position &&
	    lastNode.position.end &&
	    offset === lastNode.position.end.offset &&
	    trim(file.toString().slice(offset)) !== ''
	  ) {
	    update()
	
	    update(
	      tree && tree.position && tree.position.end && tree.position.end.offset - 1
	    )
	  }
	
	  return gaps
	
	  function one(node) {
	    var pos = node.position
	
	    update(pos && pos.start && pos.start.offset)
	
	    if (!node.children) {
	      update(pos && pos.end && pos.end.offset)
	    }
	  }
	
	  /* Detect a new position. */
	  function update(latest) {
	    if (latest === null || latest === undefined) {
	      isGap = true
	      return
	    }
	
	    if (offset >= latest) {
	      return
	    }
	
	    if (isGap) {
	      gaps.push({start: offset, end: latest})
	      isGap = false
	    }
	
	    offset = latest
	  }
	}


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(157)
	var bail = __webpack_require__(129)
	var vfile = __webpack_require__(341)
	var trough = __webpack_require__(333)
	var string = __webpack_require__(345)
	var plain = __webpack_require__(182)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var iterate = __webpack_require__(119)
	
	module.exports = modifierFactory
	
	/* Turn `callback` into a child-modifier accepting a parent.
	 * See `array-iterate` for more info. */
	function modifierFactory(callback) {
	  return iteratorFactory(wrapperFactory(callback))
	}
	
	/* Turn `callback` into a `iterator' accepting a parent. */
	function iteratorFactory(callback) {
	  return iterator
	
	  function iterator(parent) {
	    var children = parent && parent.children
	
	    if (!children) {
	      throw new Error('Missing children in `parent` for `modifier`')
	    }
	
	    return iterate(children, callback, parent)
	  }
	}
	
	/* Pass the context as the third argument to `callback`. */
	function wrapperFactory(callback) {
	  return wrapper
	
	  function wrapper(value, index) {
	    return callback(value, index, this)
	  }
	}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(4)
	
	module.exports = removePosition
	
	/* Remove `position`s from `tree`. */
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var is = __webpack_require__(26)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result
	
	    if (!test || is(test, node, index, parents[parents.length - 1] || null)) {
	      result = visitor(node, parents)
	
	      if (result === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result !== SKIP) {
	      return all(node.children, parents.concat(node)) === EXIT ? EXIT : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var child
	    var result
	
	    while (index > min && index < children.length) {
	      child = children[index]
	      result = child && one(child, index, parents)
	
	      if (result === EXIT) {
	        return result
	      }
	
	      index = typeof result === 'number' ? result : index + step
	    }
	  }
	}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(100)
	
	module.exports = VMessage
	
	/* Inherit from `Error#`. */
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	/* Message properties. */
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	/* Construct a new VMessage.
	 *
	 * Note: We cannot invoke `Error` on the created context,
	 * as that adds readonly `line` and `column` attributes on
	 * Safari 9, thus throwing and failing the data. */
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  /* Node. */
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    /* Position. */
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      /* Point. */
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(82);
	var replace = __webpack_require__(342);
	var buffer = __webpack_require__(181);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(339);
	var VFile = __webpack_require__(340);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(82);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module Dependencies
	 */
	
	var sliced = __webpack_require__(329);
	var noop = function(){};
	var co = __webpack_require__(130);
	
	/**
	 * Export `wrapped`
	 */
	
	module.exports = wrapped;
	
	/**
	 * Wrap a function to support
	 * sync, async, and gen functions.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 * @api public
	 */
	
	function wrapped(fn) {
	  function wrap() {
	    var args = sliced(arguments);
	    var last = args[args.length - 1];
	    var ctx = this;
	
	    // done
	    var done = typeof last == 'function' ? args.pop() : noop;
	
	    // nothing
	    if (!fn) {
	      return done.apply(ctx, [null].concat(args));
	    }
	
	    // generator
	    if (generator(fn)) {
	      return co(fn).apply(ctx, args.concat(done));
	    }
	
	    // async
	    if (fn.length > args.length) {
	      // NOTE: this only handles uncaught synchronous errors
	      try {
	        return fn.apply(ctx, args.concat(done));
	      } catch (e) {
	        return done(e);
	      }
	    }
	
	    // sync
	    return sync(fn, done).apply(ctx, args);
	  }
	
	  return wrap;
	}
	
	/**
	 * Wrap a synchronous function execution.
	 *
	 * @param {Function} fn
	 * @param {Function} done
	 * @return {Function}
	 * @api private
	 */
	
	function sync(fn, done) {
	  return function () {
	    var ret;
	
	    try {
	      ret = fn.apply(this, arguments);
	    } catch (err) {
	      return done(err);
	    }
	
	    if (promise(ret)) {
	      ret.then(function (value) { done(null, value); }, done);
	    } else {
	      ret instanceof Error ? done(ret) : done(null, ret);
	    }
	  }
	}
	
	/**
	 * Is `value` a generator?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function generator(value) {
	  return value
	    && value.constructor
	    && 'GeneratorFunction' == value.constructor.name;
	}
	
	
	/**
	 * Is `value` a promise?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function promise(value) {
	  return value && 'function' == typeof value.then;
	}


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ }),
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _starNotColor = __webpack_require__(725);
	
	var _starNotColor2 = _interopRequireDefault(_starNotColor);
	
	var _starColor = __webpack_require__(724);
	
	var _starColor2 = _interopRequireDefault(_starColor);
	
	__webpack_require__(699);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stars = function (_Component) {
	  _inherits(Stars, _Component);
	
	  function Stars() {
	    _classCallCheck(this, Stars);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Stars.prototype.render = function render() {
	    var _props = this.props,
	        rating = _props.rating,
	        isWithNumber = _props.isWithNumber;
	
	    var countNotColorStars = 5 - rating;
	    var ratingStars = [];
	
	    for (var i = 0; i < rating; i++) {
	      ratingStars.push(_react2.default.createElement(
	        'i',
	        { key: i, className: 'stars__img stars__img--colored' },
	        '\u2605'
	      ));
	    }
	
	    if (countNotColorStars !== 0) {
	      for (var _i = rating; _i < 5; _i++) {
	        ratingStars.push(_react2.default.createElement(
	          'i',
	          { key: _i, className: 'stars__img stars__img--not-colored' },
	          '\u2605'
	        ));
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'stars' },
	      ratingStars,
	      isWithNumber ? _react2.default.createElement(
	        'span',
	        { className: 'stars__caption' },
	        parseInt(rating).toFixed(1)
	      ) : null
	    );
	  };
	
	  return Stars;
	}(_react.Component);
	
	Stars.propTypes = {
	  rating: _propTypes2.default.string,
	  isWithNumber: _propTypes2.default.bool
	};
	
	exports.default = Stars;
	module.exports = exports['default'];

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
	}
	module.exports = exports['default'];

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(688);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Featured = function Featured(_ref) {
	  var featured = _ref.featured;
	  return _react2.default.createElement(
	    'span',
	    { className: 'featured' },
	    _react2.default.createElement(
	      'span',
	      { className: 'featured__item featured__item--' + featured },
	      featured
	    )
	  );
	};
	
	Featured.propTypes = {
	  featured: _propTypes2.default.string
	};
	
	exports.default = Featured;
	module.exports = exports['default'];

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(691);
	
	var _decideBox = __webpack_require__(719);
	
	var _decideBox2 = _interopRequireDefault(_decideBox);
	
	var _decideClock = __webpack_require__(720);
	
	var _decideClock2 = _interopRequireDefault(_decideClock);
	
	var _decideInterview = __webpack_require__(721);
	
	var _decideInterview2 = _interopRequireDefault(_decideInterview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HowDecided = function (_React$Component) {
	  _inherits(HowDecided, _React$Component);
	
	  function HowDecided() {
	    _classCallCheck(this, HowDecided);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  HowDecided.prototype.render = function render() {
	    var data = this.props.data;
	
	    var res = data.reduce(function (map, string) {
	      var key = string.split(':')[0];
	      var value = string.split(':')[1];
	      map[key] = value;
	      return map;
	    }, {});
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'how-decided' },
	      _react2.default.createElement(
	        'section',
	        { className: 'how-decided__wrapper' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'how-decided__title' },
	          'How I decided'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'how-decided__icons' },
	          _react2.default.createElement(
	            'div',
	            { className: 'how-decided__icon-item' },
	            _react2.default.createElement('img', { className: 'how-decided__img', src: _decideBox2.default, width: '40', height: '40', alt: 'box-icon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__num' },
	              res.considered
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__label' },
	              'models considered'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'how-decided__icon-item' },
	            _react2.default.createElement('img', { className: 'how-decided__img', src: _decideClock2.default, width: '40', height: '40', alt: 'clock-icon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__num' },
	              res.hours
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__label' },
	              'hours spend'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'how-decided__icon-item' },
	            _react2.default.createElement('img', { className: 'how-decided__img', src: _decideInterview2.default, width: '40', height: '40', alt: 'interview-icon' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__num' },
	              res.interviewed
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'how-decided__label' },
	              'experts interviewed'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HowDecided;
	}(_react2.default.Component);
	
	exports.default = HowDecided;
	
	
	HowDecided.propTypes = {
	  data: _propTypes2.default.array
	};
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(14);
	
	__webpack_require__(692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageGallery = function (_React$Component) {
	  _inherits(ImageGallery, _React$Component);
	
	  function ImageGallery() {
	    _classCallCheck(this, ImageGallery);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ImageGallery.prototype.render = function render() {
	    var images = this.props.images;
	    if (images.length === 0) {
	      console.warn('no images for product present');
	      return null;
	    }
	    var GALLERY_ID = (0, _utils.uniqueId)();
	    var isWithPreview = images.length > 1;
	    return _react2.default.createElement(
	      'div',
	      { className: 'gallery' },
	      _react2.default.createElement(
	        'div',
	        { className: 'gallery__carousel' },
	        _react2.default.createElement(
	          'amp-carousel',
	          { id: GALLERY_ID,
	            width: '300',
	            height: '200',
	            layout: 'responsive',
	            type: 'slides' },
	          images.map(function (img) {
	            return _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(
	                'amp-img',
	                {
	                  'class': 'gallery__image',
	                  alt: img.image_alt,
	                  width: '375',
	                  height: '300',
	                  layout: 'responsive',
	                  key: img.image_url + '-webp',
	                  src: (0, _utils.getWebpImage)(img.image_url)
	                },
	                _react2.default.createElement('amp-img', {
	                  fallback: '',
	                  'class': 'gallery__image',
	                  key: img.image_url,
	                  src: img.image_url,
	                  width: '375',
	                  height: '300',
	                  layout: 'responsive',
	                  alt: img.image_alt
	                })
	              )
	            );
	          })
	        )
	      ),
	      isWithPreview && _react2.default.createElement(
	        'div',
	        { className: 'carousel-preview' },
	        images.map(function (img, index) {
	          return _react2.default.createElement(
	            'button',
	            {
	              'aria-label': 'next-image',
	              key: img.image_url,
	              on: 'tap:' + GALLERY_ID + '.goToSlide(index=' + index + ')'
	            },
	            _react2.default.createElement('amp-img', {
	              src: img.image_url,
	              width: '60',
	              height: '40',
	              layout: 'responsive',
	              alt: img.image_alt
	            })
	          );
	        })
	      )
	    );
	  };
	
	  return ImageGallery;
	}(_react2.default.Component);
	
	exports.default = ImageGallery;
	
	
	ImageGallery.propTypes = {
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image_url: _propTypes2.default.string,
	    image_alt: _propTypes2.default.string
	  }))
	};
	module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineCard = function InlineCard(_ref) {
	  var slug = _ref.slug,
	      url = _ref.url,
	      image = _ref.image,
	      title = _ref.title,
	      introduction = _ref.introduction;
	
	  return _react2.default.createElement(
	    "a",
	    { className: "i-card", key: slug, href: url, "data-vars-slug": slug },
	    _react2.default.createElement(
	      "div",
	      { className: "i-card__image" },
	      _react2.default.createElement("amp-img", {
	        src: image,
	        width: "160",
	        height: "106",
	        layout: "flex-item",
	        alt: title
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "i-card__content" },
	      _react2.default.createElement(
	        "p",
	        { className: "i-card__title" },
	        title
	      ),
	      introduction && _react2.default.createElement(
	        "p",
	        { className: "i-card__standfirst" },
	        introduction.split(" ").slice(0, 18).join(" "),
	        "..."
	      )
	    )
	  );
	};
	
	InlineCard.propTypes = {
	  title: _propTypes2.default.string,
	  introduction: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  slug: _propTypes2.default.string,
	  url: _propTypes2.default.string
	};
	
	exports.default = InlineCard;
	module.exports = exports["default"];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(56);
	
	var config = _interopRequireWildcard(_config);
	
	var _inlineCard = __webpack_require__(399);
	
	var _inlineCard2 = _interopRequireDefault(_inlineCard);
	
	__webpack_require__(694);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineRelated = function InlineRelated(_ref) {
	  var articles = _ref.articles;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'i-related' },
	    _react2.default.createElement(
	      'aside',
	      { className: 'i-related__wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'i-related__caption' },
	        _react2.default.createElement(
	          'span',
	          { className: 'i-related__caption-text' },
	          'Related reviews'
	        )
	      ),
	      articles.map(function (article, i) {
	        return _react2.default.createElement(_inlineCard2.default, {
	          key: i,
	          title: article.title,
	          introduction: article.introduction,
	          image: article.image,
	          slug: article.slug,
	          url: config.siteUrl + article.slug
	        });
	      })
	    )
	  );
	};
	
	InlineRelated.propTypes = {
	  articles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    introduction: _propTypes2.default.string,
	    image: _propTypes2.default.string,
	    slug: _propTypes2.default.string
	  }))
	};
	
	exports.default = InlineRelated;
	module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _htmlContent = __webpack_require__(103);
	
	var _htmlContent2 = _interopRequireDefault(_htmlContent);
	
	var _amazonLink = __webpack_require__(121);
	
	var _amazonLink2 = _interopRequireDefault(_amazonLink);
	
	var _youtube = __webpack_require__(409);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _prosCons = __webpack_require__(403);
	
	var _prosCons2 = _interopRequireDefault(_prosCons);
	
	var _imageGallery = __webpack_require__(398);
	
	var _imageGallery2 = _interopRequireDefault(_imageGallery);
	
	var _utils = __webpack_require__(14);
	
	var _stars = __webpack_require__(348);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _featured = __webpack_require__(394);
	
	var _featured2 = _interopRequireDefault(_featured);
	
	__webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Product = function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product() {
	    _classCallCheck(this, Product);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Product.prototype.render = function render() {
	    var product = this.props.product;
	    var galleryImages = [{
	      image_url: product.image,
	      image_alt: product.product_name
	    }].concat(product.image_gallery).filter(function (item) {
	      return item;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'product', key: product.product_name },
	      _react2.default.createElement(
	        'div',
	        { className: 'product__title-wrap' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'product__title', id: (0, _utils.titleToId)(product.title) },
	          product.title
	        ),
	        product.featured ? _react2.default.createElement(
	          'span',
	          { className: 'product__featured' },
	          _react2.default.createElement(_featured2.default, { featured: product.featured })
	        ) : null
	      ),
	      product.rating ? _react2.default.createElement(
	        'div',
	        { className: 'product__rating' },
	        _react2.default.createElement(
	          'span',
	          { className: 'product__rating-text' },
	          'Our rating:'
	        ),
	        _react2.default.createElement(_stars2.default, { rating: product.rating, isWithNumber: true })
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'product__gallery' },
	        _react2.default.createElement(_imageGallery2.default, { images: galleryImages })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'product__buy-btn' },
	        _react2.default.createElement(_amazonLink2.default, {
	          isBlack: true,
	          link: product.amazon_link,
	          title: 'View on Amazon',
	          productName: product.product_name
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'product__body' },
	        _react2.default.createElement(_htmlContent2.default, { content: product.body })
	      ),
	      product.youtube ? _react2.default.createElement(_youtube2.default, { videoId: product.youtube }) : null,
	      _react2.default.createElement(_prosCons2.default, { pros: product.prons, cons: product.cons }),
	      _react2.default.createElement('hr', { className: 'product__separator' })
	    );
	  };
	
	  return Product;
	}(_react2.default.Component);
	
	Product.propTypes = {
	  product: _propTypes2.default.object
	};
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _product = __webpack_require__(401);
	
	var _product2 = _interopRequireDefault(_product);
	
	__webpack_require__(697);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductsList = function (_React$Component) {
	  _inherits(ProductsList, _React$Component);
	
	  function ProductsList() {
	    _classCallCheck(this, ProductsList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProductsList.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'product-list' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'product-list__title' },
	        this.props.title
	      ),
	      this.props.products.map(function (product, i) {
	        return _react2.default.createElement(_product2.default, { product: product, key: i });
	      })
	    );
	  };
	
	  return ProductsList;
	}(_react2.default.Component);
	
	ProductsList.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  dataReview: _propTypes2.default.object
	};
	
	exports.default = ProductsList;
	module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prosConsLike = __webpack_require__(723);
	
	var _prosConsLike2 = _interopRequireDefault(_prosConsLike);
	
	var _prosConsDislike = __webpack_require__(722);
	
	var _prosConsDislike2 = _interopRequireDefault(_prosConsDislike);
	
	var _commonStyles = __webpack_require__(105);
	
	__webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProsCons = function (_Component) {
	  _inherits(ProsCons, _Component);
	
	  function ProsCons() {
	    _classCallCheck(this, ProsCons);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProsCons.prototype.render = function render() {
	    var _props = this.props,
	        cons = _props.cons,
	        pros = _props.pros;
	
	    if (!cons && !pros) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pros-cons' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pros-cons__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pros-cons__list pros-cons__list--green' },
	          _react2.default.createElement(
	            'span',
	            { className: 'pros-cons__icon' },
	            _react2.default.createElement('amp-img', { src: _prosConsLike2.default, width: '25', height: '25', layout: 'flex-item', alt: 'like icon' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pros-cons__title' },
	            'Pros'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            pros.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pros-cons__text pros-cons__text--pros' },
	                  item.replace(/;/g, ',')
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pros-cons__list pros-cons__list--red' },
	          _react2.default.createElement(
	            'span',
	            { className: 'pros-cons__icon', style: _commonStyles.overlayStyle },
	            _react2.default.createElement('amp-img', { src: _prosConsDislike2.default, width: '25', height: '25', layout: 'flex-item', alt: 'like icon' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pros-cons__title' },
	            'Cons'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            cons.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pros-cons__text pros-cons__text--cons' },
	                  item.replace(/;/g, ',')
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ProsCons;
	}(_react.Component);
	
	ProsCons.propTypes = {
	  cons: _propTypes2.default.array,
	  pros: _propTypes2.default.array
	};
	
	exports.default = ProsCons;
	module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(14);
	
	__webpack_require__(700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableOfConents = function (_React$Component) {
	  _inherits(TableOfConents, _React$Component);
	
	  function TableOfConents() {
	    _classCallCheck(this, TableOfConents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TableOfConents.prototype.render = function render() {
	    var links = this.props.links.filter(function (link) {
	      return link;
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: 'toc' },
	      _react2.default.createElement(
	        'div',
	        { className: 'toc__wrapper' },
	        _react2.default.createElement('input', { className: 'toc__checkbox', id: 'toc-toggle', type: 'checkbox' }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'toc__title' },
	          'Contents'
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'toc__show', htmlFor: 'toc-toggle' },
	          '[Show]'
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'toc__hide', htmlFor: 'toc-toggle' },
	          '[Hide]'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'toc__list' },
	          links.map(function (navElelemnt, index) {
	            var title = navElelemnt.title,
	                link = navElelemnt.link;
	
	            if (typeof link === 'string') {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#' + (0, _utils.titleToId)(link) },
	                  title
	                )
	              );
	            } else if (Array.isArray(link)) {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#' + (0, _utils.titleToId)(link[0].link) },
	                  title
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'toc__list' },
	                  link.map(function (nested, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '#' + (0, _utils.titleToId)(nested.link) },
	                        nested.title
	                      )
	                    );
	                  })
	                )
	              );
	            } else {
	              return null;
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return TableOfConents;
	}(_react2.default.Component);
	
	exports.default = TableOfConents;
	
	
	TableOfConents.propTypes = {
	  links: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)]))
	};
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(701);
	
	var _amazonLink = __webpack_require__(121);
	
	var _amazonLink2 = _interopRequireDefault(_amazonLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(14);
	
	var _isTouchDevice = __webpack_require__(382);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _stars = __webpack_require__(348);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _classnames = __webpack_require__(58);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getCheckPriceCol = function (product) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'table__cell' },
	        _react2.default.createElement(_amazonLink2.default, {
	          isInsideTable: true,
	          link: product.amazon_link,
	          title: 'Check price',
	          className: 'ga-amazon-link-from-table',
	          productName: product.product_name
	        })
	      );
	    }, _this.generateTableCells = function (tableFeatures) {
	      return tableFeatures.map(function (cell, index) {
	        return _react2.default.createElement(
	          'td',
	          { className: 'table__cell', key: index },
	          cell.feature_value
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Table.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        products = _props.products,
	        tableTitle = _props.tableTitle;
	
	    var tableHeaderData = products && products[0].table_features ? products[0].table_features : [];
	    var firstCellClassName = (0, _classnames2.default)('table__cell-first', {
	      'table__cell-first--mobile': (0, _isTouchDevice2.default)()
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'table__container' },
	      tableTitle ? _react2.default.createElement(
	        'h2',
	        { className: 'table__title', id: (0, _utils.titleToId)(tableTitle) },
	        tableTitle || null
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'table__wrapper' },
	        _react2.default.createElement(
	          'table',
	          { className: 'table' },
	          _react2.default.createElement(
	            'thead',
	            { className: 'table__head' },
	            _react2.default.createElement(
	              'tr',
	              { className: 'table__row' },
	              _react2.default.createElement(
	                'th',
	                { className: 'table__header' },
	                'Name'
	              ),
	              products && products[0].rating ? _react2.default.createElement(
	                'th',
	                { className: 'table__header' },
	                'Our rating'
	              ) : null,
	              tableHeaderData.map(function (title, index) {
	                return _react2.default.createElement(
	                  'th',
	                  { className: 'table__header', key: index },
	                  title.feature_name
	                );
	              }),
	              _react2.default.createElement(
	                'th',
	                { className: 'table__header' },
	                'Shops'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            { className: 'table__body' },
	            products.map(function (product, i) {
	              return _react2.default.createElement(
	                'tr',
	                { className: 'table__row', key: product.product_name },
	                _react2.default.createElement(
	                  'td',
	                  { className: '' + firstCellClassName },
	                  _react2.default.createElement('span', { className: product.featured }),
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      target: '_blank',
	                      className: 'table__product-name',
	                      href: product.amazon_link,
	                      'data-vars-product-name': product.product_name
	                    },
	                    product.product_name
	                  )
	                ),
	                product.rating ? _react2.default.createElement(
	                  'td',
	                  { className: 'table__cell' },
	                  _react2.default.createElement(_stars2.default, { rating: product.rating })
	                ) : null,
	                product.table_features ? _this2.generateTableCells(product.table_features) : null,
	                _this2.getCheckPriceCol(product)
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'table__mobile-info ' + ((0, _isTouchDevice2.default)() ? 'visible' : null) },
	        'swipe left to see more'
	      )
	    );
	  };
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  products: _propTypes2.default.array,
	  tableTitle: _propTypes2.default.string
	};
	
	exports.default = Table;
	module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _amazonLink = __webpack_require__(121);
	
	var _amazonLink2 = _interopRequireDefault(_amazonLink);
	
	var _utils = __webpack_require__(14);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductCard = function ProductCard(props) {
	  var product_name = props.product_name,
	      subtitle = props.subtitle,
	      image = props.image,
	      bottom_line = props.bottom_line,
	      prons = props.prons,
	      amazon_link = props.amazon_link,
	      featured = props.featured;
	
	  var first5pros = prons ? prons.slice(0, 5) : null;
	  return _react2.default.createElement(
	    'section',
	    { className: 'p-card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'p-card__label ' + featured },
	      featured.replace('-', ' ')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'p-card__image-wrap' },
	      _react2.default.createElement(
	        'amp-img',
	        { 'class': 'p-card__image', src: (0, _utils.getWebpImage)(image), width: '240', height: '166', alt: product_name },
	        _react2.default.createElement('amp-img', { fallback: '', 'class': 'p-card__image', src: image, width: '240', height: '166', alt: product_name })
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'p-card__title' },
	      product_name
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'p-card__subtitle' },
	      subtitle
	    ),
	    bottom_line ? _react2.default.createElement(
	      'p',
	      { className: 'p-card__bottom-line' },
	      bottom_line
	    ) : first5pros ? _react2.default.createElement(
	      'ul',
	      { className: 'p-card__pros-list' },
	      first5pros.map(function (pron) {
	        return _react2.default.createElement(
	          'li',
	          { key: pron, className: 'p-card__pros-item' },
	          pron.replace(/;/g, ',')
	        );
	      })
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'p-card__buy-link' },
	      _react2.default.createElement(_amazonLink2.default, { link: amazon_link, title: 'View on Amazon', isBlack: true, productName: product_name })
	    )
	  );
	};
	
	ProductCard.propTypes = {
	  product_name: _propTypes2.default.any.isRequired,
	  subtitle: _propTypes2.default.any,
	  image: _propTypes2.default.any.isRequired,
	  bottom_line: _propTypes2.default.any,
	  prons: _propTypes2.default.any,
	  amazon_link: _propTypes2.default.any.isRequired,
	  featured: _propTypes2.default.any.isRequired
	};
	
	exports.default = ProductCard;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _productCard = __webpack_require__(406);
	
	var _productCard2 = _interopRequireDefault(_productCard);
	
	__webpack_require__(703);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GALLERY_ID = "RECOMMENDED_GALLERY";
	
	var WeRecommended = function (_React$Component) {
	  _inherits(WeRecommended, _React$Component);
	
	  function WeRecommended() {
	    _classCallCheck(this, WeRecommended);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WeRecommended.prototype.render = function render() {
	    var recommended = this.props.recommended;
	    return _react2.default.createElement(
	      'div',
	      { className: 'we-rec' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'we-rec__title' },
	        'I recommend:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'we-rec__wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'we-rec__item-list' },
	          _react2.default.createElement(
	            'amp-carousel',
	            { id: GALLERY_ID,
	              height: '500',
	              layout: 'fixed-height',
	              type: 'carousel' },
	            recommended.map(function (product) {
	              return _react2.default.createElement(
	                'div',
	                { key: product.product_name, className: 'we-rec__item' },
	                _react2.default.createElement(_productCard2.default, product)
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return WeRecommended;
	}(_react2.default.Component);
	
	exports.default = WeRecommended;
	
	
	WeRecommended.propTypes = {
	  recommended: _propTypes2.default.any.isRequired
	};
	module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhyTrust = function (_React$Component) {
	  _inherits(WhyTrust, _React$Component);
	
	  function WhyTrust() {
	    _classCallCheck(this, WhyTrust);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WhyTrust.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'why-trust' },
	      _react2.default.createElement(
	        'div',
	        { className: 'why-trust__wrapper' },
	        _react2.default.createElement(
	          'span',
	          { className: 'why-trust__text why-trust__text--bold' },
	          'Why you can trust me?'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'why-trust__text' },
	          'I accept nothing from product manufacturers. Never. Here \u2014\xA0only unbiased reviews and my opinion. I only earn commission from Amazon'
	        )
	      )
	    );
	  };
	
	  return WhyTrust;
	}(_react2.default.Component);
	
	exports.default = WhyTrust;
	module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isTouchDevice = __webpack_require__(382);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	__webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Youtube = function Youtube(_ref) {
	  var videoId = _ref.videoId,
	      width = _ref.width,
	      height = _ref.height;
	
	  var videoWidth = (0, _isTouchDevice2.default)() ? 320 : width | 580;
	  return _react2.default.createElement(
	    'div',
	    { className: 'youtube' },
	    _react2.default.createElement(
	      'div',
	      { className: 'youtube__wrapper' },
	      _react2.default.createElement('amp-youtube', {
	        width: videoWidth,
	        height: height | 270,
	        layout: 'fixed',
	        'data-videoid': videoId })
	    )
	  );
	};
	
	Youtube.propTypes = {
	  videoId: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	exports.default = Youtube;
	module.exports = exports['default'];

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.ReviewPage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(23);
	
	var _jumbotron = __webpack_require__(104);
	
	var _jumbotron2 = _interopRequireDefault(_jumbotron);
	
	var _tableOfContents = __webpack_require__(404);
	
	var _tableOfContents2 = _interopRequireDefault(_tableOfContents);
	
	var _productsList = __webpack_require__(402);
	
	var _productsList2 = _interopRequireDefault(_productsList);
	
	var _reviewContent = __webpack_require__(125);
	
	var _reviewContent2 = _interopRequireDefault(_reviewContent);
	
	var _layout = __webpack_require__(22);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _table = __webpack_require__(405);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _seoTags = __webpack_require__(27);
	
	var _seoTags2 = _interopRequireDefault(_seoTags);
	
	var _structuredData = __webpack_require__(28);
	
	var _structuredData2 = _interopRequireDefault(_structuredData);
	
	var _breadcrumbs = __webpack_require__(45);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _socialShare = __webpack_require__(126);
	
	var _socialShare2 = _interopRequireDefault(_socialShare);
	
	var _howDecided = __webpack_require__(397);
	
	var _howDecided2 = _interopRequireDefault(_howDecided);
	
	var _whyTrust = __webpack_require__(408);
	
	var _whyTrust2 = _interopRequireDefault(_whyTrust);
	
	var _inlineRelated = __webpack_require__(400);
	
	var _inlineRelated2 = _interopRequireDefault(_inlineRelated);
	
	var _weRecommended = __webpack_require__(407);
	
	var _weRecommended2 = _interopRequireDefault(_weRecommended);
	
	var _author = __webpack_require__(122);
	
	var _author2 = _interopRequireDefault(_author);
	
	var _utils = __webpack_require__(14);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONCLUSION = 'Conclusion';
	var BUYERS_GUIDE = 'Buyers guide';
	var COMPARISON_TABLE = 'Comparison Table';
	
	var ReviewPage = exports.ReviewPage = function ReviewPage(props) {
	  var _props$data$markdownR = props.data.markdownRemark.frontmatter,
	      title = _props$data$markdownR.title,
	      short_title = _props$data$markdownR.short_title,
	      introduction = _props$data$markdownR.introduction,
	      introduction_2 = _props$data$markdownR.introduction_2,
	      image = _props$data$markdownR.image,
	      conclusion = _props$data$markdownR.conclusion,
	      buyers_guide_1 = _props$data$markdownR.buyers_guide_1,
	      buyers_guide_2 = _props$data$markdownR.buyers_guide_2,
	      faq = _props$data$markdownR.faq,
	      products = _props$data$markdownR.products,
	      extra = _props$data$markdownR.extra,
	      created = _props$data$markdownR.created,
	      updated = _props$data$markdownR.updated,
	      seo = _props$data$markdownR.seo,
	      related_reviews = _props$data$markdownR.related_reviews;
	
	
	  var smallImages = props.data.allImageSharp.edges;
	
	  var currentPath = props.location.pathname;
	  var slug = props.data.markdownRemark.fields.slug;
	
	  var updatedTitle = utils.updateYearToCurrent(title);
	
	  var buyersGuideTitle = null;
	  var faqTitle = null;
	
	  //  === TOC ===
	  var tableOfContent = [{ title: COMPARISON_TABLE, link: extra.tableTitle }, {
	    title: 'Products',
	    link: [].concat(products.map(function (p, i) {
	      return {
	        title: p.featured ? p.featured.toUpperCase() + ': ' + p.product_name : '' + p.product_name,
	        link: p.title
	      };
	    }))
	  }];
	
	  if (buyers_guide_2 && buyers_guide_2.content) {
	    buyersGuideTitle = short_title + ' Buying Guide';
	    if (faq) buyersGuideTitle = buyersGuideTitle + ' & FAQ';
	    tableOfContent.push({ title: BUYERS_GUIDE, link: buyersGuideTitle });
	  }
	  if (faq) {
	    faqTitle = short_title + " FAQ";
	    tableOfContent.push({ title: "FAQ", link: faqTitle });
	  }
	  tableOfContent.push({ title: CONCLUSION, link: CONCLUSION });
	  //  === TOC END ===
	
	  //  === RELATED ===
	  var relatedArticles = [];
	  if (related_reviews && related_reviews.length) {
	    relatedArticles = related_reviews.filter(function (item) {
	      return item;
	    }).map(function (r) {
	      return _extends(r.frontmatter, {
	        slug: r.fields.slug,
	        image: utils.findResizedImage(r.frontmatter.image, smallImages)
	      });
	    });
	  }
	  //  === RELATED END ===
	
	  var recommended = products.filter(function (prod) {
	    return prod.featured;
	  });
	
	  return _react2.default.createElement(
	    _layout2.default,
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_seoTags2.default, {
	        title: '' + utils.updateYearToCurrent(seo.title),
	        description: '' + utils.updateYearToCurrent(seo.description),
	        image: image,
	        image_alt: updatedTitle,
	        link: [{ rel: 'amphtml', href: '/amp' + slug }],
	        created: created,
	        updated: updated,
	        isReview: true,
	        pagePath: currentPath,
	        author: seo.author
	      }),
	      _react2.default.createElement(_structuredData2.default, {
	        title: updatedTitle,
	        image: image,
	        created: created,
	        updated: updated,
	        isReview: true,
	        pagePath: currentPath,
	        isBreadcrumbs: true,
	        products: products,
	        introduction: introduction
	      }),
	      _react2.default.createElement(_jumbotron2.default, {
	        title: updatedTitle,
	        image: image,
	        alt: updatedTitle,
	        isForReview: true
	      }),
	      _react2.default.createElement(_breadcrumbs2.default, { currentPageTitle: short_title }),
	      _react2.default.createElement(_author2.default, { name: seo.author, created: created, updated: updated }),
	      _react2.default.createElement(_reviewContent2.default, { content: introduction, isWide: true }),
	      _react2.default.createElement(_whyTrust2.default, null),
	      extra.isWithRecommended ? _react2.default.createElement(_weRecommended2.default, { recommended: recommended }) : null,
	      introduction_2 && _react2.default.createElement(_reviewContent2.default, { content: introduction_2 }),
	      _react2.default.createElement(_tableOfContents2.default, { links: tableOfContent }),
	      relatedArticles.length !== 0 ? _react2.default.createElement(_inlineRelated2.default, { articles: relatedArticles }) : null,
	      buyers_guide_1 && _react2.default.createElement(_reviewContent2.default, { content: buyers_guide_1 }),
	      extra.isWithTable ? _react2.default.createElement(_table2.default, { tableTitle: extra.tableTitle, products: products }) : null,
	      extra.how_decided ? _react2.default.createElement(_howDecided2.default, { data: extra.how_decided }) : null,
	      _react2.default.createElement(_productsList2.default, { title: short_title, products: products }),
	      buyers_guide_2 && _react2.default.createElement(_reviewContent2.default, { content: buyers_guide_2.intro, title: buyersGuideTitle }),
	      buyers_guide_2 && buyers_guide_2.content && buyers_guide_2.content.map(function (_ref, i) {
	        var body = _ref.body,
	            title = _ref.title;
	        return _react2.default.createElement(_reviewContent2.default, { key: i, content: body, title: title });
	      }),
	      faq && _react2.default.createElement(_reviewContent2.default, { title: faqTitle }),
	      faq && faq.map(function (_ref2, i) {
	        var body = _ref2.body,
	            title = _ref2.title;
	        return _react2.default.createElement(_reviewContent2.default, { key: i, content: body, title: "Q: " + title, headingLevel: 'h3' });
	      }),
	      _react2.default.createElement(_reviewContent2.default, { content: conclusion, title: CONCLUSION }),
	      _react2.default.createElement(_socialShare2.default, { image: image, title: updatedTitle, pagePath: currentPath })
	    )
	  );
	};
	
	ReviewPage.propTypes = {
	  data: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouterDom.withRouter)(ReviewPage);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 687 */,
/* 688 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 695 */,
/* 696 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDM3Mi45NiAzNzIuOTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM3Mi45NiAzNzIuOTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMTg2LjQ4LDBDODMuNDksMCwwLDgzLjQ5LDAsMTg2LjQ4czgzLjQ5LDE4Ni40OCwxODYuNDgsMTg2LjQ4czE4Ni40OC04My40OSwxODYuNDgtMTg2LjQ4CgkJCUMzNzIuODI4LDgzLjU0NSwyODkuNDE1LDAuMTMyLDE4Ni40OCwweiBNMTk0LjQ4LDM1Ni41NnYtMzIuOGMwLTQuNDE4LTMuNTgyLTgtOC04cy04LDMuNTgyLTgsOHYzMi44CgkJCUM5MC43NTksMzUyLjM3MiwyMC41ODgsMjgyLjIwMSwxNi40LDE5NC40OGgzMi44YzQuNDE4LDAsOC0zLjU4Miw4LThzLTMuNTgyLTgtOC04SDE2LjRDMjAuNTg4LDkwLjc1OSw5MC43NTksMjAuNTg4LDE3OC40OCwxNi40CgkJCXYzMi44YzAsNC40MTgsMy41ODIsOCw4LDhzOC0zLjU4Miw4LThWMTYuNGM4Ny43MjEsNC4xODgsMTU3Ljg5Miw3NC4zNTksMTYyLjA4LDE2Mi4wOGgtMzIuOGMtNC40MTgsMC04LDMuNTgyLTgsOHMzLjU4Miw4LDgsOAoJCQloMC4wOGgzMi44QzM1Mi40NDksMjgyLjIzLDI4Mi4yMzIsMzUyLjQxMiwxOTQuNDgsMzU2LjU2eiIvPgoJPC9nPgo8L2c+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTI3MC44OCwyNjAuODhsLTc2LjQtNzcuNjh2LTgwLjcyYzAtNC40MTgtMy41ODItOC04LThzLTgsMy41ODItOCw4djg0YzAuMDA5LDIuMDk5LDAuODQyLDQuMTEsMi4zMiw1LjZsNzguNjQsODAKCQkJYzMuMDkzLDMuMTU5LDguMTYxLDMuMjEzLDExLjMyLDAuMTJDMjczLjkxOSwyNjkuMTA3LDI3My45NzMsMjY0LjAzOSwyNzAuODgsMjYwLjg4eiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MCA1MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8cGF0aCBkPSJNNy40MDIsMzIuNDcxYy0zLjM1My0zLjAzOC01Ljg0LTcuMDIxLTYuODk4LTExLjUwM2MtMC43NzctMy4yOTEtMC40MjQtNS4xMTktMC40MjQtNS4xMTkgIEMwLjczNCw4LjQ4NSw1LjkzNiwyLjMwNiwxMy4xNTksMi4zMDZjNC41MSwwLDguMjcxLDIuMzY5LDEwLjU1NSw1Ljk2NmwtMC4wMi0wLjAxM0wxNi4yNiwxOS4xNmwxNC40ODcsMS45MzJMMTkuMzU1LDMxLjUzNSAgbDguNDQ3LDUuMjc5bC0zLjYyNiwxMC44NzlMNy40MDIsMzIuNDcxeiBNNDkuNDk2LDIwLjk3Yy0xLjA1OCw0LjQ4Mi0zLjU0NSw4LjQ2NC02Ljg5OCwxMS41MDJMMjYuNiw0Ni43NDVsMy41OTctMTAuNzkyICBsLTcuNTUzLTQuNzIxbDEyLjYwOC0xMS41NTdMMTkuNzQsMTcuNjA4bDUuMzYyLTcuODY0YzAuMDUxLTAuMDM3LDAuMS0wLjA3OSwwLjEzMi0wLjE0M2MyLjE4MS00LjMzNCw2LjU2LTcuMjk0LDExLjYwNi03LjI5NCAgYzcuMjIzLDAsMTIuNDI1LDYuMTc5LDEzLjA3OSwxMy41NDNDNDkuOTIsMTUuODUsNTAuMjczLDE3LjY3OSw0OS40OTYsMjAuOTd6IiBmaWxsPSIjRkZGRkZGIi8+Cjwvc3ZnPgo="

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDUzLjg2NyA1My44NjciIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUzLjg2NyA1My44Njc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0VGQ0U0QTsiIHBvaW50cz0iMjYuOTM0LDEuMzE4IDM1LjI1NiwxOC4xODIgNTMuODY3LDIwLjg4NyA0MC40LDM0LjAxMyA0My41NzksNTIuNTQ5IDI2LjkzNCw0My43OTggCgkxMC4yODgsNTIuNTQ5IDEzLjQ2NywzNC4wMTMgMCwyMC44ODcgMTguNjExLDE4LjE4MiAiLz4KPC9zdmc+Cg=="

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgd2lkdGg9IjUxMHB4IiBoZWlnaHQ9IjUxMHB4IiB2aWV3Qm94PSIwIDAgNTEwIDUxMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEwIDUxMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJzdGFyLW91dGxpbmUiPgoJCTxwYXRoIGQ9Ik01MTAsMTk3LjQ3MmwtMTgzLjM3LTE1LjczNEwyNTUsMTIuNzVsLTcxLjYyOSwxNjguOTg4TDAsMTk3LjQ3MmwxMzkuMTAzLDEyMC41MzlMOTcuNDEsNDk3LjI1TDI1NSw0MDIuMTg2CgkJCWwxNTcuNTksOTUuMDY0bC00MS42OTItMTc5LjIzOUw1MTAsMTk3LjQ3MnogTTI1NSwzNTQuMzQ4bC05NS45NTcsNTcuODg2bDI1LjM5OC0xMDkuMTY2bC04NC43MzYtNzMuMzg5bDExMS42OS05LjU4OAoJCQlMMjU1LDExNy4xNzJsNDMuNjA1LDEwMi45MThsMTExLjY4OSw5LjU4OGwtODQuNzExLDczLjM4OWwyNS4zOTgsMTA5LjE2NkwyNTUsMzU0LjM0OHoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ })
]);


// WEBPACK FOOTER //
// component---src-templates-review-page-js-5314a1776bb670d4b0c6.js